<template>
  <modal name="permit-customer" :classes="'customModal'" :scrollable="true" :reset="true" :adaptive="false" :width="1300"
    height="auto" @before-open="getData" @closed="showCustomerDetails = false">
    <div class="modalWrapper">
      <div class="row" v-if="!showCustomerDetails && !showPendingCustomerDetails && !showSendPermitMemo && !directDetailLoading">
        <!-- APPROVED PERMIT CUSTOMER LIST -->
        <div class="col-md-12">
          <div class="content__box h-100">
            <div class="content__box__header pb-2">
              <div class="top__filter align-items-center">
                <ul class="top__filter__ul">
                  <li>Permit Customers</li>
                </ul>
                <ul class="top__filter__ul search_form_control">
                  <li>
                    <input type="text" v-model="search" placeholder="Search..." aria-label="Search"
                      class="form-control form-control-sm" />
                  </li>
                </ul>
                <ul class="top__filter__ul position-relative">
                  <li @click.stop="showFilterOptions = true">
                    Filter
                  </li>
                </ul>
                <div v-click-outside="closeDropdown" class="sessionsFilter" v-if="showFilterOptions">
                  <div class="d-flex">
                    <div class="sessionsFilter__left">
                      <p :class="['sessionsFilter__text mb-3 ml-3', this.approved_application_type == '' ? 'active' : '']" @click="approvedApplications('', {}, 1)">
                        Active
                      </p>
                      <p :class="['sessionsFilter__text mb-3 ml-3', this.approved_application_type == 'pending' ? 'active' : '']" @click="approvedApplications('pending', {}, 1)">
                        Pending
                      </p>
                      <p :class="['sessionsFilter__text mb-3 ml-3', this.approved_application_type == 'expired' ? 'active' : '']" @click="approvedApplications('expired', {}, 1)">
                        Expired
                      </p>
                      <div v-if="getShouldShowPermitRenewalFilters()">
                        <p class="txt--xs txt--off-white mb-3">
                            Renewals
                        </p>
                        <p :class="['sessionsFilter__text mb-3 ml-3', this.approved_application_filters['memo_type'] == 'renewal' && !this.approved_application_filters['memo_filters'] ? 'active' : '']" @click="approvedApplications('memo', { memo_type: 'renewal' }, 1)">
                            All
                        </p>
                        <p :class="['sessionsFilter__text mb-3 ml-3', this.approved_application_filters['memo_type'] == 'renewal' && this.approved_application_filters['memo_filters'] == 'cancels' ? 'active' : '']" @click="approvedApplications('memo', { memo_type: 'renewal', memo_filters: 'cancels' }, 1)">
                            Cancel
                        </p>
                        <p :class="['sessionsFilter__text mb-3 ml-3', this.approved_application_filters['memo_type'] == 'renewal' && this.approved_application_filters['memo_filters'] == 'renews' ? 'active' : '']" @click="approvedApplications('memo', { memo_type: 'renewal', memo_filters: 'renews' }, 1)">
                            Renew
                        </p>
                        <p :class="['sessionsFilter__text mb-3 ml-3', this.approved_application_filters['memo_type'] == 'renewal' && this.approved_application_filters['memo_filters'] == 'ready' ? 'active' : '']" @click="approvedApplications('memo', { memo_type: 'renewal', memo_filters: 'ready' }, 1)">
                            Ready
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <ul class="top__filter__ul position-relative">
                  <!-- <li  @click="exportPermitCustomers">Export</li> -->
                  <li @click.stop="showExportOptions = true">
                    Export
                  </li>
                </ul>
                <div v-click-outside="closeDropdown" class="sessionsFilter" v-if="showExportOptions">
                  <div class="d-flex">
                    <div class="sessionsFilter__left">
                      <p class="sessionsFilter__text mb-3" @click="exportPermitCustomers(1)">
                        Export All Subscriptions
                      </p>
                      <p class="sessionsFilter__text mb-3" @click="exportPermitCustomers(2)">
                        Export Active Subscriptions
                      </p>
                      <p class="sessionsFilter__text mb-3" @click="exportPermitCustomers(3)">
                        Export Pending Subscriptions
                      </p>

                    </div>
                  </div>
                </div>
                <ul v-if="user_role == 'commercial' || (user_role == 'operator' && access_list.permit_access_write == true)" class="top__filter__ul">
                  <li :class="['d-flex align-items-center', topFilter == 2 ? 'active' : '']" style="height: 32px" @click="changeTopFilter(2)">
                    Send Permit
                  </li>
                </ul>
                <ul v-if="user_role == 'commercial' || (user_role == 'operator' && access_list.permit_access_write == true)" class="top__filter__ul">
                  <li :class="['d-flex align-items-center', topFilter == 3 ? 'active' : '']" style="height: 32px" @click="changeTopFilter(3)">
                    Upload CSV
                  </li>
                </ul>
              </div>
            </div>
            <div class="content__divider"></div>
            <div v-if="topFilter == 1" class="content__box__body">
              <div class="table-responsive approved__permits">
                <table class="table table__audit table-borderless">
                  <thead>
                    <tr>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Vehicle</th>
                      <th>Permit Name</th>
                      <th>Status</th>
                      <th v-if="showPermitRenewalResponses">Renewal Response</th>
                      <th>Subscription End Date</th>
                      <th>Custom Subscription End Date</th>
                      <th v-for="(identifier_key, i) in approved_custom_identifiers_keys" :key="i">{{ identifier_key }}</th>
                    </tr>
                  </thead>
                  <tbody v-if="approved_applications.length > 0">
                    <tr v-for="(approved, index) in approved_applications" :key="index">
                      <td>
                        <p class="txt--ss cursor-pointer" @click="showApprovedSubscriptionDetails(approved)">
                          {{ approved.first_name }}
                        </p>
                      </td>
                      <td>
                        <p class="txt--ss cursor-pointer" @click="showApprovedSubscriptionDetails(approved)">
                          {{ approved.last_name }}
                        </p>
                      </td>
                      <td>
                        <p class="txt--ss cursor-pointer" @click="showApprovedSubscriptionDetails(approved)">
                          {{ approved.vehicle.license_no != "" ? approved.vehicle.license_no : ("####" + approved.vehicle.vin_id.substring(approved.vehicle.vin_id.length - 8)) | capitalize }}
                          {{ approved.vehicle.license_no != "" && approved.vehicle.country_code != "" && approved.vehicle.country_code != undefined ? approved.vehicle.state != "" ? " (" + approved.vehicle.country_code + "-" + approved.vehicle.state + ")" : " (" + approved.vehicle.country_code + ")" : "" }}
                        </p>
                      </td>
                      <td>
                        <p class="txt--ss cursor-pointer" @click="showApprovedSubscriptionDetails(approved)">
                          {{ approved.permit_name }}
                        </p>
                      </td>
                      <td>
                        <p class="txt--ss cursor-pointer" @click="showApprovedSubscriptionDetails(approved)">
                          {{ approved.status == "approved" ? "Active" : approved.status == 'waiting_list' ? "Waiting List" : approved.status == "expired" ? "Expired" : "Pending" }}
                          {{ approved.status == 'authorized' && approved.payment_failed_reason.length != '' ? '(' + formatSubscriptionFailedReason(approved.payment_failed_reason) + ')' : '' }}
                        </p>
                      </td>
                      <td v-if="showPermitRenewalResponses">
                        <p class="txt--ss cursor-pointer" @click="showApprovedSubscriptionDetails(approved)">
                          {{ getPermitRenewalLatestChoice(approved) }}
                        </p>
                        <p class="txt--ss txt--primary cursor-pointer" v-if="getPermitRenewalLatestUserChoice(approved)['reason']">
                          <i class="far fa-question-circle" v-tooltip="getPermitRenewalLatestUserChoice(approved)['reason']"></i>
                        </p>
                      </td>
                      <td>
                        <p class="txt-ss cursor-pointer" @click="showApprovedSubscriptionDetails(approved)">
                          {{ approved.subscription_end | formatDateTime }}
                        </p>
                      </td>
                      <td>
                        <p class="txt-ss cursor-pointer" @click="showApprovedSubscriptionDetails(approved)">
                          {{ approved.custom_cancel_date_new | formatDateTime }}
                        </p>
                      </td>
                      <td v-for="(identifier_key, i) in approved_custom_identifiers_keys" :key="i">
                        <p class="txt--ss cursor-pointer" @click="showApprovedSubscriptionDetails(approved)">
                          {{ findIdentifierValue(approved, identifier_key) }}
                        </p>
                      </td>
                      <td v-if="approved.status == 'authorized'">
                        <span class="txt--primary" @click="resendPermitNotification(approved.application_id)">Resend</span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td :colspan="6 + approved_custom_identifiers_keys.length">
                        <div v-if="
                          approved_applications.length == 0 &&
                          approved_application_loader
                        " class="
                            d-flex
                            justify-content-center
                            reports__details--body
                            m-customer--min-height
                          ">
                          <div class="lds-ring">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                        </div>
                        <div v-else>
                          <p class="d-flex justify-content-center align-items-center">
                            No Data Found
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <infinite-loading @infinite="approvedPaginate" :distance="10" v-if="
                  approved_applications.length > 0 &&
                  approved_application_load_more
                ">
                  <div slot="spinner">
                    <div class="d-flex justify-content-center mt-4">
                      <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                  <div slot="no-more"></div>
                  <div slot="no-results">No data found</div>
                </infinite-loading>
              </div>
            </div>
            <!-- SEND APPLICATION -->
            <div class="content__box__body pt-0" v-if="topFilter == 2">
              <form class="col-md-6 mx-auto">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form__group">
                      <label class="txt--xs txt--off-white mb-2">Permit (required)</label>
                      <model-list-select v-if="permit_list.length > 0" :list="permit_list" v-model="form.permit_id"
                        option-value="permit_id" option-text="permit_name" placeholder="Select Permit"
                        class="custom-vue-select">
                      </model-list-select>
                    </div>
                  </div>
                  <!-- First Name -->
                  <div class="col-sm-6" v-if="showForm || form.pied_managed">
                    <div class="form__group mb-3 mt-3">
                      <label class="txt--xs txt--off-white">First Name</label>
                      <input type="text" placeholder="Enter first name" v-model="form.first_name"
                        class="textInputField" />
                    </div>
                  </div>
                  <!-- Last Name -->
                  <div class="col-sm-6" v-if="showForm || form.pied_managed">
                    <div class="form__group mt-3 mb-3">
                      <label class="txt--xs txt--off-white">Last Name</label>
                      <input type="text" placeholder="Enter last name" v-model="form.last_name"
                        class="textInputField" />
                    </div>
                  </div>
                  <!-- Pied Managed Toggle -->
                  <div class="col-sm-12">
                    <div class="form-group mt-2">
                      <app-toggle :checked="form.pied_managed" :key="'pied-managed-' + toggleComponentKey"
                        :label="'Pied Managed Account'" @update:checked="form.pied_managed = $event">
                      </app-toggle>
                    </div>
                  </div>
                  <!-- Existing User Checkbox -->
                  <div class="col-sm-12" v-if="!form.pied_managed">
                    <div class="form-group mt-2">
                      <app-toggle :checked="form.existing_customer" :key="toggleComponentKey"
                        :label="'Existing Customer'" @update:checked="checkUncheckExistingCustomer($event)">
                      </app-toggle>
                    </div>
                  </div>
                  <!-- Email -->
                  <div class="col-sm-12">
                    <div class="form__group mb-3">
                      <label class="txt--xs txt--off-white">Email
                        <span v-if="form.pied_managed" class="txt--primary txt--xs ml-2">(Auto-generated)</span>
                      </label>
                      <label class="txt--xs txt--primary cursor-pointer float-right" v-if="!showForm && !form.pied_managed"
                        @click="checkVehicleCardStatus">Check</label>
                      <input 
                        type="text" 
                        placeholder="Enter user's email address" 
                        v-model="form.email"
                        :readonly="form.pied_managed"
                        :class="{ 'textInputField--locked': form.pied_managed }"
                        class="textInputField" 
                      />
                      <label class="txt--xs" :class="styleClassStatus == false ? 'txt--red' : 'txt--green'">{{ check_msg
                      }}</label>

                    </div>
                  </div>
                  <!-- Vehicle Details Section -->
                  <div class="col-sm-12 mb-3">
                    <div class="row" v-for="(vehicle, index) in form.vehicles" :key="'vehicle-' + index">
                      <div class="col-sm-3">
                        <div class="form__group mb-3">
                          <label class="txt--xs txt--off-white">Country</label>
                          <model-list-select
                            :list="country_list"
                            v-model="vehicle.country_code"
                            option-value="country_code"
                            option-text="country_name"
                            placeholder="Select Country"
                            class="custom-vue-select"
                            @input="onVehicleCountryChange(index, $event)">
                          </model-list-select>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="form__group mb-3">
                          <label class="txt--xs txt--off-white">State</label>
                          <model-list-select
                            :list="vehicle.state_list || []"
                            v-model="vehicle.state"
                            option-value="short_code"
                            option-text="full_name"
                            placeholder="Select State"
                            class="custom-vue-select">
                          </model-list-select>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form__group mb-3">
                          <label class="txt--xs txt--off-white">License Plate</label>
                          <input type="text" placeholder="Enter license plate number" 
                                 v-model="vehicle.license_plate" 
                                 class="textInputField" 
                                 maxlength="20" />
                        </div>
                      </div>
                      <div class="col-sm-2 d-flex align-items-center">
                        <div class="mt-2">
                          <button type="button" class="btn btn-sm text-danger" @click="removeVehicle(index)">
                            <i class="fas fa-minus"></i>
                          </button>
                          <button type="button" class="btn btn-sm text-success"
                            v-if="index == (form.vehicles.length - 1)" @click="addVehicle()">
                            <i class="fas fa-plus"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="form.vehicles.length == 0">
                      <div class="col-sm-12">
                        <a href="javascript:void(0);" class="txt--primary txt--ss mb-1"
                          @click="addVehicle()">Add Vehicle Details</a>
                      </div>
                    </div>
                  </div>
                  <!-- Allow Vehicle Section -->
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label class="txt--xs txt--off-white mb-2 mr-2">Allow Vehicles</label>
                      <ul class="top__filter__ul top__filter__ul--btn">
                        <li :class="{ active: allow_all_vehicle }" @click="setVehicleAllow(true)">
                          Allow All
                        </li>
                        <li :class="{ active: !allow_all_vehicle }" @click="setVehicleAllow(false)">
                          Allow Selected
                        </li>
                      </ul>
                      <div v-if="!allow_all_vehicle">
                        <label class="txt--xs txt--off-white">Select Number of Vehicles</label>
                        <input type="text" placeholder="Enter Number of Vehicles To Be Allowed"
                          v-model.number="form.vehicle_count" @keypress="checkNumber" class="textInputField" />
                      </div>
                    </div>
                  </div>
                  <!-- Backdate Subscription Section @close="validateDate()"-->
                  <div class="col-sm-12 mb-2" v-if="showBackDate" :class="{ 'backdate-toggle--locked': isBackdateSubscriptionLocked }">
                    <app-toggle :checked="form.backdate_subscription" :key="toggleBackdateComponentKey"
                      :label="'Backdate Subscription'" :disabled="isBackdateSubscriptionLocked" @update:checked="backdateSubscription($event)">
                    </app-toggle>
                  </div>
                  <div class="col-sm-12 mb-2" v-if="showBackDate && form.backdate_subscription && isBackdateSubscriptionLocked">
                    <p class="txt--xs txt--off-white opacity--50 mb-0">
                      <i class="far fa-info-circle mr-1"></i>
                      Backdate will be automatically derived from the permit's configured template.
                    </p>
                  </div>
                  <div class="col-sm-12 mb-2" v-if="showBackDate && form.backdate_subscription && !isBackdateSubscriptionLocked">
                    <label for="" class="txt--xs txt--off-white">Select Backdate</label>
                    <datetime title="BackDate" input-id="back_date" class="dateTime__picker" format="yyyy-MM-dd hh:mm a"
                      :input-class="['textInputField']" :max-datetime="maxDatetime" :min-datetime="minDatetime"
                      type="datetime" :zone="property_timezone" :value-zone="property_timezone"
                      v-tooltip="property_timezone" v-model="form.backdate_start_date" :clear-button="true">
                    </datetime>
                  </div>
                  <!-- Custom End Date Subscription Section @close="validateDate()"-->
                  <div class="col-sm-12 mb-2" v-if="showBackDate">
                    <app-toggle :checked="form.custom_enddate_subscription" :key="toggleCustomEndDateComponentKey"
                      :label="'Custom End Date of Subscription'" @update:checked="customEndDateSubscription($event)">
                    </app-toggle>
                  </div>
                  <div class="col-sm-12 mb-2" v-if="showBackDate && form.custom_enddate_subscription">
                    <label for="" class="txt--xs txt--off-white">Select Custom End Date</label>
                    <datetime title="CustomEndDate" input-id="custom_end_date" class="dateTime__picker"
                      format="yyyy-MM-dd hh:mm a" :input-class="['textInputField']" :max-datetime="maxCustomEndDatetime"
                      :min-datetime="minCustomEndDatetime" type="datetime" :zone="property_timezone" :value-zone="property_timezone"
                      v-tooltip="property_timezone" v-model="form.custom_end_date" :clear-button="true"></datetime>
                  </div>
                  <!-- Custom Identifier Section -->
                  <div class="col-sm-12 mb-3">
                    <div class="row" v-for="(identifier, index) in form.custom_identifiers" :key="index">
                      <div class="col-sm-5">
                        <div class="form__group mb-3">
                          <label class="txt--xs txt--off-white d-flex align-items-center">
                            <span>Custom Identifier Name</span>
                            <span v-if="isRequiredCustomIdentifier(identifier)" class="required-identifier-badge ml-2">Required</span>
                          </label>
                          <input
                            v-if="isRequiredCustomIdentifier(identifier)"
                            :value="identifier.identifier_key"
                            type="text"
                            class="textInputField textInputField--locked"
                            readonly
                            title="This identifier is required by the selected permit and cannot be changed"
                          />
                          <ModelListSelect
                            v-else
                            v-model="identifier.identifier_key"
                            :list="getCustomIdentifierKeyList(index)"
                            option-value="value"
                            option-text="text"
                            :placeholder="'Enter or select identifier name'"
                            :is-error="false"
                            :allow-new="true"
                            class="custom-vue-select"
                            :ref="'customIdentifierKeySelect_' + index"
                            @input="onCustomIdentifierKeyChange(index, $event)"
                            @searchchange="onCustomIdentifierKeySearchChange(index, $event)"
                          />
                        </div>
                      </div>
                      <div class="col-sm-5">
                        <div class="form__group mb-3">
                          <label class="txt--xs txt--off-white">Custom Identifier Value</label>
                          <ModelListSelect
                            v-model="identifier.identifier_value"
                            :list="getCustomIdentifierValueList(index, identifier.identifier_key)"
                            option-value="value"
                            option-text="text"
                            :placeholder="'Enter or select identifier value'"
                            :is-error="false"
                            :allow-new="true"
                            class="custom-vue-select"
                            :ref="'customIdentifierValueSelect_' + index"
                            @input="onCustomIdentifierValueChange(index, $event)"
                            @searchchange="onCustomIdentifierValueSearchChange(index, $event)"
                          />
                        </div>
                      </div>
                      <div class="col-sm-2 d-flex align-items-center">
                        <div class="mt-2">
                          <span
                            v-tooltip="isRequiredCustomIdentifier(identifier) ? 'This identifier is required by the selected permit and cannot be removed.' : 'Remove custom identifier'">
                            <button
                              type="button"
                              class="btn btn-sm"
                              :class="isRequiredCustomIdentifier(identifier) ? 'text-muted' : 'text-danger'"
                              :disabled="isRequiredCustomIdentifier(identifier)"
                              @click="removeCustomIdentifier(index)"><i
                                class="fas fa-minus"></i></button>
                          </span>
                          <button type="button" class="btn btn-sm text-success"
                            v-if="index == (form.custom_identifiers.length - 1)" @click="addCustomIdentifier()"><i
                              class="fas fa-plus"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="form.custom_identifiers.length == 0">
                      <div class="col-sm-12">
                        <a href="javascript:void(0);" class="txt--primary txt--ss mb-1"
                          @click="addCustomIdentifier()">Add Custom Identifier</a>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="form__group">
                  <div class="d-flex justify-content-center flex-wrap">
                    <ButtonWithSpinner class="button button--primary button--sm mr-3" :loading="button.loading"
                      :success="button.success" :disabled="button.disabled" @click="sendSubscription">Send
                    </ButtonWithSpinner>
                    <button type="button" @click="changeTopFilter(1)" class="button button--outline button--sm">
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <!-- CSV UPLOAD -->
            <div v-if="topFilter == 3" class="content__box__body pt-0">
              <div class="monthlySubsForm">
                <div class="d-flex justify-content-center align-items-center mb-4">
                  <p class="txt--ss txt--semi-bold txt--off-white" v-if="csv_name != ''">
                    <span>{{ csv_name | truncate(15, "...") }}</span>csv
                  </p>
                </div>
                <div class="monthlySubsForm__upload mb-1">
                  <label class="monthlySubsForm__upload__button" v-if="!csv_uploading">
                    <input type="file"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      ref="csvFileInput" @change="uploadCSV" />
                    Upload
                  </label>
                  <ButtonWithSpinner v-else class="button button--primary button--sm mr-3" :loading="true"
                    :success="false" :disabled="true">Upload</ButtonWithSpinner>
                </div>

                <p class="txt--xs txt--off-white text-center">
                  (Upload CSV or Excel only)
                </p>
                <a href="Sample/SampleUserList.csv" download class="
                    txt--xs txt--off-white
                    text-center
                    d-flex
                    justify-content-center
                    mt-2
                  ">Download Sample CSV
                  <span class="ml-2">
                    <i class="fas fa-cloud-download-alt"></i>
                  </span>
                </a>
              </div>
              <p class="txt--ss txt--red text-center mb-2">Important Note</p>
              <p class="txt--ss txt--off-white text-left mb-2">
                The uploaded CSV must contain FIRST NAME, LAST NAME, EMAIL,VEHICLE COUNT, VEHICLE PLATE, VEHICLE STATE
                ACTION, and SUBSCRIPTION ID, PERMIT ID, BACKDATE SUBSCRIPTION, and BACKDATE START DATE. The uploaded CSV
                is
                required to have SUBSCRIPTION ID for actions other than CREATE.
                The PERMIT ID is required for action CREATE.
              </p>
              <p class="txt--ss txt--off-white text-left mb-2">
                Leave The ACTION field blank for subscriptions that you do not
                want to change.
              </p>
              <p class="txt--ss txt--off-white text-left mb-2">
                There are a list of actions that can be used. These are -
                CREATE, CANCEL NOW, CANCEL LATER, REINITIATE AND DELETE.
              </p>
              <p class="txt--ss txt--off-white text-left mb-2">
                CREATE - Use this action to create a new permit holder.
              </p>
              <p class="txt--ss txt--off-white text-left mb-2">
                CANCEL NOW - Use this action to cancel a permit subscription
                immediately.
              </p>
              <p class="txt--ss txt--off-white text-left mb-2">
                CANCEL LATER - Use this action to cancel a permit subscription
                at the end of the current subscription period.
              </p>
              <p class="txt--ss txt--off-white text-left mb-2">
                REINITIATE - Use this action to reinitiate a permit
                subscription. Subscriptions can not be reinitiated if the
                subscription end date is already reached.
              </p>
              <p class="txt--ss txt--off-white text-left mb-2">
                DELETE - Use this action to delete a permit subscription. If the
                subscription is not cancelled or cancelled at the end of current
                subscription period, then the subscription will be cancelled
                immediately before deleting the subscription.
              </p>
              <p class="txt--ss txt--off-white text-left mb-2">
                Please remember to remove the columns that are not necessary from the CSV/Excel file that you are going
                to import.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="directDetailLoading && !showCustomerDetails && !showPendingCustomerDetails && !showSendPermitMemo">
        <div class="col-md-12">
          <div class="content__box h-100">
            <div class="content__box__body d-flex justify-content-center align-items-center" style="min-height: 220px;">
              <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Permit Customer Details -->
      <div class="row" v-if="showCustomerDetails && !showSendPermitMemo">
        <div class="col-md-6">
          <!-- Subscription Details Card -->
          <div class="content__box mb-4">
            <div class="content__box__body">
              <div class="top__filter align-items-center mb-1">
                <ul class="top__filter__ul">
                  <li class="cursor-pointer  txt--semi-bold" @click="showCustomerDetails = false">
                    <span class="mr-2"><i class="fas fa-chevron-left"></i></span>Permit Customers
                  </li>
                </ul>
                <ul
                  v-if="(!processing) && (user_role == 'commercial' || (user_role == 'operator' && access_list.permit_access_write == true))"
                  class="top__filter__ul">
                  <li v-if="showPermitRenewalResponses" @click.stop="showMarkOptions = true">
                    Mark As
                  </li>
                  <div v-click-outside="closeDropdown" class="sessionsFilter" v-if="showMarkOptions">
                    <div class="d-flex">
                      <div class="sessionsFilter__left">
                        <p class="sessionsFilter__text mb-3" @click="markPermit(approved_permit_details, 'ready', !approved_permit_marks.ready)">
                            {{ approved_permit_marks.ready !== true ? 'Ready' : 'Not Ready' }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- <li v-if="approved_permit_details.status == 'authorized'" @click="resendPermitNotification(approved_permit_details.application_id)">
                    Resend Permit
                  </li> -->
                  <li v-if="approved_permit_details.status != 'expired'" @click.stop="showContactOptions = true">
                    Send Email
                  </li>
                  <div v-click-outside="closeDropdown" class="sessionsFilter" v-if="showContactOptions">
                    <div class="d-flex">
                      <div class="sessionsFilter__left">
                        <p class="sessionsFilter__text mb-3" @click="() => {this.closeDropdown(); memoData.type = 'waitlist'; showSendPermitMemo = true;}">
                            Waitlist Instructions
                        </p>
                        <p class="sessionsFilter__text mb-3" @click="() => {this.closeDropdown(); memoData.type = 'renewal'; showSendPermitMemo = true;}">
                            Renewal Instructions
                        </p>
                        <p class="sessionsFilter__text mb-3" @click="sendEmail(approved_permit_details, 'd-5e2a32594be04df2b9f47b600f9ca75c', (() => {
                            markPermit(approved_permit_details, 'ready', !approved_permit_marks.ready)
                        }))">
                            Pick-up Instructions
                        </p>
                      </div>
                    </div>
                  </div>
                  <li v-if="
                    !approved_permit_details.cancellation_status &&
                    (approved_permit_details.status == 'approved'
                      || approved_permit_details.status == 'pending_payment'
                      || approved_permit_details.status == 'waiting_list')
                  " class="active">
                    <p class="txt--ss txt--yellow cursor-pointer" v-tooltip="'Experimental'" @click="
                      pauseSubscription(
                        approved_permit_details.application_id
                      )
                    ">
                      Suspend<sup>*</sup>
                    </p>
                  </li>
                  <li v-if="
                    approved_permit_details.cancellation_status && approved_permit_details.status == 'expired'
                  " class="active">
                    <p class="txt--ss txt--yellow cursor-pointer" v-tooltip="'Experimental'" @click="
                      unpauseSubscription(
                        approved_permit_details.application_id
                      )
                    ">
                      Unpause<sup>*</sup>
                    </p>
                  </li>
                  <li v-if="
                    !approved_permit_details.cancellation_status &&
                    (approved_permit_details.status == 'approved'
                      || approved_permit_details.status == 'pending_payment')
                  " class="active">
                    <p class="txt--ss txt--red cursor-pointer" @click="
                      cancelSubscription(
                        approved_permit_details.application_id
                      )
                    ">
                      Cancel
                    </p>
                  </li>
                  <!-- <li v-if="
                    !approved_permit_details.cancellation_status &&
                    (approved_permit_details.status == 'approved'
                      || approved_permit_details.status == 'pending_payment'
                      )
                      && !approved_permit_details.refunded_amount
                  " class="active">
                    <p class="txt--ss txt--green cursor-pointer" @click="
                      refundSubscription(
                        approved_permit_details.application_id
                      )
                    ">
                      Refund Amount
                    </p>
                  </li> -->
                  <!-- <li v-if="approved_permit_details.refunded_amount">
                    <span class="txt--xs txt badge badge-pill ml-2 badge-danger">Refunded</span>
                  </li> -->
                  <li v-if="
                    approved_permit_details.cancellation_status &&
                    approved_permit_details.status == 'approved'
                  " class="active">
                    <p class="txt--ss txt--primary cursor-pointer" @click="
                      reinitateSubscription(
                        approved_permit_details.application_id
                      )
                    ">
                      {{ approved_permit_details.cancel_custom == 1 ? 'Unscheduled ' + '( ' +
                          approved_permit_details.custom_cancel_date_new + ' )' : 'Reinitiate'
                      }}
                      <!-- Reinitiate -->
                    </p>
                  </li>
                  <li v-if="approved_permit_details.cancellation_status && approved_permit_details.status == 'expired'" class="active">
                    <p class="txt--ss txt--red cursor-pointer" @click="deleteSubscription(approved_permit_details.application_id)">
                      Delete
                    </p>
                  </li>
                  <li v-if="approved_permit_details.status == 'authorized'" class="active">
                    <p class="txt--ss txt--red cursor-pointer" @click="confirmAuthorizedApplicationDelete(approved_permit_details.application_id)">
                      Delete
                    </p>
                  </li>
                </ul>
              </div>
              <h2 class="txt--fslg pb-1">
                {{ getApprovedDisplayName() }}
              </h2>

              <div class="d-flex align-items-center flex-wrap">
                <div class="d-flex align-items-center mr-4 mt-2">
                  <p class="txt--fsxs opacity--50 text-truncate mr-3">Email</p>
                  <p class="txt--fsxs text-truncate">
                    {{ getApprovedDisplayEmail() }}
                  </p>
                </div>
                <div class="d-flex align-items-center mr-4 mt-2">
                  <p class="txt--fsxs opacity--50 text-truncate mr-3">Phone</p>
                  <p class="txt--fsxs text-truncate">
                    {{ approved_permit_details.phone || 'N/A' }}
                  </p>
                </div>
                <div class="d-flex align-items-center mr-4 mt-2">
                  <p class="txt--fsxs opacity--50 text-truncate mr-3">
                    Subscription Id
                  </p>
                  <p class="txt--fsxs text-truncate cursor-pointer" @click="copyText('subscription_id')">
                    {{ approved_permit_details.subscription_id }}
                  </p>
                  <input type="hidden" name="subscription_id" id="subscription_id"
                    :value="approved_permit_details.subscription_id" />
                </div>
                <div class="d-flex align-items-center mr-4 mt-2">
                  <p class="txt--fsxs opacity--50 text-truncate mr-3">
                    Permit Id
                  </p>
                  <p class="txt--fsxs text-truncate cursor-pointer" @click="copyText('permit_id')">
                    {{ approved_permit_details.permit_id }}
                  </p>
                  <input type="hidden" name="permit_id" id="permit_id" :value="approved_permit_details.permit_id" />
                </div>
                <div class="d-flex align-items-center mr-4 mt-2">
                  <p class="txt--fsxs opacity--50 text-truncate mr-3">
                    Allowed Vehicles
                  </p>
                  <p class="txt--fsxs text-truncate mr-2">
                    {{ approved_permit_details.vehicle_count != '' ? approved_permit_details.vehicle_count : 'All' }}
                  </p>
                  <a
                    v-if="(user_role == 'commercial' || (user_role == 'operator' && access_list.permit_access_write == true))"
                    href="javascript:void(0);"
                    class="allowed-vehicles-edit-btn"
                    title="Update # of Vehicles"
                    @click="showUpdateVehicleCountModal('approved')"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                </div>
                <div class="d-flex align-items-center mr-4 mt-2">
                  <p class="txt--fsxs opacity--50 text-truncate mr-3">
                    Permit Type
                  </p>
                  <p class="txt--fsxs text-truncate mr-2">
                    {{ approved_permit_details.permit_name }}
                  </p>
                  <a
                    v-if="(user_role == 'commercial' || (user_role == 'operator' && access_list.permit_access_write == true))"
                    href="javascript:void(0);"
                    class="allowed-vehicles-edit-btn"
                    title="Update Permit Type"
                    @click="showUpdatePermitTypeModal('approved')"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                </div>
                <!-- <div class="d-flex align-items-center mr-4 mt-2">
                  <p class="txt--fsxs opacity--50 text-truncate mr-3">Status</p>
                  <p
                    :class="[
                      'txt--fsxs text-truncate',
                      approved_permit_details.status == 'approved'
                        ? 'txt--green'
                        : 'txt--red',
                    ]"
                  >
                    {{
                      approved_permit_details.status == "approved"
                        ? "Active"
                        : approved_permit_details.status == "expired"
                        ? "Expired"
                        : approved_permit_details.status == 'pending_payment'
                        ? 'Payment Pending'
                        : "Inactive"
                    }}
                  </p>
                </div> -->
                <div class="d-flex align-items-center mr-4 mt-2">
                  <p class="txt--fsxs opacity--50 text-truncate mr-3">
                    Permit Type
                  </p>
                  <p class="txt--fsxs text-truncate">
                    {{ approved_permit_details.recurring == 1 ? "Recurring" : (approved_permit_details.flex_permit == 1 ? "Flex" : "One Time") }}
                  </p>
                </div>
                <div class="d-flex align-items-center mr-4 mt-2" v-if="approved_permit_details.flex_permit == 1">
                  <p class="txt--fsxs txt--primary text-truncate mr-3">
                    Flex Permit Usage:
                  </p>
                  <p class="txt--fsxs text-truncate">
                    {{ approved_permit_details.flex_permit_usage || 'N/A' }}
                  </p>
                </div>
                <div class="d-flex align-items-center mr-4 mt-2">
                  <p class="txt--fsxs opacity--50 text-truncate mr-3">
                    Subscription created date
                  </p>
                  <p class="txt--fsxs text-truncate">
                    {{ approved_permit_details.created_at }}
                  </p>
                </div>
                <div class="d-flex align-items-center mr-4 mt-2" v-if="approved_permit_details.cancel_custom == 1">
                  <p class="txt--fsxs txt--primary text-truncate mr-3">
                    End of subscription custom date:
                  </p>
                  <p class="txt--fsxs text-truncate">
                    {{ approved_permit_details.custom_cancel_date_new ?
                        approved_permit_details.custom_cancel_date_new : 'N/A'
                    }}
                  </p>
                </div>
                <div class="d-flex align-items-center mr-4 mt-2"
                  v-else-if="approved_permit_details.cancel_custom != 1 && approved_permit_details.cancellation_status == 1">
                  <p class="txt--fsxs txt--primary text-truncate mr-3">
                    End of subscription period date:
                  </p>
                  <p class="txt--fsxs text-truncate">
                    {{ approved_permit_details.subscription_end ? approved_permit_details.subscription_end : 'N/A' }}
                  </p>
                </div>
                <div class="d-flex align-items-center mr-4 mt-2" v-else-if="approved_permit_details.recurring == 0">
                  <p class="txt--fsxs txt--primary text-truncate mr-3">
                    End of subscription period date:
                  </p>
                  <p class="txt--fsxs text-truncate">
                    {{ approved_permit_details.subscription_end ? approved_permit_details.subscription_end : 'N/A' }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- Subscription Cancel Details -->
          <div class="content__box mb-4" v-if="shouldShowOffstreetSection()">
            <div class="content__box__header">
              <div class="top__filter align-items-center mb-1">
                <ul class="top__filter__ul">
                  <li class="cursor-default txt--semi-bold">
                    Subscription
                  </li>
                  <span :class="[
                    'txt--fsxs text-truncate txt--semi-bold pb-2',
                    approved_permit_details.status == 'approved'
                      ? 'txt--green'
                      : 'txt--red',
                  ]">
                    {{
                        approved_permit_details.status == "approved"
                          ? "Active"
                          : approved_permit_details.status == "expired"
                            ? "Expired"
                            : approved_permit_details.status == 'pending_payment'
                              ? 'Payment Pending'
                              : "Inactive"
                    }}
                  </span>
                </ul>
              </div>
              <div class="d-flex flex-wrap">
                <div class="modal__payment__text pl-0 pb-2 col-12"
                  v-if="approved_permit_details.cancel_custom != 1 && approved_permit_details.cancellation_status == 1">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">
                      End of subscription period date:
                    </p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <p class="txt--fsxs text-truncate">
                      {{ approved_permit_details.subscription_end ? approved_permit_details.subscription_end : 'N/A' }}
                    </p>
                  </div>
                </div>
                <div>
                  <div class="modal__payment__text pl-0 col-7"
                    v-if="approved_permit_details.status != 'approved' || (approved_permit_details.cancel_custom != 1 && approved_permit_details.cancellation_status == 1)">
                    <div class="sessions_start_duration text-right mr-3">
                      <p class="txt--fsxs opacity--50 text-truncate">
                        Cancelled By
                      </p>
                    </div>
                    <div class="activity__msg txt--semi-bold" v-if="this.subscriptionCancelDetails != ''">
                      <p class="txt--fsxs text-truncate">
                        {{ this.subscriptionCancelDetails.user_email }}
                        <!-- {{this.subscriptionCancelDetails.user_name + ' ( '+this.subscriptionCancelDetails.user_email+' )'}} -->
                      </p>
                    </div>
                  </div>
                  <div class="modal__payment__text col-5 pl-0"
                    v-if="approved_permit_details.status != 'approved' || (approved_permit_details.cancel_custom != 1 && approved_permit_details.cancellation_status == 1)">
                    <div class="sessions_start_duration text-right mr-3 mt-2">
                      <p class="txt--fsxs opacity--50 text-truncate">
                        Cancelled on
                      </p>
                    </div>
                    <div class="activity__msg txt--semi-bold mt-2" v-if="this.subscriptionCancelDetails != ''">
                      <p class="txt--fsxs text-truncate">
                        {{ this.subscriptionCancelDetails.cancel_at }}
                      </p>
                    </div>
                  </div>
                  <div class="modal__payment__text pl-0 pt-2 col-12"
                    v-if="approved_permit_details.status != 'approved' || (approved_permit_details.cancel_custom != 1 && approved_permit_details.cancellation_status == 1)">
                    <div class="sessions_start_duration text-right mr-3">
                      <p class="txt--fsxs opacity--50 text-truncate">
                        Cancel Reason
                      </p>
                    </div>
                    <div class="activity__msg txt--semi-bold" v-if="this.subscriptionCancelDetails != ''">
                      <p class="txt--fsxs text-truncate">
                        {{ this.subscriptionCancelDetails.cancel_reason }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="content__box mb-4">
            <div class="content__box__header">
              <div class="top__filter align-items-center mb-1">
                <ul class="top__filter__ul">
                  <li class="cursor-default txt--semi-bold">
                    Offstreet
                  </li>
                </ul>
                <ul class="top__filter__ul">
                  <li class="cursor-pointer" @click="fetchOffstreetSubscriptionDetails()">
                    Refresh Status
                  </li>
                  <li
                    v-if="canWritePermitCustomers()"
                    class="cursor-pointer"
                    @click="openApprovedOffstreetManagement()"
                  >
                    Manage Permit Offstreet
                  </li>
                  <li
                    v-if="canWritePermitCustomers()"
                    class="cursor-pointer"
                    @click="confirmRecreateApprovedOffstreetSubscription()"
                  >
                    {{ offstreetRecreateLoading ? 'Recreating...' : 'Recreate Subscription' }}
                  </li>
                </ul>
              </div>

              <div class="offstreet-summary-row mb-3" v-if="offstreetStatusSummary.total > 0">
                <span class="offstreet-summary-pill">Total: {{ offstreetStatusSummary.total }}</span>
                <span class="offstreet-summary-pill summary-good">Synced: {{ offstreetStatusSummary.synced }}</span>
                <span class="offstreet-summary-pill summary-danger">Failed: {{ offstreetStatusSummary.failed }}</span>
                <span class="offstreet-summary-pill summary-subdued">Unsynced: {{ offstreetStatusSummary.unsynced }}</span>
                <span class="offstreet-summary-pill summary-warn">Voided: {{ offstreetStatusSummary.voided }}</span>
                <span class="offstreet-summary-pill summary-neutral">Needs recreate: {{ offstreetStatusSummary.needs_recreate }}</span>
              </div>

              <div v-if="offstreetStatusLoading" class="d-flex justify-content-center py-3">
                <div class="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>

              <div v-else-if="offstreetStatusRow" class="d-flex flex-wrap">
                <div class="modal__payment__text pl-0 pb-2 col-12 col-lg-6">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">Sync Status</p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <span class="offstreet-status-chip" :class="offstreetSyncStatusClass(offstreetStatusRow.sync_status)">
                      {{ offstreetStatusRow.sync_status || 'unknown' }}
                    </span>
                  </div>
                </div>
                <div class="modal__payment__text pl-0 pb-2 col-12 col-lg-6">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">Cutover Status</p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <span class="offstreet-status-chip status-subdued">{{ offstreetStatusRow.cutover_status || 'none' }}</span>
                  </div>
                </div>
                <div class="modal__payment__text pl-0 pb-2 col-12 col-lg-6">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">Needs Recreate</p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <p class="txt--fsxs text-truncate">{{ offstreetStatusRow.offstreet_needs_recreate ? 'Yes' : 'No' }}</p>
                  </div>
                </div>
                <div class="modal__payment__text pl-0 pb-2 col-12 col-lg-6">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">Permit Version</p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <p class="txt--fsxs text-truncate">{{ offstreetStatusRow.offstreet_permit_version || '-' }}</p>
                  </div>
                </div>
                <div class="modal__payment__text pl-0 pb-2 col-12 col-lg-6">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">Last Updated</p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <p class="txt--fsxs text-truncate">{{ formatOffstreetDate(offstreetStatusRow.offstreet_last_updated_at || offstreetStatusRow.offstreet_created_at) }}</p>
                  </div>
                </div>
                <div class="modal__payment__text pl-0 pb-2 col-12 col-lg-6">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">Last Failed</p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <p class="txt--fsxs text-truncate">{{ formatOffstreetDate(offstreetStatusRow.offstreet_last_failed_at || offstreetStatusRow.offstreet_recreate_failed_at) }}</p>
                  </div>
                </div>
                <div class="modal__payment__text pl-0 pb-2 col-12" v-if="offstreetStatusRow.offstreet_recreate_last_error">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">Recreate Error</p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <p class="txt--fsxs offstreet-error-text">{{ offstreetStatusRow.offstreet_recreate_last_error }}</p>
                  </div>
                </div>
              </div>

              <div v-else>
                <p v-if="offstreetStatusError" class="txt--fsxs txt--off-white opacity--50 mb-0">
                  {{ offstreetStatusError }}
                </p>
                <p v-else class="txt--fsxs txt--off-white opacity--50 mb-0">
                  Offstreet status has not been loaded yet.
                </p>
              </div>
            </div>
          </div>
          <!-- Price Breakdown -->
          <div class="content__box mb-4" v-if="approved_permit_details.previous_price_breakdown">
            <div class="content__box__header">
              <div class="top__filter align-items-center mb-1">
                <ul class="top__filter__ul">
                  <li class="cursor-default txt--semi-bold">
                    Current Subscription Price Breakdown
                  </li>
                </ul>
              </div>
              <div class="d-flex flex-wrap">
                <div class="modal__payment__text pl-3">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">Subtotal</p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <p class="txt--fsxs text-truncate">
                      ${{ approved_permit_details.previous_price_breakdown.subtotal.toFixed(2) }}
                    </p>
                  </div>
                </div>
                <div class="modal__payment__text pl-5">
                  <div class="sessions_start_duration text-right mr-3">
                    <!-- <p class="txt--fsxs opacity--50 text-truncate">Application Fee</p> -->
                    <p class="txt--fsxs opacity--50 text-truncate">
                      Parking Tax
                    </p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <!-- <p class="txt--fsxs text-truncate">${{approved_permit_details.price_breakdown.application_fee.toFixed(2)}}</p> -->
                    <p class="txt--fsxs text-truncate" v-if="approved_permit_details.free_permit == 1">
                      $ 0.00
                    </p>
                    <p class="txt--fsxs text-truncate" v-else>
                      ${{ approved_permit_details.previous_price_breakdown.parking_tax.toFixed(2) }}
                      {{ approved_permit_details.previous_price_breakdown.tax_included == 1 ? '(Included)' : '' }}
                    </p>
                  </div>
                </div>
                <div class="modal__payment__text pl-5">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">
                      Total Price
                    </p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <p class="txt--fsxs text-truncate" v-if="approved_permit_details.free_permit == 1">
                      $ 0.00
                    </p>
                    <p class="txt--fsxs text-truncate" v-else>
                      ${{ approved_permit_details.previous_price_breakdown.total_price.toFixed(2) }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="top__filter align-items-center mt-3 mb-1">
                <ul class="top__filter__ul">
                  <li class="cursor-default txt--semi-bold">
                    Subscription Price Breakdown For Future Intervals
                  </li>
                </ul>
              </div>
              <div class="d-flex flex-wrap">
                <div class="modal__payment__text pl-3">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">Subtotal</p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <p class="txt--fsxs text-truncate">
                      ${{ approved_permit_details.price_breakdown.subtotal.toFixed(2) }}
                    </p>
                  </div>
                </div>
                <div class="modal__payment__text pl-5">
                  <div class="sessions_start_duration text-right mr-3">
                    <!-- <p class="txt--fsxs opacity--50 text-truncate">Application Fee</p> -->
                    <p class="txt--fsxs opacity--50 text-truncate">
                      Parking Tax
                    </p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <!-- <p class="txt--fsxs text-truncate">${{approved_permit_details.price_breakdown.application_fee.toFixed(2)}}</p> -->
                    <p class="txt--fsxs text-truncate" v-if="approved_permit_details.free_permit == 1">
                      $ 0.00
                    </p>
                    <p class="txt--fsxs text-truncate" v-else>
                      ${{ approved_permit_details.price_breakdown.parking_tax.toFixed(2) }}
                      {{ approved_permit_details.price_breakdown.tax_included == 1 ? '(Included)' : '' }}
                    </p>
                  </div>
                </div>
                <div class="modal__payment__text pl-5">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">
                      Total Price
                    </p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <p class="txt--fsxs text-truncate" v-if="approved_permit_details.free_permit == 1">
                      $ 0.00
                    </p>
                    <p class="txt--fsxs text-truncate" v-else>
                      ${{ approved_permit_details.price_breakdown.total_price.toFixed(2) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Card details -->
          <div class="content__box mb-4">
            <div class="content__box__header">
              <div class="top__filter align-items-center mb-1">
                <ul class="top__filter__ul">
                  <li class="cursor-default txt--semi-bold">
                    Payment Details
                    <span class="font-weight-normal"
                      v-if="approved_permit_details.recurring == 1 && (approved_permit_details.cancellation_status != 1 || approved_permit_details.subscription_end < approved_permit_details.custom_cancel_date_new)">
                      next payment on {{ approved_permit_details.subscription_end }}
                    </span>
                    <span class="font-weight-normal" v-else-if="approved_permit_details.custom_cancel_date_new != ''">
                      expires on {{ approved_permit_details.custom_cancel_date_new }}
                    </span>
                  </li>
                </ul>
                <!-- <ul class="top__filter__ul">
                  <li class="cursor-default opacity--1">
                    <span class="font-weight-normal txt--green"
                      v-if="approved_permit_details.status == 'approved'">Valid</span>
                    <span class="font-weight-normal txt--red" v-if="
                      approved_permit_details.status != 'approved' &&
                      approved_permit_details.status != 'expired' &&
                      approved_permit_details.status != 'authorized'
                    ">Invalid</span>
                  </li>
                </ul> -->
              </div>
              <div class="d-flex flex-wrap">
                <div class="payment__card" v-if="
                  approved_permit_details.card &&
                  approved_permit_details.card.brand != ''
                ">
                  <img :src="getCreditcardLogo(approved_permit_details.card.brand)" alt="CardImage" />
                </div>
                <div class="payment__card" v-else>
                  <img src="@/assets/images/DebitCardImage/credit-card.png" alt="cardImage" />
                </div>
                <div class="modal__payment__text pl-3">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">Type</p>
                    <p class="txt--fsxs opacity--50 pt-2 text-truncate">
                      Last 4
                    </p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <p class="txt--fsxs text-truncate">
                      {{ approved_permit_details.card && approved_permit_details.card.brand ? (approved_permit_details.card.brand | capitalize) : 'N/A' }}
                    </p>
                    <p class="txt--fsxs pt-2 text-truncate">
                      {{ approved_permit_details.card && approved_permit_details.card.last4_digit ? approved_permit_details.card.last4_digit : 'N/A' }}
                    </p>
                  </div>
                </div>
                <div class="modal__payment__text pl-5">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">Exp</p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <p class="txt--fsxs text-truncate">
                      {{ approved_permit_details.card && approved_permit_details.card.exp_month && approved_permit_details.card.exp_year ? (approved_permit_details.card.exp_month + '/' + approved_permit_details.card.exp_year) : 'N/A' }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Vehicle details -->
          <div class="content__box mb-4">
            <div class="content__box__body">
              <div class="top__filter">
                <ul class="top__filter__ul">
                  <li class="cursor-default">Vehicles</li>
                </ul>
                <ul class="top__filter__ul" v-if="(user_role == 'commercial' || (user_role == 'operator' && access_list.permit_access_write == true))">
                  <li @click="openApprovedPermitVehicleForm()">Add Vehicle</li>
                </ul>
              </div>
              <div v-if="getApprovedPermitVehicles().length > 0">
                <div class="d-flex flex-wrap mb-3" v-for="(vehicle, vehicleIndex) in getApprovedPermitVehicles()" :key="vehicle.id || vehicle.license_no || vehicle.vin_id || vehicleIndex">
                  <div class="activity__indicator">
                    <div :class="[
                      vehicle.license_no != ''
                        ? 'sessions_number_box'
                        : 'sessions_number_box_long',
                      'text-center',
                    ]">
                      <div class="txt--xs txt--red txt--bold images_state">
                        {{ getApprovedPermitVehicleState(vehicle) }}
                      </div>
                      <p :class="['txt--fsxs', 'txt--bold', 'pt-1', 'permit-vehicle-identifier', getApprovedPermitVehicleIdentifierClass(vehicle)]">
                        {{ getApprovedPermitVehicleIdentifier(vehicle) }}
                      </p>
                    </div>
                  </div>
                  <div class="modal__payment__text pl-3">
                    <div class="sessions_start_duration text-right mr-3">
                      <p class="txt--fsxs opacity--50 text-truncate">Year</p>
                      <p class="txt--fsxs opacity--50 pt-2 text-truncate">Make</p>
                    </div>
                    <div class="activity__msg txt--semi-bold">
                      <p class="txt--fsxs text-truncate">
                        {{ vehicle.year || 'N/A' }}
                      </p>
                      <p class="txt--fsxs pt-2 text-truncate">
                        {{ vehicle.make || 'N/A' }}
                      </p>
                    </div>
                  </div>
                  <div class="modal__payment__text pl-5">
                    <div class="sessions_start_duration text-right mr-3">
                      <p class="txt--fsxs opacity--50 text-truncate">Model</p>
                      <p class="txt--fsxs opacity--50 pt-2 text-truncate">
                        Color
                      </p>
                    </div>
                    <div class="activity__msg txt--semi-bold">
                      <p class="txt--fsxs text-truncate">
                        {{ vehicle.model || 'N/A' }}
                      </p>
                      <p class="txt--fsxs pt-2 text-truncate">
                        {{ vehicle.color || 'N/A' }}
                      </p>
                    </div>
                  </div>
                  <div class="modal__payment__text pl-3 d-flex align-items-center justify-content-end" v-if="(user_role == 'commercial' || (user_role == 'operator' && access_list.permit_access_write == true))">
                    <button type="button" class="btn btn-sm text-danger" title="Remove vehicle" @click="detachApprovedPermitVehicle(vehicle)">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div v-else>
                <p class="txt--fsxs opacity--50 mb-0">No vehicles found.</p>
              </div>
              <div class="mt-3" v-if="showApprovedPermitVehicleForm">
                <div class="row" v-for="(vehicleForm, vehicleFormIndex) in approvedPermitVehicleForms" :key="`approved-permit-vehicle-${vehicleFormIndex}`">
                  <div class="col-sm-3">
                    <div class="form__group mb-3">
                      <label class="txt--xs txt--off-white">Country</label>
                      <model-list-select
                        :list="country_list"
                        v-model="vehicleForm.country_code"
                        option-value="country_code"
                        option-text="country_name"
                        placeholder="Select Country"
                        class="custom-vue-select"
                        @input="onApprovedPermitVehicleCountryChange(vehicleFormIndex, $event)">
                      </model-list-select>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form__group mb-3">
                      <label class="txt--xs txt--off-white">State</label>
                      <model-list-select
                        :list="vehicleForm.state_list || []"
                        v-model="vehicleForm.state"
                        option-value="short_code"
                        option-text="full_name"
                        placeholder="Select State"
                        class="custom-vue-select">
                      </model-list-select>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form__group mb-3">
                      <label class="txt--xs txt--off-white">License Plate</label>
                      <input type="text" placeholder="Enter license plate number"
                        v-model="vehicleForm.license_plate" class="textInputField" maxlength="20"
                        @input="sanitizeApprovedPermitVehicleLicensePlate(vehicleFormIndex)" />
                    </div>
                  </div>
                  <div class="col-sm-2 d-flex align-items-center">
                    <div class="mt-2 d-flex" style="gap: 8px;">
                      <button type="button" class="btn btn-sm text-success" :disabled="approvedPermitVehicleSubmitting"
                        title="Add another vehicle row" @click="addApprovedPermitVehicleForm()">
                        <i class="fas fa-plus"></i>
                      </button>
                      <button type="button" class="btn btn-sm text-muted" :disabled="approvedPermitVehicleSubmitting"
                        :title="approvedPermitVehicleForms.length > 1 ? 'Remove this vehicle row' : 'Cancel adding vehicles'"
                        @click="removeApprovedPermitVehicleForm(vehicleFormIndex)">
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-end flex-wrap" style="gap: 12px;">
                  <ButtonWithSpinner class="button button--primary button--sm" :loading="approvedPermitVehicleSubmitting"
                    :success="false" :disabled="approvedPermitVehicleSubmitting" @click="attachApprovedPermitVehicle()">
                    Attach Vehicles
                  </ButtonWithSpinner>
                  <button type="button" class="button button--outline button--sm" :disabled="approvedPermitVehicleSubmitting"
                    @click="closeApprovedPermitVehicleForm()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Custom Identifiers -->
          <div
            class="content__box"
            v-if="approved_permit_details && (((approved_permit_details['custom_identifiers'] || []).length > 0) || showDetailAddIdentifierForm || canWritePermitCustomers())"
          >
            <div class="content__box__header pb-2">
              <div class="top__filter">
                <ul class="top__filter__ul">
                  <li class="cursor-default">
                    Custom Identifiers
                  </li>
                </ul>
                <ul class="top__filter__ul" v-if="!showDetailAddIdentifierForm && (user_role == 'commercial' || (user_role == 'operator' && access_list.permit_access_write == true))">
                  <li @click="showDetailAddIdentifierForm = true">
                    Add Custom Identifier
                  </li>
                </ul>
              </div>

              <div class="row pt-2">
                <div class="col">
                  <p class="txt--xs txt--semi-bold opacity--50">Identifier Name</p>
                </div>
                <div class="col">
                  <p class="txt--xs txt--semi-bold opacity--50">Identifier Value</p>
                </div>
                <div class="col">
                  <p class="txt--xs txt--semi-bold opacity--50">Action</p>
                </div>
              </div>
            </div>
            <div class="content__divider"></div>
            <div class="content__box__body pt-0">
              <div class="row pt-2" v-for="(identifier, index) in approved_permit_details['custom_identifiers']"
                :key="index">
                <div class="col">
                  <p class="txt--ss">{{ identifier.key }}</p>
                </div>
                <div class="col">
                  <p v-if="!isDetailIdentifierEditing(index)" class="txt--ss">{{ identifier.value }}</p>
                  <ModelListSelect
                    v-else
                    v-model="detailEditingIdentifierValues[index]"
                    :list="getDetailIdentifierValueList(index, identifier.key)"
                    option-value="value"
                    option-text="text"
                    :placeholder="'Enter or select identifier value'"
                    :is-error="false"
                    :allow-new="true"
                    class="custom-vue-select"
                    :ref="'detailIdentifierValueSelect_' + index"
                    @input="onDetailIdentifierEditValueChange(identifier, index, $event)"
                    @searchchange="onDetailIdentifierValueSearchChange(index, $event)"
                  />
                </div>
                <div class="col">
                  <template v-if="isDetailIdentifierEditing(index)">
                    <a href="javascript:void(0);" class="text-success mr-2" :class="{ 'disabled': detailEditIdentifierLoading }"
                      :title="detailEditIdentifierLoading ? 'Saving...' : 'Save identifier value'"
                      @click="saveDetailCustomIdentifierEdit(identifier, index)">
                      <i :class="detailEditIdentifierLoading ? 'fas fa-spinner fa-spin' : 'fas fa-check'"></i>
                    </a>
                    <a href="javascript:void(0);" class="text-muted" :class="{ 'disabled': detailEditIdentifierLoading }"
                      title="Cancel editing"
                      @click="cancelDetailCustomIdentifierEdit()"><i class="fas fa-times"></i></a>
                  </template>
                  <template v-else>
                    <a href="javascript:void(0);" class="txt--primary mr-2" title="Edit identifier value"
                      @click="startDetailCustomIdentifierEdit(identifier, index)"><i class="fas fa-pen"></i></a>
                    <a href="javascript:void(0);" :class="isRequiredApprovedCustomIdentifier(identifier) ? 'text-muted' : 'text-danger'"
                      :title="isRequiredApprovedCustomIdentifier(identifier) ? 'This identifier is required by the selected permit and cannot be removed.' : 'Remove custom identifier'"
                      @click="removeCustomIdentifiers(identifier, 'approved')"><i class="fas fa-trash"></i></a>
                  </template>
                </div>
              </div>
              <!-- Inline add custom identifier form -->
              <div v-if="showDetailAddIdentifierForm" class="mt-3">
                <div class="row">
                  <div class="col-sm-5">
                    <div class="form__group mb-3">
                      <label class="txt--xs txt--off-white">Identifier Name</label>
                      <ModelListSelect
                        v-model="detailNewIdentifier.key"
                        :list="getDetailNewIdentifierKeyList()"
                        option-value="value"
                        option-text="text"
                        :placeholder="'Enter or select identifier name'"
                        :is-error="false"
                        :allow-new="true"
                        class="custom-vue-select"
                        ref="detailNewIdentifierKeySelect"
                        @input="onDetailNewIdentifierKeyChange($event)"
                        @searchchange="onDetailNewIdentifierKeySearchChange($event)"
                      />
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="form__group mb-3">
                      <label class="txt--xs txt--off-white">Identifier Value</label>
                      <ModelListSelect
                        v-model="detailNewIdentifier.value"
                        :list="getDetailNewIdentifierValueList(detailNewIdentifier.key)"
                        option-value="value"
                        option-text="text"
                        :placeholder="'Enter or select identifier value'"
                        :is-error="false"
                        :allow-new="true"
                        class="custom-vue-select"
                        ref="detailNewIdentifierValueSelect"
                        @input="onDetailNewIdentifierValueChange($event)"
                        @searchchange="onDetailNewIdentifierValueSearchChange($event)"
                      />
                    </div>
                  </div>
                  <div class="col-sm-2 d-flex align-items-center">
                    <div class="mt-2">
                      <button type="button" class="btn btn-sm text-danger" :disabled="detailAddIdentifierLoading"
                        @click="showDetailAddIdentifierForm = false; detailNewIdentifier = { key: '', value: '' }">
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-end flex-wrap" style="gap: 12px;">
                  <ButtonWithSpinner class="button button--primary button--sm" :loading="detailAddIdentifierLoading"
                    :success="false" :disabled="detailAddIdentifierLoading" @click="submitDetailCustomIdentifier()">
                    Add Identifier
                  </ButtonWithSpinner>
                  <button type="button" class="button button--outline button--sm" :disabled="detailAddIdentifierLoading"
                    @click="showDetailAddIdentifierForm = false; detailNewIdentifier = { key: '', value: '' }">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Permit Customer Session Details -->
        <div class="col-md-6 mt-4 mt-md-0">
          <div class="content__box content__box--activity" style="height: 100%">
            <div class="content__box__header pb-0">
              <div class="top__filter flex-nowrap align-items-center">
                <ul class="top__filter__ul">
                  <li>Sessions</li>
                </ul>
                <ul class="top__filter__ul search_form_control">
                  <li>
                    <input type="text" placeholder="Search license plate OR VIN" aria-label="Search"
                      class="form-control form-control-sm" v-model="session_search" />
                  </li>
                </ul>
                <ul class="top__filter__ul">
                  <li :class="{ 'active': session_type == 1 }" @click="changeSessionFilter(1)">Active</li>
                  <li :class="{ 'active': session_type == 2 }" @click="changeSessionFilter(2)">Past</li>
                </ul>
              </div>
            </div>
            <div class="content__divider"></div>
            <div id="session_div" class="
                content__box__body
                box__height box__height--session-property
              ">
              <div class="activity__list session__list" v-if="session_list.length > 0">
                <div v-for="(session, index) in session_list" :key="index">
                  <div :id="'session_' + index" class="activity__list session__list">
                    <div class="activity__new activity__new--property pb-0">
                      <div class="activity__indicator mb-2">

                        <div :class="[
                          session.vehicle_details.license_id != ''
                            ? 'sessions_number_box text-center'
                            : 'text-center sessions_number_box_vin',
                        ]">
                          <div class="txt--xs txt--red txt--bold images_state">
                            {{
                                session.vehicle_details.state_full_name !=
                                  ""
                                  ? session.vehicle_details
                                    .state_full_name
                                  : session.vehicle_details.license_id !=
                                    ""
                                    ? session.vehicle_details.country
                                    : ""
                            }}
                          </div>
                          <p class="txt--fsxs text-truncate txt--bold pt-1"
                            v-if="session.vehicle_details.license_id != ''">
                            {{
                                session.vehicle_details.license_id.toUpperCase()
                            }}
                          </p>
                          <p v-else class="txt--fsxs txt--bold pt-1">
                            {{
                                session.vehicle_details.vin_id
                                | last_eight(8, "##")
                            }}
                          </p>
                        </div>
                      </div>

                      <div class="activity__txt activity__txt--property mb-2">
                        <div class="sessions_start_duration text-right mr-3">
                          <p class="txt--fsxs opacity--50 text-truncate">
                            Start
                          </p>
                          <p class="txt--fsxs opacity--50 pt-2 text-truncate">
                            Duration
                          </p>
                        </div>
                        <div class="activity__msg txt--semi-bold">
                          <p class="txt--fsxs text-truncate">
                            {{ session.booking_start_date_formatted }}
                          </p>
                          <p class="txt--fsxs pt-2 text-truncate">
                            {{ session.stay_duration }}
                            <span v-if="
                              session_type == 2 &&
                              session.customer_type != 2
                            " class="pl-2">
                              {{
                                  "$" +
                                  session.price_breakdown.payable_amount
                              }}
                            </span>
                          </p>
                        </div>
                      </div>
                      <div class="
                          activity__address activity__address--property
                          mb-2
                        ">
                        <p class="txt--xs opacity--50 text-truncate">
                          {{
                              session.property_name != ""
                                ? session.property_name
                                : session.display_address
                          }}
                        </p>
                        <p class="txt--xs opacity--50 text-truncate pt-2">
                          {{ session.customer_type_name }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <infinite-loading @infinite="paginateSession" :distance="10" v-if="
                  session_list.length > 0 &&
                  session_load_more
                ">
                  <div slot="spinner">
                    <div class="d-flex justify-content-center mt-4">
                      <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                  <div slot="no-more"></div>
                  <div slot="no-results">No data found</div>
                </infinite-loading>
              </div>
              <div v-if="session_list.length == 0 && session_loader" class="
                  d-flex
                  justify-content-center
                  reports__details--body
                  m-customer--min-height
                ">
                <div class="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Send Renewal Instructions -->
      <div class="content__box" v-if="showSendPermitMemo">
        <div class="content__box__header">
          <p class="text-white txt--ss opacity--50">Send Email</p>
        </div>
        <div class="content__divider"></div>
        <div class="content__box__body">
          <form class="col-md-6 mx-auto">
          <div class="row">
            <div class="col-sm-12">
                <div class="form-group">
                    <div class="d-flex align-items-center justify-content-between flex-wrap mb-2">
                        <p class="txt--xs txt--off-white">Permit Memo Type</p>
                    </div>

                    <select v-model="memoData.type" class="textInputField">
                      <option value="" selected>Select a type</option>
                      <option value="renewal" selected>Renewal</option>
                      <option value="waitlist" selected>Waitlist</option>
                    </select>
                </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group mt-2">
                <app-toggle :checked="memoData.enabled"
                  :label="'Send Enabled'" @update:checked="updateToggleValue($event, 'enabled')">
                </app-toggle>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group mt-2">
                <app-toggle :checked="memoData.unsent"
                  :label="'Send Unsent'" @update:checked="updateToggleValue($event, 'unsent')">
                </app-toggle>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group mt-2">
                <app-toggle :checked="memoData.no_response"
                  :label="'Send No Response'" @update:checked="updateToggleValue($event, 'no_response')">
                </app-toggle>
              </div>
            </div>
          </div>
        </form>
          <div class="form__group mt-2">
            <div class="d-flex justify-content-center flex-wrap" style="gap: 20px">
              <ButtonWithSpinner class="button button--primary button--sm" :loading="button.loading"
                :success="button.success" :disabled="button.disabled" @click="sendPermitMemo()">Send
              </ButtonWithSpinner>
              <button type="button" @click="closeModal()" class="button button--outline button--sm">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Close Modal Cross Icon -->
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
    <OffstreetPermitManagement />
    <CancelSubscription @api-response="finalizeCancellation($event)" />
  </modal>
</template>

<script>
import Vue from "vue";
import Toggle from "@/components/toggle";
import { ModelSelect, ModelListSelect } from "vue-search-select";
import ButtonWithSpinner from "@/components/Button";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import CancelSubscription from "@/components/modals/CancelSubscription";
import OffstreetPermitManagement from "@/components/modals/OffstreetPermitManagement";
import { normalizePermitCustomIdentifierOptionsPayload } from "@/services/customIdentifier.service";
import {
  fetchOffstreetSubscriptionSyncStatus,
  recreateOffstreetSubscription,
} from "@/services/offstreetOperator.service";
export default {
  name: "PermitCustomerLists",
  components: {
    AppToggle: Toggle,
    ModelListSelect,
    ButtonWithSpinner,
    datetime: Datetime,
    CancelSubscription,
    OffstreetPermitManagement,
  },
  props: ["search_from_property"],
  data() {
    return {
      memoData: {
        type: "",
        enabled: true,
        unsent: false,
        no_response: false,
      },
      showSendPermitMemo: false,
      showCustomerDetails: false,
      showPendingCustomerDetails: false,
      showPermitRenewalResponses: false,
      showBackDate: false,
      isBackdateSubscriptionLocked: false,
      topFilter: 1,
      toggleComponentKey: 0,
      toggleBackdateComponentKey: 0,
      toggleCustomEndDateComponentKey: 0,
      status: 0,
      property_id: "",
      property_timezone: "",
      showForm: true,
      check_msg: '',
      form: {
        first_name: "",
        last_name: "",
        email: "",
        permit_id: "",
        create_from: "COMMERCIAL",
        existing_customer: false,
        pied_managed: false,
        vehicle_count: 1,
        vehicles: [],
        custom_identifiers: this.getDefaultCustomIdentifiers(),
        backdate_subscription: false,
        custom_enddate_subscription: false,
        backdate_start_date: '',
        custom_end_date: '',
      },
      maxDatetime: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
      minDatetime: '',
      maxCustomEndDatetime: this.$moment().add(1, 'Y').format("YYYY-MM-DDTHH:mm:ss.sssZ"),
      minCustomEndDatetime: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
      allow_all_vehicle: false,
      country_list: [],
      permit_list: [],
      button: {
        loading: false,
        success: false,
        disabled: false,
      },

      search: "",
      approved_applications: [],
      approved_application_page: 1,
      approved_application_type: '',
      approved_application_filters: {},
      approved_application_loader: false,
      approved_application_load_more: false,
      approved_application_source: null,
      pendingDirectSubscriptionId: '',
      pendingDirectPermitId: '',
      pendingPreloadedSubscription: null,
      directDetailLoading: false,
      approved_custom_identifiers_keys: [],

      approved_permit_details: {},
      approved_permit_marks: {},
      showApprovedPermitVehicleForm: false,
      approvedPermitVehicleSubmitting: false,
      approvedPermitVehicleForms: [],

      showDetailAddIdentifierForm: false,
      detailNewIdentifier: { key: '', value: '' },
      detailAddIdentifierLoading: false,
      detailEditingIdentifierIndices: [],
      detailEditingIdentifierValues: {},
      detailEditIdentifierLoading: false,
      detailIdentifierValueSearchText: {},
      detailNewIdentifierKeySearchText: '',
      detailNewIdentifierValueSearchText: '',

      processing: false,
      csv_name: "",
      csv_uploading: false,
      offstreetStatusLoading: false,
      offstreetStatusError: "",
      offstreetStatusRow: null,
      offstreetStatusSummary: {
        total: 0,
        synced: 0,
        failed: 0,
        voided: 0,
        unsynced: 0,
        needs_recreate: 0,
      },
      offstreetRecreateLoading: false,

      session_source: null,
      session_list: [],
      session_page: 1,
      session_loader: false,
      session_load_more: false,
      session_search: '',
      session_type: 1,

      showExportOptions: false,
      showFilterOptions: false,
      showMarkOptions: false,
      showContactOptions: false,
      styleClassStatus: false,

      user_role: '',
      subscriptionCancelDetails: {},
      
      // Custom identifier dropdown options
      customIdentifierKeyOptions: [],
      customIdentifierValueOptions: {},
      customIdentifierKeyDefinitions: {},
      customIdentifierRelationships: {},

      // Track what the user is typing in ModelListSelect so we can inject it as a temporary option.
      // This does not persist across refresh; it only supports current form submission.
      customIdentifierKeySearchText: {},
      customIdentifierValueSearchText: {},
    };
  },
  directives: {
    "click-outside": {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
        console.log(binding);
      },
    },
  },
  filters: {
    capitalize: function (text) {
      return text.toUpperCase();
    },
    titleCase: function (text) {
      return this.titleCase(text);
    },
    truncate: function (text, length, suffix) {
      let text_ar = text.split("/");
      text = text_ar[text_ar.length - 1];
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        let text_arr = text.split(".csv");
        text = text_arr[0] + ".";
        return text;
      }
    },
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal.trim() != oldVal.trim()) {
        this.approved_application_page = 1;
        this.approved_applications = [];
        this.approved_application_load_more = false;
        this.approvedApplications();
      }
    },
    "form.backdate_subscription": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.toggleBackdateComponentKey += 1;
      }
    },
    "form.pied_managed": function (newVal) {
      if (newVal) {
        this.form.existing_customer = false;
        this.generatePiedManagedEmail();
      } else {
        this.form.email = '';
      }
    },
    "form.first_name": function () {
      if (this.form.pied_managed) {
        this.generatePiedManagedEmail();
      }
    },
    "form.last_name": function () {
      if (this.form.pied_managed) {
        this.generatePiedManagedEmail();
      }
    },
    session_search: function (newVal, oldVal) {
      if (newVal.trim() != oldVal.trim()) {
        this.getSessions();
      }
    },
    "form.permit_id": function (val) {
      if (val) {
        this.prefillCustomIdentifiersForPermit(val);
        this.applyBackdateSettingsForPermit(val);
        this.showBackDate = false;
        this.permit_list.map(permit => {
          if (permit.permit_id == val && permit.start_date == '' && permit.end_date == '' && permit.recurring == 1) {
            this.showBackDate = true;
            if (permit.permit_duration_type == 'day') {
              let date_time = this.$moment().subtract(permit.permit_duration, 'days');
              this.minDatetime = date_time.add(1, 'days').format("YYYY-MM-DDTHH:mm:ss.sssZ");

            }
            else if (permit.permit_duration_type == 'week') {
              let date_time = this.$moment().subtract(permit.permit_duration, 'weeks');
              this.minDatetime = date_time.add(1, 'days').format("YYYY-MM-DDTHH:mm:ss.sssZ");


            }
            else if (permit.permit_duration_type == 'month') {
              let date_time = this.$moment().subtract(permit.permit_duration, 'months');
              this.minDatetime = date_time.add(1, 'days').format("YYYY-MM-DDTHH:mm:ss.sssZ");


            }
            else if (permit.permit_duration_type == 'year') {
              let date_time = this.$moment().subtract(permit.permit_duration, 'years');
              this.minDatetime = date_time.add(1, 'days').format("YYYY-MM-DDTHH:mm:ss.sssZ");
            }
          }
        });

        if (this.isBackdateSubscriptionRequiredForPermit(val)) {
          this.showBackDate = true;
        }
      }
    }
  },
  created() {
    this.user_role = localStorage.getItem("role");
    this.access_list = JSON.parse(localStorage.getItem("commercial_access_list"));
  },
  beforeUpdate() { },
  methods: {
    titleCase: function (text) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
    canWritePermitCustomers() {
      return this.user_role == 'commercial' || (this.user_role == 'operator' && this.access_list && this.access_list.permit_access_write == true);
    },
    shouldShowOffstreetSection() {
      const offstreetEnabled = ["true", "1"].includes(
        String(localStorage.getItem("offstreet_integration_enabled") || "").toLowerCase()
      );

      if (!offstreetEnabled) {
        return false;
      }

      return this.user_role === 'commercial' || this.user_role === 'operator';
    },
    getPermitRenewalLatestUserChoice(approved) {        
        const responses = [...(approved.permit_renewal_user_choices || [])];
        
        return responses.reverse()[0] || {};
    },
    getPermitRenewalLatestChoice(approved) {        
        const latestChoice = this.getPermitRenewalLatestUserChoice(approved)['choice'];
        
        return latestChoice ? this.titleCase(latestChoice) : 'N/A';
    },
    resendPermitNotification(id) {
      this.axios
        .get(window.hostname + "api/auth/permit/resend_payment_link/" + id)
        .then((response) => {
          // console.log(response);
          this.$toasted.show(response.data.message, {
            icon: "check-circle",
            className: "success-class",
          });
        })
        .catch((errors) => {
        });
    },
    closeDropdown() {
      this.showExportOptions = false;
      this.showFilterOptions = false;
      this.showMarkOptions = false;
      this.showContactOptions = false;
    },
    getData(e) {
      this.showCustomerDetails = false;
      this.showPermitRenewalResponses = this.getShouldShowPermitRenewalResponses();
      this.topFilter = 1;
      this.form = {
        first_name: "",
        last_name: "",
        email: "",
        permit_id: "",
        create_from: "COMMERCIAL",
        existing_customer: false,
        pied_managed: false,
        vehicles: [],
        custom_identifiers: this.getDefaultCustomIdentifiers(),
        backdate_subscription: false,
        custom_enddate_subscription: false,
        backdate_start_date: '',
        custom_end_date: '',
      };
      this.allow_all_vehicle = false;
      this.showForm = true;
      this.showBackDate = false;
      this.isBackdateSubscriptionLocked = false;
      this.minDatetime = '';
      this.button = {
        loading: false,
        success: false,
        disabled: false,
      };
      const params = e && e.params ? e.params : {};
      const propertyDetails = params.property_details || {};
      const propertyLocation = propertyDetails.location || {};

      this.property_id = propertyDetails.space_id || params.property_id || '';
      this.property_timezone = propertyLocation.time_zone || params.property_timezone || this.$moment.tz.guess();
      this.status = propertyDetails.space_status !== undefined ? propertyDetails.space_status : (params.property_status !== undefined ? params.property_status : 4);
      this.search = "";
      this.approved_applications = [];
      this.approved_application_page = 1;
      this.approved_application_loader = false;
      this.approved_application_load_more = false;
      this.approved_application_source = null;
      this.approved_application_type = '';
      this.approved_application_filters = {};
      this.approved_permit_details_sources = {};
      this.approved_permit_details = {};
      this.approved_permit_marks = {};
      this.showApprovedPermitVehicleForm = false;
      this.approvedPermitVehicleSubmitting = false;
      this.resetApprovedPermitVehicleForms();
      this.processing = false;
      this.csv_name = "";
      this.csv_uploading = false;
      this.pendingDirectSubscriptionId = params.direct_subscription_id || '';
      this.pendingDirectPermitId = params.direct_permit_id || '';
      const preloadedSubscription = params.preloaded_subscription || null;
      this.pendingPreloadedSubscription = preloadedSubscription;
      this.directDetailLoading = !!(preloadedSubscription || this.pendingDirectSubscriptionId);
      this.search = this.search_from_property;
      this.getPermits();
      if (this.pendingDirectSubscriptionId) {
        this.openDirectSubscriptionDetails();
      } else if (preloadedSubscription && typeof preloadedSubscription === 'object') {
        const normalizedPreloaded = this.normalizeApprovedDetails(preloadedSubscription);
        this.approved_applications = [normalizedPreloaded];
        this.pendingPreloadedSubscription = null;
        this.directDetailLoading = false;
        this.showApprovedSubscriptionDetails(normalizedPreloaded);
      } else {
        this.directDetailLoading = false;
        this.approvedApplications();
      }
      this.getVehicleCountries();
      // Load custom identifier options for this property
      this.fetchCustomIdentifierOptions(this.property_id);
    },
    getPermits() {
      this.axios
        .post(window.hostname + "/api/auth/permit/list", {
          commercial: 1,
          page: 1,
          limit: 500,
          all: 1,
          property_id: this.property_id,
        })
        .then((res) => {
          if (res.data.status) {
            this.permit_list = res.data.data.permit_list ? res.data.data.permit_list : [];
          } else {
            this.permit_list = [];
          }
          if (this.permit_list.length == 0) { this.button.disabled = true; }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closeModal() {
      this.$emit("modal_closed");
      this.$modal.hide("permit-customer");
    },
    checkNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
      return true;
    },
    changeTopFilter(filter) {
      this.topFilter = filter;
      if (this.topFilter == 1) {
        this.approved_application_load_more = false;
        this.approved_application_page = 1;
        this.approved_applications = [];
        this.approvedApplications();
      }
      else if (this.topFilter == 2) {
        this.form.first_name = '';
        this.form.last_name = '';
        this.form.email = '';
        this.form.permit_id = '';
        this.form.vehicle_count = 1;
        this.form.existing_customer = false;
        this.form.pied_managed = false;
        this.resetVehicles();
        this.resetCustomerIdentifiers();
        this.form.backdate_subscription = false;
        this.form.custom_enddate_subscription = false;
        this.form.backdate_start_date = '';
        this.form.custom_end_date = '';
        this.showForm = true;
        this.showBackDate = false;
        this.isBackdateSubscriptionLocked = false;
        this.allow_all_vehicle = false;
        this.showApprovedPermitVehicleForm = false;
        this.approvedPermitVehicleSubmitting = false;
        this.resetApprovedPermitVehicleForms();
      }
    },
    updateToggleValue(e, type) {
      this.memoData[type] = e
    },
    checkUncheckExistingCustomer(e) {
      this.form.existing_customer = e;
      if (this.form.existing_customer) {
        this.form.first_name = '';
        this.form.last_name = '';
      }
      this.showForm = !this.form.existing_customer;
      if (this.showForm) {
        this.check_msg = '';
      }
    },
    generatePiedManagedEmail() {
      const firstName = this.form.first_name ? String(this.form.first_name).trim().toLowerCase() : '';
      const lastName = this.form.last_name ? String(this.form.last_name).trim().toLowerCase() : '';

      if (!firstName || !lastName) {
        this.form.email = '';
        return;
      }

      // Remove dots and spaces from first name, then replace spaces with dots
      const normalizedFirstName = firstName.replace(/\./g, '').replace(/ /g, '.');
      // Remove spaces from last name and replace with dots
      const normalizedLastName = lastName.replace(/ /g, '.');

      // Get sub_domain from localStorage, or fall back to first 7 chars of company_id
      let subDomain = localStorage.getItem('user_sub_domain');
      if (!subDomain) {
        const companyId = localStorage.getItem('commercial_user_id');
        subDomain = companyId ? companyId.substring(0, 7) : 'raffle';
      }

      this.form.email = `it.ops+${normalizedFirstName}.${normalizedLastName}.${subDomain}@piedparker.com`;
    },
    backdateSubscription(e) {
      if (this.isBackdateSubscriptionLocked) {
        this.form.backdate_subscription = true;
        return;
      }

      this.form.backdate_subscription = e;
    },
    getSelectedPermitById(permitId) {
      return (this.permit_list || []).find((permit) => permit && permit.permit_id == permitId) || null;
    },
    isBackdateSubscriptionRequiredForPermit(permitId) {
      const selectedPermit = this.getSelectedPermitById(permitId);
      const rawBackdateSubscription = selectedPermit ? selectedPermit.backdate_subscription : false;

      return rawBackdateSubscription === true || rawBackdateSubscription === 1 || rawBackdateSubscription === '1' || rawBackdateSubscription === 'true';
    },
    getBackdateStartDateTemplateForPermit(permitId) {
      const selectedPermit = this.getSelectedPermitById(permitId);
      return this.normalizeCustomIdentifierText(selectedPermit && selectedPermit.backdate_start_date_template);
    },
    applyBackdateSettingsForPermit(permitId) {
      const shouldForceBackdateSubscription = this.isBackdateSubscriptionRequiredForPermit(permitId);
      const backdateStartDateTemplate = this.getBackdateStartDateTemplateForPermit(permitId);

      this.isBackdateSubscriptionLocked = shouldForceBackdateSubscription;

      if (shouldForceBackdateSubscription) {
        this.form.backdate_subscription = true;
        this.form.backdate_start_date = '';

        if (!backdateStartDateTemplate) {
          this.$toasted.show('This permit requires backdating, but no backdate template is configured on the permit type.', {
            icon: 'times-circle',
            className: 'error-class'
          });
        }
      } else {
        this.form.backdate_subscription = false;
      }
    },
    customEndDateSubscription(e) {
      this.form.custom_enddate_subscription = e;
    },
    getShouldShowPermitRenewalFilters() {
        const renewal_owner_ids = ['60b1846a0611b655395c4832'];
        const is_renewal_owner = renewal_owner_ids.includes(localStorage.getItem("user_id")) || renewal_owner_ids.includes(localStorage.getItem("commercial_user_id"));

        return is_renewal_owner;
    },
    getShouldShowPermitRenewalResponses() {
        return this.getShouldShowPermitRenewalFilters() && this.approved_application_type == 'memo' && this.approved_application_filters['memo_type'] == 'renewal';
    },
    getDefaultCustomIdentifiers() {
      return [
        {
          identifier_key: '',
          identifier_value: ''
        }
      ];
    },
    resetCustomerIdentifiers() {        
        this.form.custom_identifiers = this.getDefaultCustomIdentifiers();
    },
    getPermitRequiredCustomIdentifiers(permit) {
      if (!permit) {
        return [];
      }

      const rawRequiredIdentifiers = permit.required_custom_idenitifers || permit.required_custom_identifiers || [];
      let parsedRequiredIdentifiers = rawRequiredIdentifiers;

      if (typeof parsedRequiredIdentifiers === 'string') {
        try {
          parsedRequiredIdentifiers = JSON.parse(parsedRequiredIdentifiers);
        } catch (e) {
          parsedRequiredIdentifiers = [];
        }
      }

      if (!Array.isArray(parsedRequiredIdentifiers)) {
        return [];
      }

      const requiredKeys = parsedRequiredIdentifiers
        .map((identifier) => {
          if (typeof identifier === 'string' || typeof identifier === 'number') {
            return String(identifier).trim();
          }

          if (identifier && typeof identifier === 'object') {
            if (identifier.key !== undefined && identifier.key !== null) {
              return String(identifier.key).trim();
            }

            if (identifier.identifier_key !== undefined && identifier.identifier_key !== null) {
              return String(identifier.identifier_key).trim();
            }
          }

          return '';
        })
        .filter((key) => key.length > 0);

      return [...new Set(requiredKeys)];
    },
    prefillCustomIdentifiersForPermit(permitId) {
      const selectedPermit = this.permit_list.find((permit) => permit.permit_id == permitId);
      const requiredKeys = this.getPermitRequiredCustomIdentifiers(selectedPermit);

      if (requiredKeys.length === 0) {
        this.resetCustomerIdentifiers();
        return;
      }

      const existingValuesByKey = {};
      (this.form.custom_identifiers || []).forEach((identifier) => {
        if (identifier && identifier.identifier_key) {
          existingValuesByKey[identifier.identifier_key] = identifier.identifier_value || '';
        }
      });

      this.form.custom_identifiers = requiredKeys.map((key) => ({
        identifier_key: key,
        identifier_value: existingValuesByKey[key] || ''
      }));
    },
    isRequiredCustomIdentifier(identifier) {
      const identifierKey = identifier && identifier.identifier_key ? String(identifier.identifier_key).trim() : '';

      if (!identifierKey || !this.form.permit_id) {
        return false;
      }

      const selectedPermit = this.permit_list.find((permit) => permit.permit_id == this.form.permit_id);
      const requiredKeys = this.getPermitRequiredCustomIdentifiers(selectedPermit);

      return requiredKeys.includes(identifierKey);
    },
    isRequiredApprovedCustomIdentifier(identifier) {
      const identifierKey = identifier && identifier.key ? String(identifier.key).trim() : '';

      if (!identifierKey || !this.approved_permit_details || !this.approved_permit_details.permit_id) {
        return false;
      }

      const selectedPermit = this.permit_list.find((permit) => permit.permit_id == this.approved_permit_details.permit_id);
      const requiredKeys = this.getPermitRequiredCustomIdentifiers(selectedPermit);

      return requiredKeys.includes(identifierKey);
    },
    validateCustomIdentifiers() {
      const customIdentifiers = (this.form.custom_identifiers || []).map((identifier) => ({
        identifier_key: identifier && identifier.identifier_key ? String(identifier.identifier_key).trim() : '',
        identifier_value: identifier && identifier.identifier_value ? String(identifier.identifier_value).trim() : ''
      }));

      const identifiersWithKey = customIdentifiers.filter((identifier) => identifier.identifier_key !== '');

      for (const identifier of identifiersWithKey) {
        if (identifier.identifier_value === '') {
          return {
            valid: false,
            message: `Please provide a value for ${identifier.identifier_key}.`
          };
        }

        if (this.isCustomIdentifierSchemaLoaded() && !this.isCustomIdentifierKeyKnown(identifier.identifier_key)) {
          return {
            valid: false,
            message: `Unknown custom identifier key: ${identifier.identifier_key}.`
          };
        }

        if (this.isPredefinedCustomIdentifierKey(identifier.identifier_key)) {
          const valueOptions = this.getValueOptionsForKey(identifier.identifier_key);
          if (!this.customIdentifierOptionListHasValue(valueOptions, identifier.identifier_value)) {
            return {
              valid: false,
              message: `Invalid value for ${identifier.identifier_key}. Please select an allowed value.`
            };
          }
        }

        const pattern = this.getCustomIdentifierValidationPattern(identifier.identifier_key);
        if (pattern) {
          let regex = null;
          try {
            regex = new RegExp(pattern);
          } catch (e) {
            regex = null;
          }

          if (regex && !regex.test(identifier.identifier_value)) {
            return {
              valid: false,
              message: this.getCustomIdentifierValidationErrorMessage(identifier.identifier_key) || `Invalid format for ${identifier.identifier_key}.`
            };
          }
        }
      }

      const selectedPermit = this.permit_list.find((permit) => permit.permit_id == this.form.permit_id);
      const requiredKeys = this.getPermitRequiredCustomIdentifiers(selectedPermit);

      for (const requiredKey of requiredKeys) {
        const matchedIdentifier = customIdentifiers.find((identifier) => identifier.identifier_key === requiredKey);
        if (!matchedIdentifier || matchedIdentifier.identifier_value === '') {
          return {
            valid: false,
            message: `Please provide a value for required identifier: ${requiredKey}.`
          };
        }
      }

      return { valid: true };
    },
    addCustomIdentifier() {
      this.form.custom_identifiers = [
        ...this.form.custom_identifiers,
        ...this.getDefaultCustomIdentifiers(),
      ];
    },
    removeCustomIdentifier(index) {
      const identifier = this.form.custom_identifiers[index];

      if (this.isRequiredCustomIdentifier(identifier)) {
        this.$toasted.show("Required custom identifiers cannot be removed!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }

      this.$delete(this.form.custom_identifiers, index);
    },
    addVehicle() {
      this.form.vehicles.push({
        country_code: '',
        state: '',
        state_list: [],
        license_plate: ''
      });
    },
    onVehicleCountryChange(index, countryCode) {
      if (!this.form.vehicles[index]) {
        return;
      }

      this.form.vehicles[index].country_code = countryCode;
      this.form.vehicles[index].state = '';
      this.$set(this.form.vehicles[index], 'state_list', []);

      if (countryCode) {
        this.getVehicleStates(index, countryCode);
      }
    },
    getVehicleCountries() {
      this.axios
        .post(window.hostname + "/api/auth/get-countries")
        .then((res) => {
          if (res.data.status) {
            this.country_list = res.data.data.country_list || [];
          } else {
            this.country_list = [];
          }
        })
        .catch(() => {
          this.country_list = [];
        });
    },
    getVehicleStates(index, countryCode) {
      this.axios
        .post(window.hostname + "/api/auth/get-states", {
          country_code: countryCode,
        })
        .then((res) => {
          const stateList = (res.data.status && res.data.data && res.data.data.state_list) ? res.data.data.state_list : [];
          if (this.form.vehicles[index]) {
            this.$set(this.form.vehicles[index], 'state_list', stateList);
          }
        })
        .catch(() => {
          if (this.form.vehicles[index]) {
            this.$set(this.form.vehicles[index], 'state_list', []);
          }
        });
    },
    getDefaultApprovedPermitVehicleForm() {
      return {
        country_code: '',
        state: '',
        state_list: [],
        license_plate: ''
      };
    },
    resetApprovedPermitVehicleForms() {
      this.approvedPermitVehicleForms = [];
    },
    addApprovedPermitVehicleForm() {
      this.approvedPermitVehicleForms = [
        ...this.approvedPermitVehicleForms,
        this.getDefaultApprovedPermitVehicleForm()
      ];
    },
    removeApprovedPermitVehicleForm(index) {
      if (this.approvedPermitVehicleForms.length <= 1) {
        this.closeApprovedPermitVehicleForm();
        return;
      }

      this.$delete(this.approvedPermitVehicleForms, index);
    },
    openApprovedPermitVehicleForm() {
      this.showApprovedPermitVehicleForm = true;
      this.resetApprovedPermitVehicleForms();
      this.addApprovedPermitVehicleForm();
    },
    closeApprovedPermitVehicleForm() {
      this.showApprovedPermitVehicleForm = false;
      this.resetApprovedPermitVehicleForms();
    },
    onApprovedPermitVehicleCountryChange(index, countryCode) {
      if (!this.approvedPermitVehicleForms[index]) {
        return;
      }

      this.approvedPermitVehicleForms[index].country_code = countryCode;
      this.approvedPermitVehicleForms[index].state = '';
      this.$set(this.approvedPermitVehicleForms[index], 'state_list', []);

      if (!countryCode) {
        return;
      }

      this.axios
        .post(window.hostname + "/api/auth/get-states", {
          country_code: countryCode,
        })
        .then((res) => {
          const stateList = (res.data.status && res.data.data && res.data.data.state_list) ? res.data.data.state_list : [];
          if (this.approvedPermitVehicleForms[index]) {
            this.$set(this.approvedPermitVehicleForms[index], 'state_list', stateList);
          }
        })
        .catch(() => {
          if (this.approvedPermitVehicleForms[index]) {
            this.$set(this.approvedPermitVehicleForms[index], 'state_list', []);
          }
        });
    },
    normalizeApprovedPermitVehicleLicensePlate(licensePlate) {
      return String(licensePlate || '')
        .replace(/[^a-z0-9]/gi, '')
        .toUpperCase();
    },
    sanitizeApprovedPermitVehicleLicensePlate(index) {
      if (!this.approvedPermitVehicleForms[index]) {
        return;
      }

      this.$set(
        this.approvedPermitVehicleForms[index],
        'license_plate',
        this.normalizeApprovedPermitVehicleLicensePlate(this.approvedPermitVehicleForms[index].license_plate)
      );
    },
    validateApprovedPermitVehicleForm(vehicle, index) {
      const countryCode = vehicle && vehicle.country_code ? String(vehicle.country_code).trim() : '';
      const state = vehicle && vehicle.state ? String(vehicle.state).trim() : '';
      const licensePlate = this.normalizeApprovedPermitVehicleLicensePlate(vehicle && vehicle.license_plate ? vehicle.license_plate : '');
      const countryIsValid = this.country_list.some((country) => country.country_code === countryCode);
      const stateList = Array.isArray(vehicle && vehicle.state_list) ? vehicle.state_list : [];
      const stateIsValid = stateList.some((stateOption) => stateOption.short_code === state);
      const rowLabel = `vehicle row ${index + 1}`;

      if (!countryCode || !countryIsValid) {
        return { valid: false, message: `Please select a valid country for ${rowLabel}.` };
      }

      if (!state || !stateIsValid) {
        return { valid: false, message: `Please select a valid state for ${rowLabel}.` };
      }

      if (licensePlate === '') {
        return { valid: false, message: `Please provide a valid license plate for ${rowLabel}.` };
      }

      return {
        valid: true,
        vehicle: {
          country_code: countryCode,
          state,
          state_list: stateList,
          license_plate: licensePlate
        }
      };
    },
    validateApprovedPermitVehicleForms() {
      const vehicles = Array.isArray(this.approvedPermitVehicleForms) ? this.approvedPermitVehicleForms : [];

      if (vehicles.length === 0) {
        return { valid: false, message: 'Please add at least one vehicle row before submitting.' };
      }

      const normalizedVehicles = [];

      for (let index = 0; index < vehicles.length; index++) {
        const validation = this.validateApprovedPermitVehicleForm(vehicles[index], index);

        if (!validation.valid) {
          return validation;
        }

        normalizedVehicles.push(validation.vehicle);
      }

      return { valid: true, vehicles: normalizedVehicles };
    },
    validateVehicles() {
      const vehicles = this.form.vehicles || [];

      for (let index = 0; index < vehicles.length; index++) {
        const vehicle = vehicles[index] || {};
        const vehicleNumber = index + 1;
        const countryCode = vehicle.country_code ? String(vehicle.country_code).trim() : '';
        const state = vehicle.state ? String(vehicle.state).trim() : '';
        const licensePlate = vehicle.license_plate ? String(vehicle.license_plate).trim() : '';
        const countryIsValid = this.country_list.some((country) => country.country_code === countryCode);
        const stateList = Array.isArray(vehicle.state_list) ? vehicle.state_list : [];
        const stateIsValid = stateList.some((stateOption) => stateOption.short_code === state);

        if (!countryCode || !countryIsValid) {
          return {
            valid: false,
            message: `Please select a valid country for vehicle ${vehicleNumber}.`
          };
        }

        if (!state || !stateIsValid) {
          return {
            valid: false,
            message: `Please select a valid state for vehicle ${vehicleNumber}.`
          };
        }

        if (licensePlate === '') {
          return {
            valid: false,
            message: `Please provide a valid license plate for vehicle ${vehicleNumber}.`
          };
        }
      }

      return { valid: true };
    },
    removeVehicle(index) {
      this.$delete(this.form.vehicles, index);
    },
    resetVehicles() {
      this.form.vehicles = [];
    },
    // Custom identifier dropdown management methods
    isObject(value) {
      return !!value && typeof value === 'object' && !Array.isArray(value);
    },
    isCustomIdentifierSchemaLoaded() {
      return Object.keys(this.customIdentifierKeyDefinitions || {}).length > 0;
    },
    getCustomIdentifierKeyDefinition(key) {
      const normalizedKey = this.normalizeCustomIdentifierText(key);
      if (!normalizedKey) {
        return null;
      }

      return (this.customIdentifierKeyDefinitions || {})[normalizedKey] || null;
    },
    isCustomIdentifierKeyKnown(key) {
      return !!this.getCustomIdentifierKeyDefinition(key);
    },
    isPredefinedCustomIdentifierKey(key) {
      const definition = this.getCustomIdentifierKeyDefinition(key);
      if (!definition) {
        return false;
      }

      return String(definition.value_type || '').toLowerCase() === 'predefined';
    },
    getCustomIdentifierValidationPattern(key) {
      const definition = this.getCustomIdentifierKeyDefinition(key);
      if (!definition) {
        return '';
      }

      return this.normalizeCustomIdentifierText(definition.validation_pattern);
    },
    getCustomIdentifierValidationErrorMessage(key) {
      const definition = this.getCustomIdentifierKeyDefinition(key);
      if (!definition) {
        return '';
      }

      return this.normalizeCustomIdentifierText(definition.validation_error_message);
    },
    resetCustomIdentifierSchemaState() {
      this.customIdentifierKeyOptions = [];
      this.customIdentifierValueOptions = {};
      this.customIdentifierKeyDefinitions = {};
      this.customIdentifierRelationships = {};
    },
    buildCustomIdentifierKeyDefinitions(keys) {
      const definitions = {};
      (Array.isArray(keys) ? keys : []).forEach((keyDefinition) => {
        if (!keyDefinition || keyDefinition.is_active === false) {
          return;
        }

        const key = this.normalizeCustomIdentifierText(keyDefinition.key);
        if (!key) {
          return;
        }

        definitions[key] = {
          ...keyDefinition,
          key,
          display_name: this.normalizeCustomIdentifierText(keyDefinition.display_name) || key,
        };
      });

      return definitions;
    },
    buildCustomIdentifierKeyOptions(definitions) {
      return Object.values(definitions || {}).map((definition) => ({
        value: definition.key,
        text: definition.display_name || definition.key,
        metadata: {
          value_type: definition.value_type,
          validation_pattern: definition.validation_pattern,
          validation_error_message: definition.validation_error_message,
        },
      }));
    },
    buildCustomIdentifierValueOptions(rawValuesByKey) {
      const valueOptions = {};
      const valuesByKey = this.isObject(rawValuesByKey) ? rawValuesByKey : {};

      Object.keys(valuesByKey).forEach((key) => {
        const normalizedKey = this.normalizeCustomIdentifierText(key);
        if (!normalizedKey) {
          return;
        }

        const rawValues = Array.isArray(valuesByKey[key]) ? valuesByKey[key] : [];
        valueOptions[normalizedKey] = rawValues
          .filter((valueOption) => !valueOption || valueOption.is_active !== false)
          .map((valueOption) => {
            if (!this.isObject(valueOption)) {
              const normalized = this.normalizeCustomIdentifierText(valueOption);
              return { value: normalized, text: normalized };
            }

            const value = this.normalizeCustomIdentifierText(valueOption.value);
            const text = this.normalizeCustomIdentifierText(valueOption.display_text) || value;

            return {
              value,
              text,
              metadata: valueOption,
            };
          })
          .filter((valueOption) => valueOption.value !== '');
      });

      return valueOptions;
    },
    getRelationshipValueMap(rawRelationship) {
      if (!this.isObject(rawRelationship)) {
        return {};
      }

      const valueMapKeys = ['value_mappings', 'value_map', 'mappings', 'map', 'values'];
      for (const key of valueMapKeys) {
        if (this.isObject(rawRelationship[key])) {
          return rawRelationship[key];
        }
      }

      const knownRelationshipMeta = [
        '_id',
        'source_key_id',
        'source_key',
        'target_key_id',
        'target_key',
        'is_bidirectional',
        'permit_type_scope',
        'created_at',
        'updated_at'
      ];

      const fallbackEntries = Object.entries(rawRelationship).filter(([entryKey]) => !knownRelationshipMeta.includes(entryKey));
      if (fallbackEntries.length === 0) {
        return {};
      }

      const valueMap = {};
      fallbackEntries.forEach(([entryKey, entryValue]) => {
        if (entryValue === null || entryValue === undefined) {
          return;
        }
        if (this.isObject(entryValue) || Array.isArray(entryValue)) {
          return;
        }

        valueMap[this.normalizeCustomIdentifierText(entryKey)] = this.normalizeCustomIdentifierText(entryValue);
      });

      return valueMap;
    },
    getReverseRelationshipValueMap(valueMap) {
      const reverse = {};
      Object.entries(valueMap || {}).forEach(([sourceValue, targetValue]) => {
        const normalizedSourceValue = this.normalizeCustomIdentifierText(sourceValue);
        const normalizedTargetValue = this.normalizeCustomIdentifierText(targetValue);
        if (!normalizedSourceValue || !normalizedTargetValue) {
          return;
        }
        if (reverse[normalizedTargetValue] === undefined) {
          reverse[normalizedTargetValue] = normalizedSourceValue;
        }
      });

      return reverse;
    },
    normalizeCustomIdentifierRelationships(rawRelationships) {
      const relationshipMap = {};
      const addRelationship = (relationshipKey, rawRelationship, shouldGenerateReverse) => {
        if (!relationshipKey || !relationshipKey.includes('->')) {
          return;
        }

        const [sourceKeyRaw, targetKeyRaw] = relationshipKey.split('->');
        const sourceKey = this.normalizeCustomIdentifierText(sourceKeyRaw);
        const targetKey = this.normalizeCustomIdentifierText(targetKeyRaw);
        if (!sourceKey || !targetKey) {
          return;
        }

        const valueMap = this.getRelationshipValueMap(rawRelationship);
        const normalizedRelationship = {
          ...(this.isObject(rawRelationship) ? rawRelationship : {}),
          source_key: sourceKey,
          target_key: targetKey,
          value_mappings: valueMap,
        };

        relationshipMap[`${sourceKey}->${targetKey}`] = normalizedRelationship;

        const shouldCreateReverse = shouldGenerateReverse && normalizedRelationship.is_bidirectional === true;
        if (!shouldCreateReverse) {
          return;
        }

        const reverseKey = `${targetKey}->${sourceKey}`;
        if (relationshipMap[reverseKey]) {
          return;
        }

        relationshipMap[reverseKey] = {
          ...normalizedRelationship,
          source_key: targetKey,
          target_key: sourceKey,
          value_mappings: this.getReverseRelationshipValueMap(valueMap),
        };
      };

      if (Array.isArray(rawRelationships)) {
        rawRelationships.forEach((relationship) => {
          if (!this.isObject(relationship)) {
            return;
          }

          const sourceKey = this.normalizeCustomIdentifierText(relationship.source_key);
          const targetKey = this.normalizeCustomIdentifierText(relationship.target_key);
          addRelationship(`${sourceKey}->${targetKey}`, relationship, true);
        });

        return relationshipMap;
      }

      if (this.isObject(rawRelationships)) {
        Object.entries(rawRelationships).forEach(([relationshipKey, relationship]) => {
          addRelationship(relationshipKey, relationship, true);
        });
      }

      return relationshipMap;
    },
    getSelectedPermitScopeValues(permitId) {
      if (!permitId) {
        return [];
      }

      const selectedPermit = (this.permit_list || []).find((permit) => String((permit || {}).permit_id) === String(permitId));
      if (!selectedPermit) {
        return [String(permitId)];
      }

      return [
        String(selectedPermit.permit_id || ''),
        String(selectedPermit.permit_name || ''),
        String(selectedPermit.permit_title || ''),
        String(selectedPermit.permit_type || ''),
      ].filter((value) => value !== '');
    },
    isRelationshipApplicableForPermit(relationship, permitId) {
      if (!relationship || !Array.isArray(relationship.permit_type_scope) || relationship.permit_type_scope.length === 0) {
        return true;
      }

      const scopeValues = this.getSelectedPermitScopeValues(permitId).map((value) => value.toLowerCase());
      const relationshipScopeValues = relationship.permit_type_scope
        .map((value) => this.normalizeCustomIdentifierText(value).toLowerCase())
        .filter((value) => value !== '');

      if (scopeValues.length === 0 || relationshipScopeValues.length === 0) {
        return true;
      }

      return relationshipScopeValues.some((value) => scopeValues.includes(value));
    },
    getMappedRelationshipValue(valueMap, sourceValue) {
      if (!this.isObject(valueMap)) {
        return null;
      }

      const normalizedSourceValue = this.normalizeCustomIdentifierText(sourceValue);
      if (!normalizedSourceValue) {
        return null;
      }

      if (valueMap[normalizedSourceValue] !== undefined) {
        return this.normalizeCustomIdentifierText(valueMap[normalizedSourceValue]);
      }

      const normalizedSourceLowercase = normalizedSourceValue.toLowerCase();
      const matchedKey = Object.keys(valueMap).find((key) => this.normalizeCustomIdentifierText(key).toLowerCase() === normalizedSourceLowercase);
      if (!matchedKey) {
        return null;
      }

      return this.normalizeCustomIdentifierText(valueMap[matchedKey]);
    },
    getRelationshipTargetMappings(sourceKey, sourceValue, permitId) {
      const normalizedSourceKey = this.normalizeCustomIdentifierText(sourceKey);
      const normalizedSourceValue = this.normalizeCustomIdentifierText(sourceValue);
      if (!normalizedSourceKey || !normalizedSourceValue) {
        return [];
      }

      const targets = [];
      Object.entries(this.customIdentifierRelationships || {}).forEach(([relationshipKey, relationship]) => {
        const [relationshipSourceKey, relationshipTargetKey] = relationshipKey.split('->');
        if (this.normalizeCustomIdentifierText(relationshipSourceKey) !== normalizedSourceKey) {
          return;
        }

        if (!this.isRelationshipApplicableForPermit(relationship, permitId)) {
          return;
        }

        const mappedValue = this.getMappedRelationshipValue((relationship || {}).value_mappings || relationship, normalizedSourceValue);
        if (!mappedValue) {
          return;
        }

        targets.push({
          targetKey: this.normalizeCustomIdentifierText((relationship || {}).target_key || relationshipTargetKey),
          targetValue: mappedValue,
        });
      });

      return targets.filter((target) => target.targetKey && target.targetValue);
    },
    getValueOptionsForKey(key) {
      // Return value options for the given key, or empty array if none exist
      const normalizedKey = this.normalizeCustomIdentifierText(key);
      return this.customIdentifierValueOptions[normalizedKey] || [];
    },

    normalizeCustomIdentifierText(text) {
      return (text === null || text === undefined) ? '' : String(text).trim();
    },

    customIdentifierOptionListHasValue(options, value) {
      const normalized = this.normalizeCustomIdentifierText(value).toLowerCase();
      if (!normalized) {
        return true;
      }
      return (options || []).some((option) => {
        const optionValue = this.normalizeCustomIdentifierText(option && option.value).toLowerCase();
        return optionValue === normalized;
      });
    },

    decorateCustomIdentifierOptions(options) {
      const list = Array.isArray(options) ? options : [];
      // vue-search-select keeps the text in the internal search input when option.value === option.text.
      // That makes the selected value render using the "filter" input styling (larger font).
      // We append a zero-width char to text when value===text so selected values render like placeholders.
      return list.map((option) => {
        const rawValue = option && option.value !== undefined ? option.value : '';
        const rawText = option && option.text !== undefined ? option.text : rawValue;
        const value = this.normalizeCustomIdentifierText(rawValue);
        let text = this.normalizeCustomIdentifierText(rawText);

        if (value && text && value === text) {
          text = `${text}\u200B`;
        }

        return {
          ...option,
          value,
          text,
        };
      });
    },

    blurVueSearchSelect(refKey) {
      this.$nextTick(() => {
        const ref = this.$refs[refKey];
        const component = Array.isArray(ref) ? ref[0] : ref;
        const rootEl = component && component.$el ? component.$el : component;
        const input = rootEl && rootEl.querySelector ? rootEl.querySelector('input.search') : null;
        if (input && typeof input.blur === 'function') {
          input.blur();
        }
      });
    },

    getDetailIdentifierValueList(index, key) {
      const baseOptions = this.decorateCustomIdentifierOptions(this.getValueOptionsForKey(key));
      const typed = this.normalizeCustomIdentifierText(this.detailIdentifierValueSearchText[index]);
      const selected = this.normalizeCustomIdentifierText(this.detailEditingIdentifierValues[index]);
      const desired = typed || selected;

      if (!desired) {
        return baseOptions;
      }

      if (this.customIdentifierOptionListHasValue(baseOptions, desired)) {
        return baseOptions;
      }

      return [{ value: desired, text: `${desired}\u200B` }, ...baseOptions];
    },

    onDetailIdentifierValueSearchChange(index, searchText) {
      const typed = this.normalizeCustomIdentifierText(searchText);
      this.$set(this.detailIdentifierValueSearchText, index, typed);
    },

    getDetailNewIdentifierKeyList() {
      const baseOptions = this.decorateCustomIdentifierOptions(this.customIdentifierKeyOptions);
      const typed = this.normalizeCustomIdentifierText(this.detailNewIdentifierKeySearchText);
      const selected = this.normalizeCustomIdentifierText(this.detailNewIdentifier && this.detailNewIdentifier.key);
      const desired = typed || selected;

      if (!desired) {
        return baseOptions;
      }

      if (this.customIdentifierOptionListHasValue(baseOptions, desired)) {
        return baseOptions;
      }

      return [{ value: desired, text: `${desired}\u200B` }, ...baseOptions];
    },

    onDetailNewIdentifierKeySearchChange(searchText) {
      this.detailNewIdentifierKeySearchText = this.normalizeCustomIdentifierText(searchText);
    },

    onDetailNewIdentifierKeyChange(newKey) {
      const normalizedKey = this.normalizeCustomIdentifierText(newKey);
      this.detailNewIdentifier.key = normalizedKey;
      this.detailNewIdentifier.value = '';
      this.detailNewIdentifierKeySearchText = normalizedKey;
      this.detailNewIdentifierValueSearchText = '';
      this.blurVueSearchSelect('detailNewIdentifierKeySelect');
    },

    getDetailNewIdentifierValueList(key) {
      const baseOptions = this.decorateCustomIdentifierOptions(this.getValueOptionsForKey(key));
      const typed = this.normalizeCustomIdentifierText(this.detailNewIdentifierValueSearchText);
      const selected = this.normalizeCustomIdentifierText(this.detailNewIdentifier && this.detailNewIdentifier.value);
      const desired = typed || selected;

      if (!desired) {
        return baseOptions;
      }

      if (this.customIdentifierOptionListHasValue(baseOptions, desired)) {
        return baseOptions;
      }

      return [{ value: desired, text: `${desired}\u200B` }, ...baseOptions];
    },

    onDetailNewIdentifierValueSearchChange(searchText) {
      this.detailNewIdentifierValueSearchText = this.normalizeCustomIdentifierText(searchText);
    },

    onDetailNewIdentifierValueChange(newValue) {
      this.detailNewIdentifier.value = this.normalizeCustomIdentifierText(newValue);
      this.blurVueSearchSelect('detailNewIdentifierValueSelect');
    },

    getCustomIdentifierKeyList(index) {
      const baseOptions = this.decorateCustomIdentifierOptions(this.customIdentifierKeyOptions);
      const typed = this.normalizeCustomIdentifierText(this.customIdentifierKeySearchText[index]);
      const selected = this.normalizeCustomIdentifierText(
        this.form.custom_identifiers && this.form.custom_identifiers[index]
          ? this.form.custom_identifiers[index].identifier_key
          : ''
      );
      const desired = typed || selected;

      if (!desired) {
        return baseOptions;
      }

      if (this.customIdentifierOptionListHasValue(baseOptions, desired)) {
        return baseOptions;
      }

      return [{ value: desired, text: `${desired}\u200B` }, ...baseOptions];
    },

    onCustomIdentifierKeySearchChange(index, searchText) {
      const typed = this.normalizeCustomIdentifierText(searchText);
      this.$set(this.customIdentifierKeySearchText, index, typed);
    },

    getCustomIdentifierValueList(index, key) {
      const baseOptions = this.decorateCustomIdentifierOptions(this.getValueOptionsForKey(key));
      const typed = this.normalizeCustomIdentifierText(this.customIdentifierValueSearchText[index]);
      const selected = this.normalizeCustomIdentifierText(
        this.form.custom_identifiers && this.form.custom_identifiers[index]
          ? this.form.custom_identifiers[index].identifier_value
          : ''
      );
      const desired = typed || selected;

      if (!desired) {
        return baseOptions;
      }

      if (this.customIdentifierOptionListHasValue(baseOptions, desired)) {
        return baseOptions;
      }

      return [{ value: desired, text: `${desired}\u200B` }, ...baseOptions];
    },

    onCustomIdentifierValueSearchChange(index, searchText) {
      const typed = this.normalizeCustomIdentifierText(searchText);
      this.$set(this.customIdentifierValueSearchText, index, typed);
    },
    onCustomIdentifierKeyChange(index, newKey) {
      if (this.isRequiredCustomIdentifier(this.form.custom_identifiers[index])) {
        return;
      }

      if (this.form.custom_identifiers[index]) {
        const normalizedKey = this.normalizeCustomIdentifierText(newKey);
        this.form.custom_identifiers[index].identifier_key = normalizedKey;

        // Clear the value when key changes, as the available options may be different
        this.form.custom_identifiers[index].identifier_value = '';
        this.$set(this.customIdentifierKeySearchText, index, normalizedKey);
        this.$set(this.customIdentifierValueSearchText, index, '');
      }

      this.blurVueSearchSelect(`customIdentifierKeySelect_${index}`);
    },
    onCustomIdentifierValueChange(index, newValue) {
      if (this.form.custom_identifiers[index]) {
        this.form.custom_identifiers[index].identifier_value = this.normalizeCustomIdentifierText(newValue);
        this.$set(this.customIdentifierValueSearchText, index, this.form.custom_identifiers[index].identifier_value);
      }

      this.blurVueSearchSelect(`customIdentifierValueSelect_${index}`);

      const currentKey = this.form.custom_identifiers[index].identifier_key;
      const relationshipTargets = this.getRelationshipTargetMappings(currentKey, newValue, this.form.permit_id);

      relationshipTargets.forEach(({ targetKey, targetValue }) => {
        const existingRelatedIndex = this.form.custom_identifiers.findIndex((identifier, identifierIndex) => {
          if (identifierIndex === index) {
            return false;
          }
          return this.normalizeCustomIdentifierText(identifier && identifier.identifier_key) === targetKey;
        });

        if (existingRelatedIndex !== -1) {
          this.form.custom_identifiers[existingRelatedIndex].identifier_value = targetValue;
          this.$set(this.customIdentifierValueSearchText, existingRelatedIndex, targetValue);
          return;
        }

        this.form.custom_identifiers.push({
          identifier_key: targetKey,
          identifier_value: targetValue
        });
      });
    },
    async fetchCustomIdentifierOptions(property_id) {
      try {
        this.resetCustomIdentifierSchemaState();

        const response = await this.axios.post(window.hostname + '/api/auth/permit/custom-identifier-options', {
          property_id,
        });

        if (!response || !response.data || !response.data.status) {
          this.$toasted.show('Custom identifier schema could not be loaded. Identifier fields will allow manual entry until it is available.', {
            icon: 'times-circle',
            className: 'error-class'
          });
          return;
        }

        const payload = normalizePermitCustomIdentifierOptionsPayload(response.data.data || {});
        this.customIdentifierKeyDefinitions = payload.keyDefinitions || {};
        this.customIdentifierKeyOptions = payload.keyOptions || [];
        this.customIdentifierValueOptions = payload.valueOptions || {};
        this.customIdentifierRelationships = payload.relationships || {};
      } catch (error) {
        this.resetCustomIdentifierSchemaState();
        console.error('Failed to fetch custom identifier options:', error);
        this.$toasted.show('Custom identifier schema could not be loaded. Identifier fields will allow manual entry until it is available.', {
          icon: 'times-circle',
          className: 'error-class'
        });
      }
    },
    setVehicleAllow(status) {
      this.allow_all_vehicle = status;
      if (this.allow_all_vehicle) {
        this.form.vehicle_count = '';
      } else if (this.form.vehicle_count == '') {
        this.form.vehicle_count = 1;
      }
    },
    sendSubscription() {
      if (this.status != 4) {
        this.$toasted.show("This property is not verified yet!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      if (this.form.first_name == "" && this.form.existing_customer == false && !this.form.pied_managed) {
        this.$toasted.show("First Name is required!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      let alpha = window.regularExpressions.name;
      if (!alpha.test(this.form.first_name.trim()) && this.form.existing_customer == false && !this.form.pied_managed) {
        this.$toasted.show("First Name field can only have alphabets!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      if (this.form.first_name == "" && this.form.pied_managed) {
        this.$toasted.show("First Name is required for Pied managed accounts!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      if (!alpha.test(this.form.first_name.trim()) && this.form.pied_managed) {
        this.$toasted.show("First Name field can only have alphabets!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      if (this.form.last_name == "" && this.form.existing_customer == false && !this.form.pied_managed) {
        this.$toasted.show("Last Name is required!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      if (!alpha.test(this.form.last_name.trim()) && this.form.existing_customer == false && !this.form.pied_managed) {
        this.$toasted.show("Last Name field can only have alphabets!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      if (this.form.last_name == "" && this.form.pied_managed) {
        this.$toasted.show("Last Name is required for Pied managed accounts!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      if (!alpha.test(this.form.last_name.trim()) && this.form.pied_managed) {
        this.$toasted.show("Last Name field can only have alphabets!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      if (this.form.email == "") {
        this.$toasted.show("Email is required!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      if (!this.allow_all_vehicle) {
        if (isNaN(this.form.vehicle_count) || this.form.vehicle_count < 1) {
          this.$toasted.show("Please provide a valid vehicle count!", {
            icon: 'times-circle',
            className: 'error-class'
          });
          return;
        }
      }

      if (this.form.permit_id == "") {
        this.$toasted.show("Please select a permit!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }

      const vehicleValidation = this.validateVehicles();
      if (!vehicleValidation.valid) {
        this.$toasted.show(vehicleValidation.message, {
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      const customIdentifierValidation = this.validateCustomIdentifiers();
      if (!customIdentifierValidation.valid) {
        this.$toasted.show(customIdentifierValidation.message, {
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      if (this.form.backdate_subscription && this.isBackdateSubscriptionLocked && !this.getBackdateStartDateTemplateForPermit(this.form.permit_id)) {
        this.$toasted.show("This permit requires a configured backdate template before it can be assigned.", {
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      if (this.form.backdate_subscription && !this.isBackdateSubscriptionLocked && this.form.backdate_start_date == '') {
        this.$toasted.show("Please provide a backdate to start the subscription!", {
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      if (this.form.custom_enddate_subscription && this.form.custom_end_date == '') {
        this.$toasted.show("Please provide a custom end date to start the subscription!", {
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      let form = JSON.parse(JSON.stringify(this.form));
      form.vehicles = (form.vehicles || []).map((vehicle) => ({
        country_code: vehicle.country_code || '',
        state: vehicle.state || '',
        region_code: vehicle.country_code && vehicle.state ? `${vehicle.country_code}-${vehicle.state}` : (vehicle.country_code || ''),
        license_plate: vehicle.license_plate ? String(vehicle.license_plate).trim() : ''
      }));
      form.backdate_subscription = form.backdate_subscription ? 1 : 0;
      form.backdate_start_date = form.backdate_start_date && form.backdate_start_date != '' ? this.$moment(form.backdate_start_date).utc().format() : '';

      form.custom_enddate_subscription = form.custom_enddate_subscription ? 1 : 0;
      form.custom_end_date = form.custom_end_date && form.custom_end_date != '' ? this.$moment(form.custom_end_date).utc().format() : '';

      this.button.disabled = true;
      this.button.loading = true;
      this.button.success = false;
      this.axios
        .post(window.hostname + "/api/auth/permit/subscribe", form)
        .then((res) => {
          if (res.data.status) {
            this.$toasted.show(res.data.message, {
              icon: "check-circle",
              className: "success-class",
            });
            this.check_msg = "";
            this.form.first_name = "";
            this.form.last_name = "";
            this.form.email = "";
            this.form.permit_id = "";
            this.resetVehicles();
            this.resetCustomerIdentifiers();
            this.button.disabled = false;
            this.button.loading = false;
            this.button.success = false;

            if (res.data.response_type == 2) {

              this.toggleComponentKey += 1;
              this.toggleBackdateComponentKey += 1;
              this.toggleCustomEndDateComponentKey += 1;
              //this.showForm= true;
              this.showBackDate = false;
              this.form.existing_customer = false;
              this.form.vehicle_count = 1;
              this.allow_all_vehicle = false;
              this.approved_application_page = 1;
              this.approved_application_load_more = false;
              //this.showApprovedSubscriptionDetails();
              this.approved_applications = [];
              this.approvedApplications();

            } else {
              this.changeTopFilter(1);
            }
          } else {
            this.$toasted.show(res.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
            this.button.disabled = false;
            this.button.loading = false;
            this.button.success = false;
            return;
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.data && err.response.data.message) {
            this.$toasted.show(err.response.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
          }
          this.button.disabled = false;
          this.button.loading = false;
          this.button.success = false;
          return;
        });
    },
    cancelPreviousRequest(sourceDict, sourceKey) {
        if (sourceDict[sourceKey]) {
            sourceDict[sourceKey].cancel("Cancel previous request");
        }

        return sourceDict[sourceKey] = this.axios.CancelToken.source();
    },
    markPermit(approved_permit_details, mark_key, mark_value) {
        this.closeDropdown();
        this.axios.post(window.hostname + "/api/auth/permit/subscription-mark", {
          application_id: (approved_permit_details || {})['application_id'],
          mark_key: mark_key,
          mark_value: mark_value,
          device_type: 1,
          commercial: 1,
        }, {
          cancelToken: null //cancelToken
        }).then(res => {
            if (res.data.status) {
              this.approved_permit_marks[mark_key] = mark_value;
              this.$toasted.show("Permit has been marked!", {
                icon: "check-circle",
                className: "success-class",
              });
            } else {
              this.$toasted.show(res.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            }
          })
          .catch(err => {
            if (this.axios.isCancel(err)) {
              return;
            }
            
            console.error(err);
            
            this.$toasted.show("There was an unexpected error...", {
              icon: "times-circle",
              className: "error-class",
            });
          });
    },
    sendPermitMemo() {
      if (this.memoData.type == "") {
        this.$toasted.show("Please select a permit!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      this.showSendPermitMemo = false;
      this.axios.post(window.hostname + "/api/auth/permit/permit-memo-email", {
        memo_type: this.memoData.type,
        device_type: 1,
        permit_id: (this.approved_permit_details || {})['permit_id'],
        permit_instance_id: (this.approved_permit_details || {})['application_id'],
        permit_send_enabled: this.memoData.enabled ? '1' : '0',
        permit_send_only_unsent: this.memoData.unsent ? '1' : '0',
        permit_send_only_no_response: this.memoData.no_response ? '1' : '0',
      }, {
        cancelToken: null //cancelToken
      }).then(res => {
          if (res.data.status) {
            this.$toasted.show("Email is being delivered!", {
              icon: "check-circle",
              className: "success-class",
            });
          } else {
            this.$toasted.show(res.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
          }
        })
        .catch(err => {
          if (this.axios.isCancel(err)) {
            return;
          }
          
          console.error(err);
          
          this.$toasted.show("There was an unexpected error...", {
            icon: "times-circle",
            className: "error-class",
          });
        });
    },
    sendEmail(approved_permit_details, template_id, cb = (() => {})) {
    //   const cancelToken = this.cancelPreviousRequest(this.approved_permit_details_sources, 'sendEmail');

      this.axios.post(window.hostname + "/api/auth/permit/subscription-email", {
        application_id: (approved_permit_details || {})['application_id'],
        property_id: this.property_id,
        template_id: template_id,
        device_type: 1,
        commercial: 1,
      }, {
        cancelToken: null //cancelToken
      }).then(res => {
          if (res.data.status) {
            cb();
            this.$toasted.show("Email is being delivered!", {
              icon: "check-circle",
              className: "success-class",
            });
          } else {
            this.$toasted.show(res.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
          }
        })
        .catch(err => {
          if (this.axios.isCancel(err)) {
            return;
          }
          
          console.error(err);
          
          this.$toasted.show("There was an unexpected error...", {
            icon: "times-circle",
            className: "error-class",
          });
        });
    },
    getMemoParametersIfAny() {
      if (this.approved_application_type === 'memo') {
        return {
          memo_type: this.approved_application_filters['memo_type'],
          memo_filters: this.approved_application_filters['memo_filters'],
        }
      }
      
      return {};
    },
    prepareForApprovedApplications(type = null, filters = null, page = null) {
      if (this.approved_application_source) {
        this.approved_application_source.cancel("Cancel previous request");
      }

      this.approved_application_source = this.axios.CancelToken.source();
      this.approved_application_loader = true;
      
      if (type !== null) {
        this.approved_application_type = type;
      }

      if (filters !== null) {
        this.approved_application_filters = filters;
      }
      
      if (page !== null) {
        this.approved_application_page = page;
      }
    },
    approvedApplications(type = null, filters = null, page = null) {
      this.closeDropdown();
      this.prepareForApprovedApplications(type, filters, page);
      
      if (this.approved_application_source) {
        this.approved_application_source.cancel("Cancel previous request");
      }
      
      const CancelToken = this.axios.CancelToken;
      
      this.approved_application_source = CancelToken.source();
      this.approved_application_loader = true;
      
      this.axios.post(window.hostname + "/api/auth/permit/subscription-list", {
        type: this.approved_application_type,
        property_id: this.property_id,
        device_type: 1,
        commercial: 1,
        time_zone: this.$moment.tz.guess(),
        search: this.search,
        page: this.approved_application_page,
        ...this.getMemoParametersIfAny(),
      }, {
        cancelToken: this.approved_application_source.token
      })
        .then(res => {
          this.approved_application_loader = false;
          
          if (res.data.status) {
            this.approved_applications = res.data.data.subscription_list;
            this.approved_application_page++;
            this.approved_application_load_more = res.data.data.pagination.load_more;
            this.approved_applications.map((val) => {
              if (val.custom_identifiers.length > 0) {
                val.custom_identifiers.map((identifier) => {
                  this.approved_custom_identifiers_keys.push(identifier.key);
                });
              }
            });

            this.approved_custom_identifiers_keys = [...new Set(this.approved_custom_identifiers_keys)];
            this.showPermitRenewalResponses = this.getShouldShowPermitRenewalResponses();
          }
          else {
            this.approved_application_page = 1;
            this.approved_application_load_more = false;
            this.approved_applications = [];
            this.showPermitRenewalResponses = this.getShouldShowPermitRenewalResponses();
          }
        })
        .catch(err => {
          if (this.axios.isCancel(err)) {
            return;
          }
          else {
            this.approved_application_loader = false;
            this.approved_application_page = 1;
            this.approved_application_load_more = false;
            this.approved_applications = [];
          }
        });
    },
    async fetchApprovedApplicationsPage(type = '', page = 1, search = '') {
      const response = await this.axios.post(window.hostname + "/api/auth/permit/subscription-list", {
        type,
        property_id: this.property_id,
        device_type: 1,
        commercial: 1,
        time_zone: this.$moment.tz.guess(),
        search,
        page,
      });

      if (!response || !response.data || !response.data.status) {
        return null;
      }

      const data = response.data.data || {};
      return {
        list: Array.isArray(data.subscription_list) ? data.subscription_list : [],
        load_more: !!(data.pagination && data.pagination.load_more),
      };
    },
    async fetchDirectSubscriptionById(subscriptionId) {
      const response = await this.axios.post(
        window.hostname + "/api/auth/permit/subscription-show/" + encodeURIComponent(subscriptionId), {
          commercial: 1,
        }
      );

      if (!response || !response.data || !response.data.status) {
        return null;
      }

      const responseData = response.data.data || {};
      const directSubscription =
        this.findSubscriptionRecord(responseData, subscriptionId) ||
        this.findSubscriptionRecord(response.data, subscriptionId) ||
        responseData.subscription ||
        responseData.subscription_details ||
        responseData.subscription_detail ||
        responseData.data ||
        responseData;

      if (!directSubscription || typeof directSubscription !== 'object') {
        return null;
      }

      return directSubscription;
    },
    findSubscriptionRecord(payload, subscriptionId) {
      if (!payload) {
        return null;
      }

      if (Array.isArray(payload)) {
        for (let i = 0; i < payload.length; i += 1) {
          const found = this.findSubscriptionRecord(payload[i], subscriptionId);
          if (found) {
            return found;
          }
        }
        return null;
      }

      if (typeof payload !== 'object') {
        return null;
      }

      const normalizedTargetId = String(subscriptionId || '');
      const payloadSubscriptionId = String(
        payload.application_id ||
        payload.subscription_id ||
        payload.subscriptionId ||
        payload.permit_instance_id ||
        payload.id ||
        payload._id ||
        ''
      );

      if (payloadSubscriptionId === normalizedTargetId) {
        return payload;
      }

      const keys = Object.keys(payload);
      for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i];
        const value = payload[key];
        if (value && (typeof value === 'object' || Array.isArray(value))) {
          const found = this.findSubscriptionRecord(value, subscriptionId);
          if (found) {
            return found;
          }
        }
      }

      return null;
    },
    matchesDirectSubscription(approved, requestedId, requestedPermitId = '') {
      if (!approved || typeof approved !== 'object') {
        return false;
      }

      const normalizedRequestedId = String(requestedId || '');
      const normalizedRequestedPermitId = String(requestedPermitId || '');

      const candidateIds = [
        approved.application_id,
        approved.subscription_id,
        approved.subscriptionId,
        approved.permit_instance_id,
        approved.id,
        approved._id,
      ]
        .filter((value) => value !== undefined && value !== null)
        .map((value) => String(value));

      const sameId = candidateIds.includes(normalizedRequestedId);
      const samePermit = !normalizedRequestedPermitId || String(approved.permit_id || '') === normalizedRequestedPermitId;

      return sameId && samePermit;
    },
    normalizeApprovedDetails(rawApproved) {
      const approved = rawApproved && typeof rawApproved === 'object' ? { ...rawApproved } : {};
      const parkerName = String(approved.parker_name || '').trim();
      const parkerNameParts = parkerName ? parkerName.split(/\s+/) : [];

      if (!approved.first_name && parkerNameParts.length > 0) {
        approved.first_name = parkerNameParts[0];
      }

      if (!approved.last_name && parkerNameParts.length > 1) {
        approved.last_name = parkerNameParts.slice(1).join(' ');
      }

      if (!approved.email && approved.parker_email) {
        approved.email = approved.parker_email;
      }

      if (!approved.first_name && approved.user && approved.user.first_name) {
        approved.first_name = approved.user.first_name;
      }

      if (!approved.last_name && approved.user && approved.user.last_name) {
        approved.last_name = approved.user.last_name;
      }

      if (!approved.email && approved.user && approved.user.email) {
        approved.email = approved.user.email;
      }

      if (!approved.permit_id && this.pendingDirectPermitId) {
        approved.permit_id = this.pendingDirectPermitId;
      }

      if (!approved.subscription_id && this.pendingDirectSubscriptionId) {
        approved.subscription_id = this.pendingDirectSubscriptionId;
      }

      if (!approved.application_id) {
        approved.application_id =
          approved.id ||
          approved.permit_instance_id ||
          approved.subscription_instance_id ||
          (approved.application && (approved.application.id || approved.application.application_id)) ||
          '';
      }

      if (!approved.user_id) {
        approved.user_id =
          approved.customer_id ||
          approved.parker_id ||
          (approved.user && (approved.user.id || approved.user.user_id)) ||
          '';
      }

      if (!approved.permit_name && approved.permit && approved.permit.permit_name) {
        approved.permit_name = approved.permit.permit_name;
      }

      approved.vehicle = approved.vehicle && typeof approved.vehicle === 'object'
        ? approved.vehicle
        : {
            license_no: '',
            vin_id: '',
            country_code: '',
            state: '',
          };

      approved.card = approved.card && typeof approved.card === 'object'
        ? approved.card
        : {
            brand: '',
            last4_digit: '',
            exp_month: '',
            exp_year: '',
          };

      approved.custom_identifiers = Array.isArray(approved.custom_identifiers)
        ? approved.custom_identifiers
        : [];

      return approved;
    },
    async openDirectSubscriptionDetails() {
      const preloaded = this.pendingPreloadedSubscription && typeof this.pendingPreloadedSubscription === 'object'
        ? this.pendingPreloadedSubscription
        : null;
      const preloadedSubscriptionId = String((preloaded && preloaded.subscription_id) || '');
      const preloadedPermitId = String((preloaded && preloaded.permit_id) || '');

      const directSubscriptionId = String(this.pendingDirectSubscriptionId || preloadedSubscriptionId || '');
      const directPermitId = String(this.pendingDirectPermitId || preloadedPermitId || '');
      this.directDetailLoading = true;

      if (!directSubscriptionId || !this.property_id) {
        this.directDetailLoading = false;
        return;
      }

      const currentMatch = (this.approved_applications || []).find((item) => {
        return this.matchesDirectSubscription(item, directSubscriptionId, directPermitId);
      });

      if (currentMatch) {
        this.pendingDirectSubscriptionId = '';
        this.pendingDirectPermitId = '';
        this.directDetailLoading = false;
        this.showApprovedSubscriptionDetails(currentMatch);
        return;
      }

      try {
        let directSubscription = await this.fetchDirectSubscriptionById(directSubscriptionId);
        if (!directSubscription && preloaded) {
          directSubscription = preloaded;
        }

        if (directSubscription) {
          const normalizedDirect = this.normalizeApprovedDetails(directSubscription);
          if (this.matchesDirectSubscription(normalizedDirect, directSubscriptionId, directPermitId)) {
            this.approved_applications = [normalizedDirect];
            this.approved_application_page = 2;
            this.approved_application_load_more = false;
            this.pendingDirectSubscriptionId = '';
            this.pendingDirectPermitId = '';
            this.pendingPreloadedSubscription = null;
            this.directDetailLoading = false;
            this.showApprovedSubscriptionDetails(normalizedDirect);
            return;
          }
        }

        this.$toasted.show('Subscription details could not be found in Permit Customers.', {
          icon: 'times-circle',
          className: 'error-class',
        });
        this.pendingPreloadedSubscription = null;
        this.directDetailLoading = false;
      } catch (error) {
        this.$toasted.show('Subscription details could not be loaded.', {
          icon: 'times-circle',
          className: 'error-class',
        });
        this.pendingPreloadedSubscription = null;
        this.directDetailLoading = false;
      }
    },
    approvedPaginate($state) {
      this.prepareForApprovedApplications();
      this.approved_application_loader = true;
      this.axios.post(window.hostname + "/api/auth/permit/subscription-list", {
        type: this.approved_application_type,
        property_id: this.property_id,
        device_type: 1,
        commercial: 1,
        time_zone: this.$moment.tz.guess(),
        search: this.search,
        page: this.approved_application_page,
        ...this.getMemoParametersIfAny(),
      }, {
        cancelToken: this.approved_application_source.token
      })
        .then(res => {
          this.approved_application_loader = false;
          if (res.data.status) {
            let approved_applications = res.data.data.subscription_list;
            approved_applications.map((val) => {
              this.approved_applications.push(val);

              if (val.custom_identifiers.length > 0) {
                val.custom_identifiers.map((identifier) => {
                  this.approved_custom_identifiers_keys.push(identifier.key);
                });
              }

            });
            this.approved_custom_identifiers_keys = [...new Set(this.approved_custom_identifiers_keys)];
            this.approved_application_page++;
            this.approved_application_load_more = res.data.data.pagination.load_more;
            if (this.approved_application_load_more) {
              $state.loaded();

            } else {
              $state.complete();
            }
          } else {
            this.approved_application_page = 1;
            this.approved_application_load_more = false;
            this.approved_applications = [];
            $state.complete();
          }
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            return;
          } else {
            this.approved_application_loader = false;
            this.approved_application_page = 1;
            this.approved_application_load_more = false;
            this.approved_applications = [];
            $state.error();
          }
        });
    },
    uploadCSV(event) {
      let input = this.$refs.csvFileInput;
      if (this.status != 4) {
        this.$toasted.show("This property is not verified yet!", {
          icon: "times-circle",
          className: "error-class",
        });
        this.csv_name = "";
        input.type = "text";
        input.type = "file";
        return;
      }

      let mimes = [
        "text/comma-separated-values",
        "text/csv",
        "application/csv",
        "application/excel",
        "application/vnd.ms-excel",
        "application/vnd.msexcel",
        "text/anytext",
        "csv",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ""
      ];
      // console.log(event.target.files[0].type);
      if (
        event.target.files.length > 0 &&
        mimes.indexOf(event.target.files[0].type) != -1
      ) {
        if (event.target.files[0].size <= 5 * 1024 * 1024) {
          // 5MB
          this.csv_name = event.target.files[0].name;
          this.csv_name = this.csv_name.split(".csv")[0];

          this.formData = new FormData();
          this.formData.append("property_id", this.property_id);
          this.formData.append("csv", event.target.files[0]);
          this.csv_uploading = true;
          this.axios
            .post(
              window.hostname + "/api/auth/permit/upload-csv",
              this.formData
            )
            .then((res) => {
              if (res.data.status) {
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                this.csv_name = "";
                input.type = "text";
                input.type = "file";
                this.approved_application_page = 1;
                this.approved_application_load_more = false;
                this.approved_applications = [];
                this.approvedApplications();

              } else {
                this.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
                this.csv_name = "";
                input.type = "text";
                input.type = "file";
                this.approved_application_page = 1;
                this.approved_application_load_more = false;
                this.approved_applications = [];
                this.approvedApplications();
              }
              this.csv_uploading = false;
            })
            .catch((err) => {
              this.csv_name = "";
              this.csv_uploading = false;
              input.type = "text";
              input.type = "file";
              this.$toasted.show("Something went wrong. Please try again!", {
                icon: "times-circle",
                className: "error-class",
              });
            });
        } else {
          this.$toasted.show("CSV file size can not exceed 5MB!", {
            icon: "times-circle",
            className: "error-class",
          });
          this.csv_name = "";
          input.type = "text";
          input.type = "file";
        }
      } else {
        this.$toasted.show("Please upload a valid CSV file!", {
          icon: "times-circle",
          className: "error-class",
        });
        this.csv_name = "";
        input.type = "text";
        input.type = "file";
      }
    },
    showApprovedSubscriptionDetails(approved) {
      this.approved_permit_details = this.normalizeApprovedDetails(approved);
      this.approved_permit_marks = approved.permit_marks || {};
      this.resetOffstreetSubscriptionState();
      this.showApprovedPermitVehicleForm = false;
      this.approvedPermitVehicleSubmitting = false;
      this.resetApprovedPermitVehicleForms();
      // console.log(this.approved_permit_details);
      if (this.approved_permit_details.old_price_expires_on != '') {
        let expired_price = this.$moment(this.approved_permit_details.old_price_expires_on);
        let subscription_to = this.$moment(this.approved_permit_details.subscription_end);
        console.log(this.$moment(subscription_to).diff(expired_price, 'days'));
        if (this.$moment(subscription_to).diff(expired_price, 'days') > 0) {
          this.approved_permit_details.previous_price_breakdown = this.approved_permit_details.price_breakdown || {};
        }
      }
      else {
        this.approved_permit_details.previous_price_breakdown = this.approved_permit_details.price_breakdown || {};
      }
      this.showCustomerDetails = true;
      this.showPendingCustomerDetails = false;
      this.getSessions();
      this.getSubscriptionDetails();
      if (this.shouldShowOffstreetSection()) {
        this.fetchOffstreetSubscriptionDetails();
      } else {
        this.resetOffstreetStatusState();
      }
    },
    getSubscriptionDetails() {
      this.subscriptionCancelDetails = {};

      const applicationId = this.approved_permit_details && this.approved_permit_details['application_id'];
      if (!applicationId) {
        return;
      }

      this.axios
        .post(window.hostname + `/api/auth/permit/subscription-show/${applicationId}`, {
          commercial: 1,
        })
        .then(response => {
          if (response.data.status) {
            const detailData = response.data.data || {};
            this.subscriptionCancelDetails = detailData;
            this.approved_permit_details = this.normalizeApprovedDetails({
              ...this.approved_permit_details,
              ...detailData,
            });
          }
        })
        .catch(error => {

        })
    },
    getApprovedDisplayName() {
      const approved = this.approved_permit_details || {};
      const firstName = String(approved.first_name || '').trim();
      const lastName = String(approved.last_name || '').trim();
      const parkerName = String(approved.parker_name || '').trim();

      if (firstName || lastName) {
        return `${firstName} ${lastName}`.trim();
      }

      if (parkerName) {
        return parkerName;
      }

      if (approved.user_id) {
        return `User ${approved.user_id}`;
      }

      return 'Unknown User';
    },
    getApprovedDisplayEmail() {
      const approved = this.approved_permit_details || {};
      return approved.email || approved.parker_email || 'N/A';
    },
    extractOffstreetApiData(response) {
      if (!response || !response.data) {
        return {};
      }
      return response.data.data || response.data || {};
    },
    resetOffstreetSubscriptionState() {
      this.offstreetStatusLoading = false;
      this.offstreetStatusError = "";
      this.offstreetStatusRow = null;
      this.offstreetStatusSummary = {
        total: 0,
        synced: 0,
        failed: 0,
        voided: 0,
        unsynced: 0,
        needs_recreate: 0,
      };
      this.offstreetRecreateLoading = false;
    },
    normalizeOffstreetDateValue(value) {
      if (!value) {
        return null;
      }

      if (typeof value === "string" || typeof value === "number") {
        return value;
      }

      if (value.$date !== undefined) {
        const dateValue = value.$date;
        if (typeof dateValue === "string" || typeof dateValue === "number") {
          return dateValue;
        }
        if (dateValue && dateValue.$numberLong !== undefined) {
          return Number(dateValue.$numberLong);
        }
      }

      if (value.$numberLong !== undefined) {
        return Number(value.$numberLong);
      }

      return value;
    },
    normalizeOffstreetStatusRow(row) {
      if (!row) {
        return null;
      }

      return {
        ...row,
        offstreet_created_at: this.normalizeOffstreetDateValue(row.offstreet_created_at),
        offstreet_last_updated_at: this.normalizeOffstreetDateValue(row.offstreet_last_updated_at),
        offstreet_voided_at: this.normalizeOffstreetDateValue(row.offstreet_voided_at),
        offstreet_last_failed_at: this.normalizeOffstreetDateValue(row.offstreet_last_failed_at),
        offstreet_recreate_requested_at: this.normalizeOffstreetDateValue(row.offstreet_recreate_requested_at),
        offstreet_recreate_attempted_at: this.normalizeOffstreetDateValue(row.offstreet_recreate_attempted_at),
        offstreet_recreate_failed_at: this.normalizeOffstreetDateValue(row.offstreet_recreate_failed_at),
      };
    },
    formatOffstreetDate(dateText) {
      if (!dateText) {
        return "-";
      }
      return this.$moment(dateText).format("YYYY-MM-DD HH:mm");
    },
    offstreetSyncStatusClass(status) {
      const normalized = String(status || "").toLowerCase();
      if (normalized === "synced") {
        return "status-success";
      }
      if (normalized === "failed") {
        return "status-danger";
      }
      if (normalized === "voided") {
        return "status-neutral";
      }
      if (normalized === "unsynced") {
        return "status-subdued";
      }
      return "status-subdued";
    },
    async fetchOffstreetSubscriptionDetails() {
      const permitId = this.approved_permit_details && this.approved_permit_details.permit_id;
      const subscriptionId = this.approved_permit_details && this.approved_permit_details.subscription_id;

      this.offstreetStatusLoading = true;
      this.offstreetStatusError = "";
      this.offstreetStatusRow = null;

      if (!permitId || !subscriptionId) {
        this.offstreetStatusLoading = false;
        this.offstreetStatusError = "Permit or subscription id is missing.";
        return;
      }

      try {
        const perPage = 200;
        let page = 1;
        let lastPage = 1;
        let foundRow = null;

        while (page <= lastPage) {
          const response = await fetchOffstreetSubscriptionSyncStatus({
            permit_id: permitId,
            filter: "all",
            page,
            per_page: perPage,
          });
          const data = this.extractOffstreetApiData(response);
          const summary = data.summary || {};
          this.offstreetStatusSummary = {
            total: Number(summary.total) || 0,
            synced: Number(summary.synced) || 0,
            failed: Number(summary.failed) || 0,
            voided: Number(summary.voided) || 0,
            unsynced: Number(summary.unsynced) || 0,
            needs_recreate: Number(summary.needs_recreate) || 0,
          };

          const records = data.subscriptions || data.records || data.subscription_records || data.subscription_sync_status || data.list || [];
          foundRow = Array.isArray(records)
            ? records.find((row) => String((row || {}).subscription_id || "") === String(subscriptionId))
            : null;

          if (foundRow) {
            break;
          }

          const pagination = data.pagination || {};
          lastPage = Number(pagination.last_page) || 1;

          if (!Array.isArray(records) || records.length === 0) {
            break;
          }

          page += 1;
        }

        this.offstreetStatusRow = this.normalizeOffstreetStatusRow(foundRow);
        if (!this.offstreetStatusRow) {
          this.offstreetStatusError = "No Offstreet status record was found for this subscription.";
        }
      } catch (error) {
        this.offstreetStatusError = (error && error.response && error.response.data && error.response.data.message)
          ? error.response.data.message
          : "Unable to load Offstreet status.";
      } finally {
        this.offstreetStatusLoading = false;
      }
    },
    async recreateApprovedOffstreetSubscription() {
      const subscriptionId = this.approved_permit_details && this.approved_permit_details.subscription_id;
      const permitId = this.approved_permit_details && this.approved_permit_details.permit_id;

      if (!subscriptionId || !permitId) {
        return;
      }

      this.offstreetRecreateLoading = true;
      try {
        const response = await recreateOffstreetSubscription({
          subscription_id: subscriptionId,
          permit_id: permitId,
          async: true,
        });
        this.$toasted.show((response.data && response.data.message) || "Recreate request submitted.", {
          icon: "check-circle",
          className: "success-class",
        });
        this.fetchOffstreetSubscriptionDetails();
      } catch (error) {
        this.$toasted.show(
          (error && error.response && error.response.data && error.response.data.message)
            ? error.response.data.message
            : "Unable to recreate Offstreet subscription.",
          {
            icon: "times-circle",
            className: "error-class",
          }
        );
      } finally {
        this.offstreetRecreateLoading = false;
      }
    },
    confirmRecreateApprovedOffstreetSubscription() {
      this.$swal({
        title: "Recreate subscription",
        text: "Are you sure you want to recreate this Offstreet subscription?",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.recreateApprovedOffstreetSubscription();
        }
      });
    },
    openApprovedOffstreetManagement() {
      this.$modal.show("offstreet-permit-management", {
        permit: {
          permit_id: this.approved_permit_details.permit_id,
          permit_name: this.approved_permit_details.permit_name,
          offstreet_syncable: this.approved_permit_details.offstreet_syncable,
          offstreet_location_id: this.approved_permit_details.offstreet_location_id,
          offstreet: this.approved_permit_details.offstreet || {},
        },
      });
    },
    getSessions() {
      if (this.session_source) {
        this.session_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.session_source = CancelToken.source();
      this.session_loader = true;
      this.session_page = 1;
      this.session_list = [];
      this.session_load_more = false;

      this.axios
        .post(
          window.hostname + "/api/auth/booking",
          {
            page: this.session_page,
            space_id: this.property_id,
            mode: "show-booking",
            booking_for: "owner",
            booking_type: 1,
            session_type: this.session_type,
            filter: 0,
            search_param: this.session_search,
            booking_user_id: this.approved_permit_details.user_id,
            time_zone: this.$moment.tz.guess(new Date()),
            start_date: "",
            end_date: "",
          },
          {
            cancelToken: this.session_source.token,
          }
        )
        .then(res => {
          this.session_loader = false;
          if (res.data.status) {
            this.session_list = res.data.data.booking_details;
            this.session_page++;
            this.session_load_more = res.data.data.pagination.load_more == 1 ? true : false;
          }
          else {
            this.session_load_more = false;
            this.session_list = [];
          }
        })
        .catch(err => {
          this.session_list = [];
          this.session_loader = false;
          this.session_load_more = false;
        });
    },
    paginateSession($state) {
      if (this.session_source) {
        this.session_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.session_source = CancelToken.source();

      this.axios
        .post(
          window.hostname + "/api/auth/booking",
          {
            page: this.session_page,
            space_id: this.property_id,
            mode: "show-booking",
            booking_for: "owner",
            booking_type: 1,
            session_type: this.session_type,
            filter: 0,
            search_param: this.session_search,
            booking_user_id: this.approved_permit_details.user_id,
            time_zone: this.$moment.tz.guess(new Date()),
            start_date: "",
            end_date: "",
          },
          {
            cancelToken: this.session_source.token,
          }
        )
        .then(res => {
          this.session_loader = false;
          if (res.data.status) {
            let session_list = res.data.data.booking_details;
            session_list.map(val => {
              this.session_list.push(val);
            });

            this.session_page++;
            this.session_load_more = res.data.data.pagination.load_more == 1 ? true : false;

            if (this.session_load_more) {
              $state.loaded();
            }
            else {
              $state.complete();
            }
          }
          else {
            this.session_load_more = false;
            this.session_list = [];
            $state.complete();
          }
        })
        .catch(err => {
          $state.error();
          this.session_list = [];
          this.session_loader = false;
          this.session_load_more = false;
        });
    },
    getApprovedPermitVehicles() {
      const vehicles = this.approved_permit_details && Array.isArray(this.approved_permit_details.vehicles)
        ? this.approved_permit_details.vehicles.filter((vehicle) => vehicle)
        : [];

      if (vehicles.length > 0) {
        return vehicles;
      }

      if (this.approved_permit_details && this.approved_permit_details.vehicle) {
        return [this.approved_permit_details.vehicle];
      }

      return [];
    },
    getApprovedPermitVehicleState(vehicle) {
      if (!vehicle) {
        return '';
      }

      return vehicle.state_full_name || vehicle.state || vehicle.country_code || vehicle.country || '';
    },
    getApprovedPermitVehicleIdentifier(vehicle) {
      if (!vehicle) {
        return 'N/A';
      }

      if (vehicle.license_no) {
        return vehicle.license_no;
      }

      if (vehicle.license_plate) {
        return vehicle.license_plate;
      }

      if (vehicle.license_id) {
        return vehicle.license_id;
      }

      if (vehicle.vin_id) {
        return String(vehicle.vin_id).toUpperCase();
      }

      return 'N/A';
    },
    getApprovedPermitVehicleId(vehicle) {
      if (!vehicle) {
        return '';
      }

      return vehicle.vehicle_id || vehicle.id || '';
    },
    getApprovedPermitVehicleIdentifierClass(vehicle) {
      const identifier = this.getApprovedPermitVehicleIdentifier(vehicle);
      const identifierLength = identifier ? String(identifier).length : 0;

      if (identifierLength >= 14) {
        return 'permit-vehicle-identifier--wrap';
      }

      if (identifierLength >= 12) {
        return 'permit-vehicle-identifier--xs';
      }

      if (identifierLength >= 10) {
        return 'permit-vehicle-identifier--sm';
      }

      return '';
    },
    attachApprovedPermitVehicle() {
      const validation = this.validateApprovedPermitVehicleForms();
      if (!validation.valid) {
        this.$toasted.show(validation.message, {
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      if (!this.approved_permit_details || !this.approved_permit_details.user_id || !this.approved_permit_details.application_id) {
        this.$toasted.show('Unable to determine the permit customer details needed to attach vehicles.', {
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      const vehiclePayloads = validation.vehicles.map((vehicle) => ({
        country_code: vehicle.country_code,
        state: vehicle.state,
        region_code: `${vehicle.country_code}-${vehicle.state}`,
        license_plate: vehicle.license_plate
      }));

      this.approvedPermitVehicleSubmitting = true;
      this.axios.post(window.hostname + '/api/auth/permit/attach-vehicle', {
        user_id: this.approved_permit_details.user_id,
        application_id: this.approved_permit_details.application_id,
        vehicles: vehiclePayloads
      })
        .then((res) => {
          if (res.data.status) {
            const responseVehicles = res.data.data && Array.isArray(res.data.data.vehicles)
              ? res.data.data.vehicles
              : (res.data.data && res.data.data.vehicle ? [res.data.data.vehicle] : []);
            const existingVehicles = Array.isArray(this.approved_permit_details.vehicles)
              ? [...this.approved_permit_details.vehicles]
              : this.getApprovedPermitVehicles();

            this.$set(this.approved_permit_details, 'vehicles', [...existingVehicles, ...responseVehicles]);
            this.closeApprovedPermitVehicleForm();
            this.$toasted.show(res.data.message || 'Vehicle attached successfully!', {
              icon: 'check-circle',
              className: 'success-class'
            });
          } else {
            this.$toasted.show(res.data.message || 'Unable to attach vehicle.', {
              icon: 'times-circle',
              className: 'error-class'
            });
          }
        })
        .catch((err) => {
          const message = err && err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unable to attach vehicle.';
          this.$toasted.show(message, {
            icon: 'times-circle',
            className: 'error-class'
          });
        })
        .finally(() => {
          this.approvedPermitVehicleSubmitting = false;
        });
    },
    detachApprovedPermitVehicle(vehicle) {
      const vehicleId = this.getApprovedPermitVehicleId(vehicle);
      if (!vehicleId) {
        this.$toasted.show('This vehicle cannot be removed because it does not have a vehicle id yet.', {
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      if (!this.approved_permit_details || !this.approved_permit_details.user_id || !this.approved_permit_details.application_id) {
        this.$toasted.show('Unable to determine the permit customer details needed to remove this vehicle.', {
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      this.$swal({
        title: 'Remove vehicle?',
        text: `Do you want to remove ${this.getApprovedPermitVehicleIdentifier(vehicle)} from this permit customer?`,
        showCancelButton: true,
      }).then((result) => {
        if (!result.value) {
          return;
        }

        this.axios.post(window.hostname + '/api/auth/permit/detach-vehicle', {
          user_id: this.approved_permit_details.user_id,
          application_id: this.approved_permit_details.application_id,
          vehicle_id: vehicleId,
        })
          .then((res) => {
            if (res.data.status) {
              const nextVehicles = this.getApprovedPermitVehicles().filter((item) => this.getApprovedPermitVehicleId(item) !== vehicleId);
              this.$set(this.approved_permit_details, 'vehicles', nextVehicles);
              this.$toasted.show(res.data.message || 'Vehicle removed successfully!', {
                icon: 'check-circle',
                className: 'success-class'
              });
            } else {
              this.$toasted.show(res.data.message || 'Unable to remove vehicle.', {
                icon: 'times-circle',
                className: 'error-class'
              });
            }
          })
          .catch((err) => {
            const message = err && err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : 'Unable to remove vehicle.';
            this.$toasted.show(message, {
              icon: 'times-circle',
              className: 'error-class'
            });
          });
      });
    },
    changeSessionFilter(filter) {
      this.session_type = filter;
      this.getSessions();
    },
    getCreditcardLogo(card) {
      var image = require("@/assets/images/DebitCardImage/credit-card.png");
      try {
        image = require("@/assets/images/DebitCardImage/" + card + ".png");
      } catch (e) {
        image = require("@/assets/images/DebitCardImage/credit-card.png");
      }
      return image;
    },
    pauseSubscriptionAPIcall(application_id) {
        if(localStorage.getItem('admin_id')) {
            this.cancelled_by = localStorage.getItem('admin_id');
        } else if (localStorage.getItem('user_id')) {
            this.cancelled_by = localStorage.getItem('user_id');
        }

        this.button.loading = true;
        this.selected_option = 'now';
        this.axios
            .post(window.hostname + "/api/auth/permit/cancel", {
                // cancel_reason: this.cancel_reason,
                pause: 1,
                cancelled_by: this.cancelled_by,
                application_id: application_id,
                cancel_time: this.selected_option,
                // custom_date: this.selected_option== 'cancel_custom' ? this.$moment(this.custom_date).utc().format("YYYY-MM-DD HH:mm:ss") : null
            })
            .then(res=> {
                this.button.loading = false;
                if(res.data.status) {
                    this.button.success = true;
                    if(this.selected_option == 'cancel_custom'){
                        this.$toasted.show('Suspension of subscription is scheduled successfully', {
                            icon: 'check-circle',
                            className: 'success-class'
                        }); 
                    }
                    else{
                        this.$toasted.show(res.data.message, {
                            icon: 'check-circle',
                            className: 'success-class'
                        });
                    }

                    this.$emit('api-response', {
                        cancelled: true,
                        selected_option: this.selected_option,
                        end_date: res.data.end_date
                    });
                }
                else {
                    this.$toasted.show(res.data.message, {
                        icon: 'times-circle',
                        className: 'error-class'
                    });
                }
            })
            .catch(err=> {
                this.button.loading = false;
                this.$toasted.show(err.response.data.message, {
                    icon: 'times-circle',
                    className: 'error-class'
                });
            })
    },
    pauseSubscription(application_id) {
        this.$swal({
          title: "Suspend Subscription",
          text: "Are you sure you want to suspend this subscription?",
          showCancelButton: true,
        }).then((result) => {
          if (result.value) {
            this.pauseSubscriptionAPIcall(application_id);
          }
        });
    },
    unpauseSubscriptionAPIcall(application_id) {
        if(localStorage.getItem('admin_id')) {
            this.cancelled_by = localStorage.getItem('admin_id');
        } else if (localStorage.getItem('user_id')) {
            this.cancelled_by = localStorage.getItem('user_id');
        }

        this.button.loading = true;
        this.selected_option = 'now';
        this.axios
            .post(window.hostname + "/api/auth/permit/unpause", {
                application_id: application_id,
            })
            .then(res=> {
                this.button.loading = false;
                if(res.data.status) {
                  this.button.success = true;
                  this.$toasted.show(res.data.message, {
                      icon: 'check-circle',
                      className: 'success-class'
                  });
                } else {
                    this.$toasted.show(res.data.message, {
                        icon: 'times-circle',
                        className: 'error-class'
                    });
                }
            })
            .catch(err=> {
                this.button.loading = false;
                this.$toasted.show(err.response.data.message, {
                    icon: 'times-circle',
                    className: 'error-class'
                });
            })
    },
    unpauseSubscription(application_id) {
        this.$swal({
          title: "Unpause Subscription",
          text: "Are you sure you want to unpause this subscription?",
          showCancelButton: true,
        }).then((result) => {
          if (result.value) {
            this.unpauseSubscriptionAPIcall(application_id);
          }
        });
    },
    cancelSubscription(application_id) {
      this.$modal.show("cancel-subscription", {
        application_id: application_id,
        property_timezone: this.property_timezone,
      });
      this.processing = true;
    },
    finalizeCancellation(data) {
      // console.log(data);
      this.processing = false;

      if (data.cancelled) {
        this.approved_application_page = 1;
        this.approved_applications = [];
        this.approved_application_load_more = false;
        this.approvedApplications();
        // console.log(this.approved_permit_details);
        this.approved_permit_details.cancellation_status = true;

        if (data.selected_option == "now") {
          this.showCustomerDetails = false;
        } else {
          this.showCustomerDetails = false;
          this.approved_permit_details.subscription_end = this.$moment(
            data.end_date
          ).format("LL");
          this.approved_permit_details.cancellation_status = true;
        }
      }
    },
    cancelSubscriptionOld(application_id) {
      let message = "Do you want to cancel this subscription?";
      const self = this;
      this.$swal({
        title: "Are you sure?",
        text: message,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          self.cancelSubscriptionAPIcall(application_id);
        }
      });
    },
    async cancelSubscriptionAPIcall(application_id) {
      const { value: selected_data } = await this.$swal({
        title: "Cancel now or later?",
        html:
          "Do you want to cancel now or cancel at the end of subscription period?" +
          "<br>" +
          `
        <div class="row justify-content-center">
          <div class="col-sm-6 mt-2">
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="cancel_now" class="custom-control-input" name="cancel_time" value="now"><label for="cancel_now" class="custom-control-label">Cancel Now</label>
            </div>
          </div>
          <div class="col-sm-6 mt-2">
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="cancel_later" class="custom-control-input" name="cancel_time" value="period_end"><label for="cancel_later" class="custom-control-label">Cancel Later</label>
            </div>
          </div>
        </div>`,
        showCancelButton: true,
        showConfirmButton: true,
        preConfirm: () => {
          if (document.querySelector('input[name="cancel_time"]:checked')) {
            let selected_value = document.querySelector(
              'input[name="cancel_time"]:checked'
            ).value;

            if (selected_value) {
              return selected_value;
            } else {
              this.$toasted.show(
                "Please select one of the options listed above!",
                {
                  icon: "times-circle",
                  className: "error-class",
                }
              );
              return false;
            }
          } else {
            this.$toasted.show(
              "Please select one of the options listed above!",
              {
                icon: "times-circle",
                className: "error-class",
              }
            );
            return false;
          }
        },
      });

      if (selected_data != undefined) {
        this.approved_permit_details.cancellation_status = true;
        // this.customer.subscription_end = '';
        this.processing = true;

        this.axios
          .post(window.hostname + "/api/auth/permit/cancel", {
            application_id: application_id,
            cancel_time: selected_data,
          })
          .then((res) => {
            this.processing = false;
            if (res.data.status) {
              this.approved_application_page = 1;
              this.approved_applications = [];
              this.approved_application_load_more = false;
              this.approvedApplications();
              if (selected_data == "now") {
                this.showCustomerDetails = false;
              } else {
                this.approved_permit_details.subscription_end = this.$moment(
                  res.data.end_date
                ).format("LL");
                this.approved_permit_details.cancellation_status = true;
              }
              this.$toasted.show("Subscription cancelled successfully!", {
                icon: "check-circle",
                className: "success-class",
              });
            } else {
              this.approved_permit_details.cancellation_status = false;
              this.$toasted.show(res.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            }
          })
          .catch((err) => {
            this.processing = false;
            this.approved_permit_details.cancellation_status = false;
          });
      }
    },
    reinitateSubscription(application_id) {
      let message = "";
      const self = this;
      // console.log(self.approved_permit_details);
      if (self.approved_permit_details.cancel_custom && self.approved_permit_details.cancel_custom == 1) {
        message = "Do you want to unschedule this subscription for cancellation?";
      }
      else {
        message = "Do you want to reinitiate this subscription?";
      }

      this.$swal({
        title: "Are you sure?",
        text: message,
        showCancelButton: true,
      }).then((res) => {
        if (res.value) {
          self.approved_permit_details.cancellation_status = true;
          self.approved_permit_details.subscription_end = "";
          self.processing = true;
          self.axios
            .post(window.hostname + "/api/auth/permit/reinitiate", {
              application_id: application_id,
            })
            .then((res) => {
              self.processing = false;
              if (res.data.status) {
                self.approved_application_page = 1;
                self.approved_applications = [];
                self.approved_application_load_more = false;
                self.approvedApplications();
                self.approved_permit_details.subscription_end = self
                  .$moment(res.data.end_date)
                  .format("LL");
                self.approved_permit_details.cancellation_status = false;
                if (self.approved_permit_details.cancel_custom && self.approved_permit_details.cancel_custom == 1) {
                  self.$toasted.show("Subscription is unscheduled successfully!", {
                    icon: "check-circle",
                    className: "success-class",
                  });
                  self.approved_permit_details.cancel_custom = 0;

                }
                else {
                  self.$toasted.show("Subscription reinitated successfully!", {
                    icon: "check-circle",
                    className: "success-class",
                  });
                }

              } else {
                self.approved_permit_details.cancellation_status = true;
                self.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
              }
            })
            .catch((err) => {
              self.processing = false;
              self.approved_permit_details.cancellation_status = true;
              console.log(err);
            });
        }
      });
    },
    deleteSubscription(application_id) {
      let message = "Do you want to delete this subscription?";

      const self = this;
      this.$swal({
        title: "Are you sure?",
        text: message,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          self.processing = true;
          self.axios
            .post(window.hostname + "/api/auth/permit/delete-subscription", {
              application_id: application_id,
            })
            .then((res) => {
              self.processing = false;
              if (res.data.status) {
                self.approved_application_page = 1;
                self.approved_applications = [];
                self.approved_application_load_more = false;
                self.approvedApplications();
                self.showCardetails = null;
                self.$toasted.show("Subscription deleted successfully!", {
                  icon: "check-circle",
                  className: "success-class",
                });
              } else {
                self.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
              }
            })
            .catch((err) => {
              self.processing = false;
              console.log(err);
            });
        }
      });
    },
    copyText(id) {
      let testingCodeToCopy = document.querySelector("#" + id);
      testingCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      testingCodeToCopy.select();

      try {
        var successful = document.execCommand("copy");
        if (successful) {
          this.$toasted.show("Copied text!", {
            icon: "check-circle",
            className: "success-class",
          });
        }
      } catch (err) {
        this.$toasted.show("Oops! unable to copy.", {
          icon: "times-circle",
          className: "error-class",
        });
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    confirmAuthorizedApplicationDelete(application_id) {
      this.$swal({
        title: "Are you sure?",
        html: `<p class="txt--ss font-weight-bold txt--off-white" >Do you want to delete this application?</p>`,

        showCancelButton: true,
      })
        .then((result) => {
          if (result.value) {
            this.deleteAuthorizedApplication(application_id);
          }
        });
    },
    deleteAuthorizedApplication(application_id) {
      this.axios.post(window.hostname + '/api/auth/permit/delete-subscription', {
        application_id: application_id
      })
        .then(res => {
          if (res.data.status) {
            this.$toasted.show(res.data.message, {
              icon: 'check-circle',
              className: 'success-class'
            });
            this.approved_application_page = 1;
            this.approved_application_load_more = false;
            this.approved_applications = [];
            this.approvedApplications();
          }
          else {
            this.$toasted.show(res.data.message, {
              icon: 'times-circle',
              className: 'error-class'
            });
          }
        })
        .catch(err => {
          this.$toasted.show(err.response.data.message, {
            icon: 'times-circle',
            className: 'error-class'
          });
        })
    },
    exportPermitCustomers(type) {
      this.$toasted.show("Your file will be downloaded soon!", {
        icon: "check-circle",
        className: "success-class",
      });
      this.$Progress.start();
      this.percentLoader = true;

      this.axios
        .post(window.hostname + "api/auth/permit/export", {
          property_id: this.property_id,
          time_zone: this.$moment.tz.guess(),
          export_type: type
        })
        .then(res => {
          if (res.data.status) {
            let csv_donload_link = res.data.data.file_path;
            // let file_name = res.data.data.file_name ;
            var element = document.createElement("a");
            element.href = csv_donload_link;
            element.setAttribute("download", "Permit Holder.xlsx");

            element.style.display = "none";
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
            this.$toasted.show("Your file download has started!", {
              icon: "check-circle",
              className: "success-class",
            });
            this.$Progress.finish();
            this.percentLoader = false;
          } else {
            this.$Progress.fail();
            this.percentLoader = false;
            this.$toasted.show(
              "File download failed. Please try again later!",
              {
                icon: "times-circle",
                className: "error-class",
              }
            );
          }
        })
        .catch(err => {
          console.log(err.response.data.message);
          this.$Progress.fail();
          this.percentLoader = false;
          this.$toasted.show("File download failed. Please try again later!", {
            icon: "times-circle",
            className: "error-class",
          });
        });
    },
    submitDetailCustomIdentifier() {
      const key = (this.detailNewIdentifier.key || '').trim();
      const value = (this.detailNewIdentifier.value || '').trim();

      if (key.length === 0) {
        this.$toasted.show("Identifier Name is required!", {
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      if (key.length > 50) {
        this.$toasted.show("Identifier Name can not be more than 50 characters long!", {
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      if (value.length === 0) {
        this.$toasted.show("Identifier value is required!", {
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      if (value.length > 50) {
        this.$toasted.show("Identifier value can not be more than 50 characters long!", {
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      this.detailAddIdentifierLoading = true;
      this.axios.post(window.hostname + '/api/auth/permit/add-custom-identifier', {
        subscription_id: this.approved_permit_details.application_id,
        identifier_key: key,
        identifier_value: value
      })
        .then(res => {
          this.detailAddIdentifierLoading = false;
          if (res.data.status) {
            this.approved_application_page = 1;
            this.approved_applications = [];
            this.approved_application_load_more = false;
            this.approvedApplications();
            if (this.approved_permit_details.custom_identifiers && this.approved_permit_details.custom_identifiers.length > 0) {
              const existingIdentifierIndex = this.approved_permit_details.custom_identifiers.findIndex((identifier) => identifier.key === key);
              if (existingIdentifierIndex !== -1) {
                this.$set(this.approved_permit_details.custom_identifiers, existingIdentifierIndex, { key, value });
              } else {
                this.approved_permit_details.custom_identifiers.push({ key, value });
              }
            } else {
              this.$set(this.approved_permit_details, 'custom_identifiers', [{ key, value }]);
            }
            this.showDetailAddIdentifierForm = false;
            this.detailNewIdentifier = { key: '', value: '' };
            this.$toasted.show(res.data.message, {
              icon: 'check-circle',
              className: 'success-class'
            });
          } else {
            this.$toasted.show(res.data.message, {
              icon: 'times-circle',
              className: 'error-class'
            });
          }
        })
        .catch(err => {
          this.detailAddIdentifierLoading = false;
          this.$toasted.show(err.response.data.message, {
            icon: 'times-circle',
            className: 'error-class'
          });
        });
    },
    isDetailIdentifierEditing(index) {
      return this.detailEditingIdentifierIndices.includes(index);
    },
    getLinkedDetailIdentifierIndex(identifier, index) {
      if (!identifier || !identifier.key) {
        return null;
      }

      const customIdentifiers = this.approved_permit_details.custom_identifiers || [];
      const relatedKeys = this.getRelationshipTargetMappings(identifier.key, identifier.value, this.approved_permit_details.permit_id)
        .map((relationship) => relationship.targetKey);

      for (const targetKey of relatedKeys) {
        const linkedIndex = customIdentifiers.findIndex((item, itemIndex) => {
          if (itemIndex === index || !item) {
            return false;
          }
          return this.normalizeCustomIdentifierText(item.key) === this.normalizeCustomIdentifierText(targetKey);
        });

        if (linkedIndex !== -1) {
          return linkedIndex;
        }
      }

      return null;
    },
    onDetailIdentifierEditValueChange(identifier, index, newValue) {
      const normalizedNewValue = this.normalizeCustomIdentifierText(newValue);
      this.$set(this.detailEditingIdentifierValues, index, normalizedNewValue);
      this.blurVueSearchSelect(`detailIdentifierValueSelect_${index}`);

      if (!identifier || !identifier.key) {
        return;
      }

      const relationshipTargets = this.getRelationshipTargetMappings(identifier.key, normalizedNewValue, this.approved_permit_details.permit_id);
      relationshipTargets.forEach(({ targetKey, targetValue }) => {
        const targetEditIndex = this.detailEditingIdentifierIndices.find((editingIndex) => {
          const editingIdentifier = (this.approved_permit_details.custom_identifiers || [])[editingIndex];
          return editingIdentifier && this.normalizeCustomIdentifierText(editingIdentifier.key) === targetKey;
        });

        if (targetEditIndex !== undefined) {
          this.$set(this.detailEditingIdentifierValues, targetEditIndex, targetValue);
        }
      });
    },
    startDetailCustomIdentifierEdit(identifier, index) {
      const editIndices = [index];
      const linkedIndex = this.getLinkedDetailIdentifierIndex(identifier, index);
      if (linkedIndex !== null && linkedIndex !== undefined) {
        editIndices.push(linkedIndex);
      }

      this.detailEditingIdentifierIndices = editIndices;
      const editValues = {};
      editIndices.forEach((editIndex) => {
        const editIdentifier = (this.approved_permit_details.custom_identifiers || [])[editIndex];
        editValues[editIndex] = editIdentifier && editIdentifier.value ? editIdentifier.value : '';
      });
      this.detailEditingIdentifierValues = editValues;
    },
    cancelDetailCustomIdentifierEdit() {
      this.detailEditingIdentifierIndices = [];
      this.detailEditingIdentifierValues = {};
      this.detailEditIdentifierLoading = false;
    },
    saveDetailCustomIdentifierEdit(identifier, index) {
      if (!identifier || !identifier.key) {
        return;
      }

      const editPayloads = this.detailEditingIdentifierIndices
        .map((editingIndex) => {
          const editingIdentifier = (this.approved_permit_details.custom_identifiers || [])[editingIndex];
          if (!editingIdentifier || !editingIdentifier.key) {
            return null;
          }
          const value = (this.detailEditingIdentifierValues[editingIndex] || '').trim();
          return {
            index: editingIndex,
            key: editingIdentifier.key,
            value,
          };
        })
        .filter((item) => !!item);

      if (editPayloads.length === 0) {
        return;
      }

      for (const payload of editPayloads) {
        if (payload.value.length === 0) {
          this.$toasted.show("Identifier value is required!", {
            icon: 'times-circle',
            className: 'error-class'
          });
          return;
        }

        if (payload.value.length > 50) {
          this.$toasted.show("Identifier value can not be more than 50 characters long!", {
            icon: 'times-circle',
            className: 'error-class'
          });
          return;
        }
      }

      this.detailEditIdentifierLoading = true;
      Promise.all(
        editPayloads.map((payload) =>
          this.axios.post(window.hostname + '/api/auth/permit/add-custom-identifier', {
            subscription_id: this.approved_permit_details.application_id,
            identifier_key: payload.key,
            identifier_value: payload.value
          })
        )
      )
        .then((responses) => {
          this.detailEditIdentifierLoading = false;
          const failedResponse = responses.find((response) => !response.data.status);
          if (failedResponse) {
            this.$toasted.show(failedResponse.data.message, {
              icon: 'times-circle',
              className: 'error-class'
            });
            return;
          }

          this.approved_application_page = 1;
          this.approved_applications = [];
          this.approved_application_load_more = false;
          this.approvedApplications();

          editPayloads.forEach((payload) => {
            this.$set(this.approved_permit_details.custom_identifiers, payload.index, {
              key: payload.key,
              value: payload.value
            });
          });

          this.cancelDetailCustomIdentifierEdit();
          this.$toasted.show(responses[0].data.message || 'Custom identifier updated successfully!', {
            icon: 'check-circle',
            className: 'success-class'
          });
        })
        .catch(err => {
          this.detailEditIdentifierLoading = false;
          this.$toasted.show(err.response.data.message, {
            icon: 'times-circle',
            className: 'error-class'
          });
        });
    },
    removeCustomIdentifiers(identifier, application_type) {
      if (this.isRequiredApprovedCustomIdentifier(identifier)) {
        this.$toasted.show("Required custom identifiers cannot be removed!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }

      this.$swal({
        title: "Are you sure?",
        text: "Do you want to delete this custom identifier?",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.axios.post(window.hostname + '/api/auth/permit/remove-custom-identifier', {
            subscription_id: this.approved_permit_details.application_id,
            identifier_key: identifier.key,
            identifier_value: identifier.value
          })
            .then(res => {
              if (res.data.status) {
                let key = this.approved_permit_details.custom_identifiers.indexOf(identifier);
                this.$delete(this.approved_permit_details.custom_identifiers, key);
                this.approved_application_page = 1;
                this.approved_applications = [];
                this.approved_application_load_more = false;
                this.approvedApplications();

                this.$toasted.show(res.data.message, {
                  icon: 'check-circle',
                  className: 'success-class'
                });
              }
              else {
                this.$toasted.show(res.data.message, {
                  icon: 'times-circle',
                  className: 'error-class'
                });
              }
            })
            .catch(err => {
              this.$toasted.show(err.response.data.message, {
                icon: 'times-circle',
                className: 'error-class'
              });
            });
        }
      })
    },
    findIdentifierValue(approved, identifier_key) {
      let value = '-';
      if (approved.custom_identifiers.length > 0) {
        approved.custom_identifiers.map((val) => {
          if (val.key == identifier_key) {
            value = val.value;
          }
        });
        return value;
      }
      else {
        return value;
      }
    },
    changePermitStatus() {
      if (this.approved_permit_details.status == 'waiting_list') {
        this.$swal({
          title: "Are you sure?",
          html: `<p class="txt--ss font-weight-bold txt--off-white" >Do you want to approve this application?</p>`,

          showCancelButton: true,
        })
          .then((result) => {
            if (result.value) {
              this.approveApplication();
            }
          });
      }
    },
    approveApplication() {
      this.axios.post(window.hostname + '/api/auth/permit/status-update', {
        application_id: this.approved_permit_details.application_id
      })
        .then(res => {
          if (res.data.status) {
            this.approved_application_page = 1;
            this.approved_application_load_more = false;
            this.approved_applications = [];
            this.approvedApplications();
            this.$toasted.show(res.data.message, {
              icon: 'check-circle',
              className: 'success-class'
            });
          }
          else {
            this.$toasted.show(res.data.message, {
              icon: 'times-circle',
              className: 'error-class'
            });
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    async showUpdateVehicleCountModal(application_type) {
      let current_vehicle_count = this.approved_permit_details.vehicle_count;
      const allowAllByDefault =
        current_vehicle_count === '' ||
        current_vehicle_count === null ||
        current_vehicle_count === undefined;

      const { value: vehicle_count } = await this.$swal({
        title: "Allowed Vehicles",
        html:
          `<div class="row">
            <div class="col-md-12">
              <div class="form__group mb-1 mt-3">
                <label class="txt--xs txt--off-white mb-2 mr-2 d-flex justify-content-start">Allow Vehicles</label>
                <ul class="top__filter__ul top__filter__ul--btn d-flex mb-2" id="vehicle_allow_type">
                  <li id="allow_all_option" class="` + (allowAllByDefault ? 'active' : '') + `">Allow All</li>
                  <li id="allow_selected_option" class="` + (!allowAllByDefault ? 'active' : '') + `">Allow Selected</li>
                </ul>
                <div id="vehicle_count_wrapper" style="display: ` + (allowAllByDefault ? 'none' : 'block') + `;">
                  <label class="txt--xs txt--off-white d-flex justify-content-start">Select Number of Vehicles</label>
                  <input type="text" placeholder="Enter Number of Vehicles To Be Allowed" class="textInputField" id="vehicle_count" value="` + (allowAllByDefault ? '' : current_vehicle_count) + `">
                </div>
              </div>
            </div>
          </div>`,
        showCancelButton: true,
        onOpen: () => {
          // Small delay to ensure DOM elements are fully rendered
          setTimeout(() => {
            const allowAllOption = document.getElementById('allow_all_option');
            const allowSelectedOption = document.getElementById('allow_selected_option');
            const vehicleCountWrapper = document.getElementById('vehicle_count_wrapper');
            const vehicleCountInput = document.getElementById('vehicle_count');

            console.log('Modal elements found:', { 
              allowAllOption: !!allowAllOption, 
              allowSelectedOption: !!allowSelectedOption, 
              vehicleCountWrapper: !!vehicleCountWrapper 
            });

            const setMode = (allowAll) => {
              console.log('setMode called with allowAll:', allowAll);
              
              if (!allowAllOption || !allowSelectedOption || !vehicleCountWrapper) {
                console.log('Missing elements, aborting setMode');
                return;
              }

              // Update styles directly for both options using standard RGB format
              if (allowAll) {
                allowAllOption.style.background = 'rgba(245, 166, 33, 1)';
                allowAllOption.style.color = '#fff';
                allowSelectedOption.style.background = 'rgba(130, 101, 53, 0.5)';
                allowSelectedOption.style.color = 'inherit';
                console.log('Set Allow All as active');
              } else {
                allowSelectedOption.style.background = 'rgba(245, 166, 33, 1)';
                allowSelectedOption.style.color = '#fff';
                allowAllOption.style.background = 'rgba(130, 101, 53, 0.5)';
                allowAllOption.style.color = 'inherit';
                console.log('Set Allow Selected as active');
              }
              
              // Show/hide input based on selection
              vehicleCountWrapper.style.display = allowAll ? 'none' : 'block';

              if (!allowAll && vehicleCountInput) {
                vehicleCountInput.focus();
              }
            };

            if (allowAllOption) {
              allowAllOption.addEventListener('click', (e) => {
                console.log('Allow All button clicked');
                e.preventDefault();
                e.stopPropagation();
                setMode(true);
              });
            }
            if (allowSelectedOption) {
              allowSelectedOption.addEventListener('click', (e) => {
                console.log('Allow Selected button clicked');
                e.preventDefault();
                e.stopPropagation();
                setMode(false);
              });
            }
            if (vehicleCountInput) {
              vehicleCountInput.addEventListener('input', (e) => {
                e.target.value = String(e.target.value || '').replace(/[^0-9]/g, '');
              });
            }
          }, 100);
        },
        preConfirm: () => {
          const allowAllOption = document.getElementById('allow_all_option');
          const vehicleCountInput = document.getElementById('vehicle_count');
          const vehicleCountWrapper = document.getElementById('vehicle_count_wrapper');
          
          // Check if input wrapper is hidden (means Allow All is selected)
          const allowAll = vehicleCountWrapper && vehicleCountWrapper.style.display === 'none';
          
          console.log('preConfirm - allowAll detected:', allowAll, 'wrapper display:', vehicleCountWrapper ? vehicleCountWrapper.style.display : 'no wrapper');

          if (allowAll) {
            console.log('Returning empty count for Allow All');
            return {
              count: ''
            };
          }

          let count = vehicleCountInput ? vehicleCountInput.value : '';

          if (count.trim().length === 0) {
            this.$toasted.show("Please provide a valid vehicle count!", {
              icon: 'times-circle',
              className: 'error-class'
            });
            return false;
          }

          count = parseInt(count);
          if (isNaN(count) || count < 1) {
            this.$toasted.show("Please provide a valid vehicle count!", {
              icon: 'times-circle',
              className: 'error-class'
            });
            return false;
          }

          console.log('Returning vehicle count:', count);
          return {
            count: count
          }
        }
      });

      if (vehicle_count == undefined || vehicle_count == null) {
        return;
      }

      this.axios.post(window.hostname + '/api/auth/subscription/update', {
        application_id: this.approved_permit_details.application_id,
        vehicle_count: vehicle_count.count
      })
        .then(res => {
          if (res.data.status) {
            this.$toasted.show(res.data.message, {
              icon: 'check-circle',
              className: 'success-class'
            });
            this.approved_permit_details.vehicle_count = vehicle_count.count;
          }
          else {
            this.$toasted.show(res.data.message, {
              icon: 'times-circle',
              className: 'error-class'
            });
          }
        })
        .catch(err => {
          this.$toasted.show(err.response.data.message, {
            icon: 'times-circle',
            className: 'error-class'
          });
        });
    },

    async showUpdatePermitTypeModal(_application_type) {
      const currentPermitIdRaw = (this.approved_permit_details || {})['permit_id'];
      const currentPermitId = (currentPermitIdRaw === null || currentPermitIdRaw === undefined) ? '' : String(currentPermitIdRaw);
      const allowRefreshStripeMetadata = !!(window && window.featureFlags && window.featureFlags.permitSwitchingAllowRefreshStripeMetadata);
      const currentPermit = (this.permit_list || []).find((permit) => String((permit || {}).permit_id) === currentPermitId);
      const currentPermitName = currentPermit ? (currentPermit.permit_name || currentPermit.permit_title || currentPermit.name || currentPermitId) : (currentPermitId || '');
      const currentPermitHandleMethod = currentPermit && currentPermit.handle_method ? String(currentPermit.handle_method) : '';

      const escapeHtml = (value) => {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      };

      const optionTags = (this.permit_list || [])
        .filter((permit) => permit && permit.permit_id !== null && permit.permit_id !== undefined)
        .map((permit) => {
          const permitId = String(permit.permit_id);
          const permitName = escapeHtml(permit.permit_name || permit.permit_title || permit.name || permitId);
          const selected = (permitId === currentPermitId) ? 'selected' : '';
          return `<option value="${escapeHtml(permitId)}" ${selected}>${permitName}</option>`;
        })
        .join('');

      const initialCustomerIdentifiers = Array.isArray((this.approved_permit_details || {})['custom_identifiers'])
        ? (this.approved_permit_details || {})['custom_identifiers']
        : [];

      const initialCustomIdentifiers = initialCustomerIdentifiers
        .map((identifier) => {
          const key = identifier && identifier.key !== undefined ? String(identifier.key).trim() : '';
          const value = identifier && identifier.value !== undefined ? String(identifier.value).trim() : '';
          return {
            identifier_key: key,
            identifier_value: value,
          };
        })
        .filter((identifier) => identifier.identifier_key !== '' || identifier.identifier_value !== '');

      const html = `<div id="permit_switching_root"></div>`;

      let permitSwitchingVm = null;
      const debounce = (fn, waitMs) => {
        let timeoutId = null;
        return (...args) => {
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          timeoutId = setTimeout(() => fn(...args), waitMs);
        };
      };

      const { value: changePayload } = await this.$swal({
        title: "Edit Permit Type",
        html,
        showCancelButton: true,
        width: '640px',
        focusConfirm: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: () => {
          const root = document.getElementById('permit_switching_root');
          if (!root) {
            return;
          }

          permitSwitchingVm = new Vue({
            parent: this,
            components: {
              ModelListSelect,
            },
            data: () => {
              return {
                permitOptions: [],
                permitLoading: false,
                permitSearchText: '',
                selectedPermitId: allowRefreshStripeMetadata ? (currentPermitId || '') : '',
                currentPermitId: currentPermitId || '',
                currentPermitName: currentPermitName || '',
                currentPermitHandleMethod: currentPermitHandleMethod || '',
                allowRefreshStripeMetadata,

                effectiveAt: 'immediate',
                showAdvanced: false,
                prorationBehavior: 'none',
                avoidEarlyCharge: 0,
                refreshStripeMetadata: 0,
                recalculateSubscriptionDates: 1,
                recalculatePrice: 1,

                customIdentifiers: (initialCustomIdentifiers && initialCustomIdentifiers.length > 0)
                  ? [...initialCustomIdentifiers]
                  : [{ identifier_key: '', identifier_value: '' }],

                customIdentifierKeySearchText: {},
                customIdentifierValueSearchText: {},
              };
            },
            computed: {
              normalizeHandleMethod() {
                return (value) => {
                  if (value === null || value === undefined) {
                    return '';
                  }
                  return String(value).trim().toLowerCase();
                };
              },
              currentPermitIsStripe() {
                // Default to Stripe unless explicitly manual.
                const method = this.normalizeHandleMethod(this.currentPermitHandleMethod);
                return method !== 'manual';
              },
              selectedPermitIsStripe() {
                const permit = this.selectedPermit;
                const method = this.normalizeHandleMethod(permit ? permit.handle_method : '');
                return method !== 'manual';
              },
              isSamePermitSelected() {
                const selected = this.selectedPermitId ? String(this.selectedPermitId) : '';
                const current = this.currentPermitId ? String(this.currentPermitId) : '';
                return !!selected && !!current && selected === current;
              },
              isRefreshingSamePermit() {
                return this.allowRefreshStripeMetadata
                  && this.isSamePermitSelected
                  && parseInt(String(this.refreshStripeMetadata || 0), 10) === 1;
              },
              isAnyManualPermitInSwitch() {
                // If either side is manual/non-Stripe, Stripe-only billing knobs are obsolete.
                return !this.currentPermitIsStripe || !this.selectedPermitIsStripe;
              },
              isManualToStripeSwitch() {
                return !this.currentPermitIsStripe && this.selectedPermitIsStripe;
              },
              isNextPeriodAllowed() {
                // Backend rejects manual -> Stripe with next_period.
                return !this.isRefreshingSamePermit && !this.isManualToStripeSwitch;
              },
              selectedPermit() {
                const id = this.selectedPermitId ? String(this.selectedPermitId) : '';
                if (!id) {
                  return null;
                }

                const inOptions = (this.permitOptions || []).find((p) => p && String(p.permit_id) === id);
                if (inOptions) {
                  return inOptions;
                }

                const inCached = (this.$parent.permit_list || []).find((p) => p && String(p.permit_id) === id);
                return inCached || null;
              },
              requiredIdentifierKeys() {
                return this.$parent.getPermitRequiredCustomIdentifiers(this.selectedPermit);
              },
              shouldDisableProration() {
                return String(this.effectiveAt) === 'next_period' || parseInt(String(this.avoidEarlyCharge || 0), 10) === 1;
              },
              showEffectiveAtControl() {
                return !this.isRefreshingSamePermit;
              },
              showAvoidEarlyChargeControl() {
                if (this.isRefreshingSamePermit) {
                  return false;
                }

                if (String(this.effectiveAt) === 'next_period') {
                  return false;
                }

                if (this.isAnyManualPermitInSwitch) {
                  return false;
                }

                return true;
              },
              showProrationControl() {
                if (!this.showAdvanced) {
                  return false;
                }

                if (this.isRefreshingSamePermit) {
                  return false;
                }

                if (this.isAnyManualPermitInSwitch) {
                  return false;
                }

                if (String(this.effectiveAt) !== 'immediate') {
                  return false;
                }

                if (parseInt(String(this.avoidEarlyCharge || 0), 10) === 1) {
                  return false;
                }

                return true;
              },
              showAdvancedRecalculateControls() {
                return this.showAdvanced && !this.isRefreshingSamePermit;
              },
            },
            watch: {
              selectedPermitId(newVal, oldVal) {
                this.ensureRequiredIdentifiers();

                // If switching from manual -> Stripe, next_period is not supported.
                if (this.isManualToStripeSwitch && String(this.effectiveAt) === 'next_period') {
                  this.effectiveAt = 'immediate';
                }

                if (this.isAnyManualPermitInSwitch) {
                  this.avoidEarlyCharge = 0;
                  this.prorationBehavior = 'none';
                }
              },
              effectiveAt(newVal) {
                if (String(newVal) === 'next_period') {
                  this.prorationBehavior = 'none';
                  this.avoidEarlyCharge = 0;
                }
              },
              refreshStripeMetadata(newVal) {
                if (parseInt(String(newVal || 0), 10) === 1 && this.isSamePermitSelected) {
                  this.effectiveAt = 'immediate';
                  this.prorationBehavior = 'none';
                  this.avoidEarlyCharge = 0;
                }
              },
              avoidEarlyCharge(newVal) {
                if (parseInt(String(newVal || 0), 10) === 1) {
                  this.prorationBehavior = 'none';
                }
              }
            },
            created() {
              this.fetchPermits('');
              this.ensureRequiredIdentifiers();
            },
            methods: {
              normalizeText(value) {
                return (value === null || value === undefined) ? '' : String(value).trim();
              },
              blurSelect(refKey) {
                this.$nextTick(() => {
                  const ref = this.$refs[refKey];
                  const component = Array.isArray(ref) ? ref[0] : ref;
                  const rootEl = component && component.$el ? component.$el : component;
                  const input = rootEl && rootEl.querySelector ? rootEl.querySelector('input.search') : null;
                  if (input && typeof input.blur === 'function') {
                    input.blur();
                  }
                });
              },
              async fetchPermits(searchText) {
                this.permitLoading = true;
                try {
                  const res = await this.$parent.axios.post(window.hostname + '/api/auth/permit/list', {
                    commercial: 1,
                    page: 1,
                    limit: 50,
                    all: 1,
                    property_id: this.$parent.property_id,
                    search_param: searchText || '',
                  });

                  if (res && res.data && res.data.status) {
                    const rawList = (res.data.data && res.data.data.permit_list) ? res.data.data.permit_list : [];
                    if (this.allowRefreshStripeMetadata) {
                      this.permitOptions = rawList;
                    } else {
                      this.permitOptions = rawList.filter((permit) => String((permit || {}).permit_id) !== String(this.currentPermitId || ''));
                    }
                  } else {
                    this.permitOptions = [];
                  }
                } catch (e) {
                  this.permitOptions = [];
                } finally {
                  this.permitLoading = false;
                }
              },
              onPermitSearchChange(searchText) {
                this.permitSearchText = this.normalizeText(searchText);
                this.debouncedFetchPermits(this.permitSearchText);
              },
              ensureRequiredIdentifiers() {
                const requiredKeys = Array.isArray(this.requiredIdentifierKeys) ? this.requiredIdentifierKeys : [];
                const current = Array.isArray(this.customIdentifiers) ? [...this.customIdentifiers] : [];

                if (requiredKeys.length === 0) {
                  if (current.length === 0) {
                    this.customIdentifiers = [{ identifier_key: '', identifier_value: '' }];
                  }
                  return;
                }

                const existingByKey = {};
                current.forEach((identifier) => {
                  const key = identifier && identifier.identifier_key ? String(identifier.identifier_key).trim() : '';
                  if (key && existingByKey[key] === undefined) {
                    existingByKey[key] = identifier && identifier.identifier_value ? String(identifier.identifier_value) : '';
                  }
                });

                const requiredRows = requiredKeys.map((key) => ({
                  identifier_key: key,
                  identifier_value: existingByKey[key] || '',
                }));

                const nonRequiredRows = current.filter((identifier) => {
                  const key = identifier && identifier.identifier_key ? String(identifier.identifier_key).trim() : '';
                  return !key || !requiredKeys.includes(key);
                });

                const next = [...requiredRows, ...nonRequiredRows];
                this.customIdentifiers = (next.length > 0) ? next : [{ identifier_key: '', identifier_value: '' }];
              },
              isRequiredIdentifier(identifier) {
                const key = identifier && identifier.identifier_key ? String(identifier.identifier_key).trim() : '';
                return !!key && (this.requiredIdentifierKeys || []).includes(key);
              },
              decorateOptions(options) {
                // Use the parent decorator so it matches existing UX.
                return this.$parent.decorateCustomIdentifierOptions(options);
              },
              optionListHasValue(options, value) {
                return this.$parent.customIdentifierOptionListHasValue(options, value);
              },
              getValueOptionsForKey(key) {
                return this.$parent.getValueOptionsForKey(key);
              },
              getKeyOptions(index) {
                const baseOptions = this.decorateOptions(this.$parent.customIdentifierKeyOptions || []);
                const typed = this.normalizeText(this.customIdentifierKeySearchText[index]);
                const selected = this.normalizeText(this.customIdentifiers && this.customIdentifiers[index] ? this.customIdentifiers[index].identifier_key : '');
                const desired = typed || selected;

                if (!desired) {
                  return baseOptions;
                }

                if (this.optionListHasValue(baseOptions, desired)) {
                  return baseOptions;
                }

                return [{ value: desired, text: `${desired}\u200B` }, ...baseOptions];
              },
              getValueOptions(index, key) {
                const baseOptions = this.decorateOptions(this.getValueOptionsForKey(key));
                const typed = this.normalizeText(this.customIdentifierValueSearchText[index]);
                const selected = this.normalizeText(this.customIdentifiers && this.customIdentifiers[index] ? this.customIdentifiers[index].identifier_value : '');
                const desired = typed || selected;

                if (!desired) {
                  return baseOptions;
                }

                if (this.optionListHasValue(baseOptions, desired)) {
                  return baseOptions;
                }

                return [{ value: desired, text: `${desired}\u200B` }, ...baseOptions];
              },
              onKeySearchChange(index, searchText) {
                const typed = this.normalizeText(searchText);
                this.$set(this.customIdentifierKeySearchText, index, typed);
              },
              onValueSearchChange(index, searchText) {
                const typed = this.normalizeText(searchText);
                this.$set(this.customIdentifierValueSearchText, index, typed);
              },
              onKeyChange(index, newKey) {
                const current = this.customIdentifiers[index];
                if (!current) {
                  return;
                }

                if (this.isRequiredIdentifier(current)) {
                  return;
                }

                const normalized = this.normalizeText(newKey);
                current.identifier_key = normalized;
                current.identifier_value = '';
                this.$set(this.customIdentifierKeySearchText, index, normalized);
                this.$set(this.customIdentifierValueSearchText, index, '');
                this.blurSelect(`customIdentifierKeySelect_${index}`);
              },
              onValueChange(index, newValue) {
                const current = this.customIdentifiers[index];
                if (!current) {
                  return;
                }
                const normalized = this.normalizeText(newValue);
                current.identifier_value = normalized;
                this.$set(this.customIdentifierValueSearchText, index, normalized);
                this.blurSelect(`customIdentifierValueSelect_${index}`);
              },
              addIdentifier() {
                this.customIdentifiers.push({ identifier_key: '', identifier_value: '' });
              },
              removeIdentifier(index) {
                const identifier = this.customIdentifiers[index];
                if (this.isRequiredIdentifier(identifier)) {
                  return;
                }
                this.customIdentifiers.splice(index, 1);
                if (this.customIdentifiers.length === 0) {
                  this.customIdentifiers.push({ identifier_key: '', identifier_value: '' });
                }
              },
              validate() {
                if (!this.selectedPermitId) {
                  return { valid: false, message: 'Please select a permit type.' };
                }

                const identifiers = (this.customIdentifiers || []).map((i) => ({
                  identifier_key: i && i.identifier_key ? String(i.identifier_key).trim() : '',
                  identifier_value: i && i.identifier_value ? String(i.identifier_value).trim() : '',
                }));

                const withKey = identifiers.filter((i) => i.identifier_key !== '');
                for (const identifier of withKey) {
                  if (identifier.identifier_value === '') {
                    return { valid: false, message: `Please provide a value for ${identifier.identifier_key}.` };
                  }

                  if (this.$parent.isCustomIdentifierSchemaLoaded() && !this.$parent.isCustomIdentifierKeyKnown(identifier.identifier_key)) {
                    return { valid: false, message: `Unknown custom identifier key: ${identifier.identifier_key}.` };
                  }

                  if (this.$parent.isPredefinedCustomIdentifierKey(identifier.identifier_key)) {
                    const valueOptions = this.$parent.getValueOptionsForKey(identifier.identifier_key);
                    if (!this.$parent.customIdentifierOptionListHasValue(valueOptions, identifier.identifier_value)) {
                      return { valid: false, message: `Invalid value for ${identifier.identifier_key}. Please select an allowed value.` };
                    }
                  }

                  const pattern = this.$parent.getCustomIdentifierValidationPattern(identifier.identifier_key);
                  if (pattern) {
                    let regex = null;
                    try {
                      regex = new RegExp(pattern);
                    } catch (e) {
                      regex = null;
                    }

                    if (regex && !regex.test(identifier.identifier_value)) {
                      return {
                        valid: false,
                        message: this.$parent.getCustomIdentifierValidationErrorMessage(identifier.identifier_key) || `Invalid format for ${identifier.identifier_key}.`
                      };
                    }
                  }
                }

                const requiredKeys = Array.isArray(this.requiredIdentifierKeys) ? this.requiredIdentifierKeys : [];
                for (const key of requiredKeys) {
                  const match = identifiers.find((i) => i.identifier_key === key);
                  if (!match || match.identifier_value === '') {
                    return { valid: false, message: `Please provide a value for required identifier: ${key}.` };
                  }
                }

                return { valid: true };
              },
              getPayload() {
                const normalizedCustomIdentifiers = (this.customIdentifiers || [])
                  .map((i) => ({
                    key: i && i.identifier_key ? String(i.identifier_key).trim() : '',
                    value: i && i.identifier_value ? String(i.identifier_value).trim() : '',
                  }))
                  .filter((i) => i.key !== '' && i.value !== '');

                const isRefreshingSamePermit = this.isRefreshingSamePermit;
                const effectiveAt = isRefreshingSamePermit ? 'immediate' : String(this.effectiveAt || 'immediate');
                const avoidEarlyCharge = (isRefreshingSamePermit || String(effectiveAt) === 'next_period' || this.isAnyManualPermitInSwitch)
                  ? 0
                  : (parseInt(String(this.avoidEarlyCharge || 0), 10) === 1 ? 1 : 0);

                const prorationBehavior = (isRefreshingSamePermit || String(effectiveAt) !== 'immediate' || avoidEarlyCharge === 1 || this.isAnyManualPermitInSwitch)
                  ? 'none'
                  : String(this.prorationBehavior || 'none');

                const recalculateSubscriptionDates = isRefreshingSamePermit
                  ? 1
                  : parseInt(String(this.recalculateSubscriptionDates || 1));

                const recalculatePrice = isRefreshingSamePermit
                  ? 1
                  : parseInt(String(this.recalculatePrice || 1));

                return {
                  selectedPermitId: String(this.selectedPermitId),
                  effectiveAt,
                  prorationBehavior,
                  avoidEarlyCharge,
                  refreshStripeMetadata: parseInt(String(this.refreshStripeMetadata || 0), 10) === 1 ? 1 : 0,
                  recalculateSubscriptionDates,
                  recalculatePrice,
                  customIdentifiers: normalizedCustomIdentifiers,
                };
              }
            },
            beforeMount() {
              this.debouncedFetchPermits = debounce((text) => this.fetchPermits(text), 250);
            },
            render(createElement) {
              const permitHelpText = this.permitLoading ? 'Searching permits…' : 'Type to search permits.';
              const currentPermitNote = this.currentPermitName ? `Current permit: ${this.currentPermitName}` : '';

              const customIdentifierRows = (this.customIdentifiers || []).map((identifier, index) => {
                const required = this.isRequiredIdentifier(identifier);

                const nameCol = createElement('div', { class: ['col-sm-5'] }, [
                  createElement('div', { class: ['form__group', 'mb-3'] }, [
                    createElement('label', { class: ['txt--xs', 'txt--off-white', 'd-flex', 'align-items-center'] }, [
                      createElement('span', 'Custom Identifier Name'),
                      required ? createElement('span', { class: ['required-identifier-badge', 'ml-2'] }, 'Required') : null,
                    ]),
                    required
                      ? createElement('input', {
                        attrs: {
                          type: 'text',
                          readonly: true,
                          title: 'This identifier is required by the selected permit and cannot be changed',
                          value: identifier.identifier_key || '',
                        },
                        class: ['textInputField', 'textInputField--locked'],
                      })
                      : createElement('ModelListSelect', {
                        ref: `customIdentifierKeySelect_${index}`,
                        props: {
                          value: identifier.identifier_key,
                          list: this.getKeyOptions(index),
                          optionValue: 'value',
                          optionText: 'text',
                          placeholder: 'Enter or select identifier name',
                          allowNew: true,
                          isError: false,
                        },
                        class: ['custom-vue-select'],
                        on: {
                          input: (val) => this.onKeyChange(index, val),
                          searchchange: (val) => this.onKeySearchChange(index, val),
                        }
                      })
                  ])
                ]);

                const valueCol = createElement('div', { class: ['col-sm-5'] }, [
                  createElement('div', { class: ['form__group', 'mb-3'] }, [
                    createElement('label', { class: ['txt--xs', 'txt--off-white'] }, 'Custom Identifier Value'),
                    createElement('ModelListSelect', {
                      ref: `customIdentifierValueSelect_${index}`,
                      props: {
                        value: identifier.identifier_value,
                        list: this.getValueOptions(index, identifier.identifier_key),
                        optionValue: 'value',
                        optionText: 'text',
                        placeholder: 'Enter or select identifier value',
                        allowNew: true,
                        isError: false,
                      },
                      class: ['custom-vue-select'],
                      on: {
                        input: (val) => this.onValueChange(index, val),
                        searchchange: (val) => this.onValueSearchChange(index, val),
                      }
                    })
                  ])
                ]);

                const actionCol = createElement('div', { class: ['col-sm-2', 'd-flex', 'align-items-center'] }, [
                  createElement('div', { class: ['mt-2'] }, [
                    createElement('span', {
                      directives: [{ name: 'tooltip', value: required ? 'This identifier is required by the selected permit and cannot be removed.' : 'Remove custom identifier' }]
                    }, [
                      createElement('button', {
                        attrs: { type: 'button', disabled: required },
                        class: ['btn', 'btn-sm', required ? 'text-muted' : 'text-danger'],
                        on: { click: () => this.removeIdentifier(index) }
                      }, [createElement('i', { class: ['fas', 'fa-minus'] })])
                    ]),
                    (index === (this.customIdentifiers.length - 1))
                      ? createElement('button', {
                        attrs: { type: 'button' },
                        class: ['btn', 'btn-sm', 'text-success'],
                        on: { click: this.addIdentifier }
                      }, [createElement('i', { class: ['fas', 'fa-plus'] })])
                      : null,
                  ])
                ]);

                return createElement('div', { class: ['row'], key: `identifier_row_${index}` }, [nameCol, valueCol, actionCol]);
              });

              const customIdentifiersSection = createElement('div', { class: ['col-sm-12', 'mb-2'] }, [
                createElement('p', { class: ['txt--xs', 'txt--off-white', 'mb-2'] }, 'Custom Identifiers'),
                ...customIdentifierRows,
              ]);

              const advancedSection = this.showAdvanced
                ? createElement('div', { class: ['col-sm-12', 'mt-2'] }, [
                  createElement('div', { class: ['row'] }, [
                    this.showProrationControl
                      ? createElement('div', { class: ['col-sm-6'] }, [
                        createElement('div', { class: ['form__group', 'mb-3'] }, [
                          createElement('label', { class: ['txt--xs', 'txt--off-white'] }, 'Proration'),
                          createElement('select', {
                            class: ['textInputField'],
                            domProps: { value: this.prorationBehavior },
                            on: {
                              change: (e) => {
                                this.prorationBehavior = String(e && e.target ? e.target.value : 'none');
                              }
                            }
                          }, [
                            createElement('option', { attrs: { value: 'none' } }, 'None'),
                            createElement('option', { attrs: { value: 'create_prorations' } }, 'Create prorations'),
                          ]),
                          createElement('p', { class: ['txt--xs', 'txt--off-white'], style: { opacity: '0.8', marginTop: '6px' } }, 'Only meaningful for Stripe recurring + immediate.'),
                        ])
                      ])
                      : null,

                    this.showAdvancedRecalculateControls
                      ? createElement('div', { class: ['col-sm-6'] }, [
                        createElement('div', { class: ['form__group', 'mb-3'] }, [
                          createElement('label', { class: ['txt--xs', 'txt--off-white'] }, 'Recalculate Subscription Dates'),
                          createElement('select', {
                            class: ['textInputField'],
                            domProps: { value: String(this.recalculateSubscriptionDates) },
                            on: { change: (e) => { this.recalculateSubscriptionDates = parseInt(String(e && e.target ? e.target.value : '1')); } }
                          }, [
                            createElement('option', { attrs: { value: '1' } }, 'Yes'),
                            createElement('option', { attrs: { value: '0' } }, 'No'),
                          ]),
                        ])
                      ])
                      : null,
                  ]),
                  this.showAdvancedRecalculateControls
                    ? createElement('div', { class: ['row'] }, [
                      createElement('div', { class: ['col-sm-6'] }, [
                        createElement('div', { class: ['form__group', 'mb-3'] }, [
                          createElement('label', { class: ['txt--xs', 'txt--off-white'] }, 'Recalculate Price'),
                          createElement('select', {
                            class: ['textInputField'],
                            domProps: { value: String(this.recalculatePrice) },
                            on: { change: (e) => { this.recalculatePrice = parseInt(String(e && e.target ? e.target.value : '1')); } }
                          }, [
                            createElement('option', { attrs: { value: '1' } }, 'Yes'),
                            createElement('option', { attrs: { value: '0' } }, 'No'),
                          ]),
                        ])
                      ]),
                    ])
                    : null,
                ])
                : null;

              return createElement('div', { class: ['row'] }, [
                createElement('div', { class: ['col-sm-12'] }, [
                  createElement('div', { class: ['form__group', 'mb-3', 'mt-3'] }, [
                    createElement('label', { class: ['txt--xs', 'txt--off-white'] }, 'Permit (required)'),
                    createElement('ModelListSelect', {
                      ref: 'permitSelect',
                      props: {
                        value: this.selectedPermitId,
                        list: (this.permitOptions && this.permitOptions.length > 0)
                          ? this.permitOptions
                          : (this.allowRefreshStripeMetadata
                            ? (this.$parent.permit_list || [])
                            : (this.$parent.permit_list || []).filter((permit) => String((permit || {}).permit_id) !== String(this.currentPermitId || ''))
                          ),
                        optionValue: 'permit_id',
                        optionText: 'permit_name',
                        placeholder: 'Select Permit',
                        isError: false,
                        allowNew: false,
                      },
                      class: ['custom-vue-select'],
                      on: {
                        input: (val) => { this.selectedPermitId = val; },
                        searchchange: this.onPermitSearchChange,
                      }
                    }),
                    (!this.allowRefreshStripeMetadata && currentPermitNote)
                      ? createElement('p', { class: ['txt--xs', 'txt--off-white'], style: { opacity: '0.8', marginTop: '6px' } }, currentPermitNote)
                      : null,
                    createElement('p', { class: ['txt--xs', 'txt--off-white'], style: { opacity: '0.75', marginTop: '6px' } }, permitHelpText),
                  ]),

                  createElement('div', { class: ['form__group', 'mb-3'] }, [
                    createElement('label', { class: ['txt--xs', 'txt--off-white'] }, 'Effective At'),
                    this.showEffectiveAtControl
                      ? createElement('select', {
                        class: ['textInputField'],
                        domProps: { value: this.effectiveAt },
                        on: {
                          change: (e) => { this.effectiveAt = String(e && e.target ? e.target.value : 'immediate'); }
                        }
                      }, [
                        createElement('option', { attrs: { value: 'immediate' } }, 'Immediate'),
                        this.isNextPeriodAllowed
                          ? createElement('option', { attrs: { value: 'next_period' } }, 'Next period')
                          : null,
                      ].filter(Boolean))
                      : createElement('p', { class: ['txt--xs', 'txt--off-white'], style: { opacity: '0.8', marginTop: '6px' } }, 'Effective At is not applicable when refreshing Stripe metadata.'),
                    (!this.isNextPeriodAllowed && this.isManualToStripeSwitch)
                      ? createElement('p', { class: ['txt--xs', 'txt--off-white'], style: { opacity: '0.8', marginTop: '6px' } }, 'Next period is not supported when switching from a manual permit to a Stripe permit.')
                      : null,
                    (String(this.effectiveAt) === 'next_period')
                      ? createElement('p', { class: ['txt--xs', 'txt--off-white'], style: { opacity: '0.8', marginTop: '6px' } }, 'Switch at renewal boundary (no charge until renewal). Proration/Avoid Early Charge are not applicable.')
                      : null,
                  ]),

                  this.showAvoidEarlyChargeControl
                    ? createElement('div', { class: ['form__group', 'mb-3'] }, [
                      createElement('label', { class: ['txt--xs', 'txt--off-white'] }, 'Avoid Early Charge'),
                      createElement('select', {
                        class: ['textInputField'],
                        domProps: { value: String(this.avoidEarlyCharge) },
                        on: {
                          change: (e) => { this.avoidEarlyCharge = parseInt(String(e && e.target ? e.target.value : '0'), 10) === 1 ? 1 : 0; }
                        }
                      }, [
                        createElement('option', { attrs: { value: '0' } }, 'No'),
                        createElement('option', { attrs: { value: '1' } }, 'Yes'),
                      ]),
                      createElement('p', { class: ['txt--xs', 'txt--off-white'], style: { opacity: '0.8', marginTop: '6px' } }, 'Prevent mid-cycle charges (no proration, renewal date unchanged).'),
                      createElement('p', { class: ['txt--xs', 'txt--off-white'], style: { opacity: '0.7', marginTop: '2px' } }, 'Important: this avoids mid-cycle charges; it does not make renewal free.'),
                    ])
                    : null,

                  (this.isAnyManualPermitInSwitch && !this.isRefreshingSamePermit)
                    ? createElement('p', { class: ['txt--xs', 'txt--off-white'], style: { opacity: '0.75', marginTop: '-6px', marginBottom: '12px' } }, 'Stripe billing options (proration/avoid early charge) are not applicable for manual permits.')
                    : null,

                  this.allowRefreshStripeMetadata
                    ? createElement('div', { class: ['form__group', 'mb-3'] }, [
                      createElement('label', { class: ['txt--xs', 'txt--off-white'] }, 'Refresh Stripe Metadata'),
                      createElement('select', {
                        class: ['textInputField'],
                        domProps: { value: String(this.refreshStripeMetadata) },
                        on: {
                          change: (e) => { this.refreshStripeMetadata = parseInt(String(e && e.target ? e.target.value : '0'), 10) === 1 ? 1 : 0; }
                        }
                      }, [
                        createElement('option', { attrs: { value: '0' } }, 'No'),
                        createElement('option', { attrs: { value: '1' } }, 'Yes'),
                      ]),
                      createElement('p', { class: ['txt--xs', 'txt--off-white'], style: { opacity: '0.8', marginTop: '6px' } }, 'Fix Stripe metadata display (no billing change).'),
                    ])
                    : null,

                  customIdentifiersSection,

                  createElement('div', { class: ['form__group', 'mb-2'], style: { display: 'flex', justifyContent: 'flex-end' } }, [
                    createElement('a', {
                      attrs: { href: '#' },
                      class: ['txt--xs', 'txt--primary'],
                      style: { textDecoration: 'underline' },
                      on: {
                        click: (e) => {
                          e.preventDefault();
                          this.showAdvanced = !this.showAdvanced;
                        }
                      }
                    }, this.showAdvanced ? 'Hide advanced options' : 'Show advanced options')
                  ]),

                  advancedSection,
                ]),
              ]);
            }
          }).$mount();

          root.appendChild(permitSwitchingVm.$el);
        },
        preConfirm: () => {
          if (!permitSwitchingVm) {
            return false;
          }

          const validation = permitSwitchingVm.validate();
          if (!validation.valid) {
            this.$toasted.show(validation.message || 'Please check the form.', {
              icon: 'times-circle',
              className: 'error-class'
            });
            return false;
          }

          const payload = permitSwitchingVm.getPayload();

          if (
            payload.selectedPermitId &&
            currentPermitId &&
            String(payload.selectedPermitId) === currentPermitId &&
            (!allowRefreshStripeMetadata || parseInt(String(payload.refreshStripeMetadata || 0), 10) !== 1)
          ) {
            this.$toasted.show(allowRefreshStripeMetadata ? 'Please select a different permit type, or enable Refresh Stripe Metadata.' : 'Please select a different permit type.', {
              icon: 'times-circle',
              className: 'error-class'
            });
            return false;
          }

          return payload;
        }
      });

      if (!changePayload || !changePayload.selectedPermitId) {
        return;
      }

      const selectedPermitId = changePayload.selectedPermitId;
      const selectedPermitForSwitch = (this.permit_list || []).find((permit) => String((permit || {}).permit_id) === String(selectedPermitId));
      const currentPermitForSwitch = (this.permit_list || []).find((permit) => String((permit || {}).permit_id) === String(currentPermitId));
      const currentHandleMethod = currentPermitForSwitch && currentPermitForSwitch.handle_method ? String(currentPermitForSwitch.handle_method).trim().toLowerCase() : '';
      const selectedHandleMethod = selectedPermitForSwitch && selectedPermitForSwitch.handle_method ? String(selectedPermitForSwitch.handle_method).trim().toLowerCase() : '';
      const currentIsStripe = currentHandleMethod !== 'manual';
      const selectedIsStripe = selectedHandleMethod !== 'manual';
      const anyManual = !currentIsStripe || !selectedIsStripe;
      const isSamePermit = currentPermitId && String(selectedPermitId) === String(currentPermitId);

      const refreshStripeMetadata = allowRefreshStripeMetadata && (changePayload.refreshStripeMetadata === 1 || changePayload.refreshStripeMetadata === '1') ? 1 : 0;
      const isRefresh = isSamePermit && refreshStripeMetadata === 1;

      let effectiveAt = changePayload.effectiveAt || 'immediate';
      if (isRefresh) {
        effectiveAt = 'immediate';
      }

      // Backend rejects manual -> Stripe with next_period.
      if (!currentIsStripe && selectedIsStripe && String(effectiveAt) === 'next_period') {
        effectiveAt = 'immediate';
      }

      const prorationBehavior = changePayload.prorationBehavior || 'none';
      const avoidEarlyCharge = (isRefresh || anyManual || effectiveAt === 'next_period')
        ? 0
        : ((changePayload.avoidEarlyCharge === 1 || changePayload.avoidEarlyCharge === '1') ? 1 : 0);
      const recalculateSubscriptionDates = (changePayload.recalculateSubscriptionDates === 0 || changePayload.recalculateSubscriptionDates === 1)
        ? changePayload.recalculateSubscriptionDates
        : 1;
      const recalculatePrice = (changePayload.recalculatePrice === 0 || changePayload.recalculatePrice === 1)
        ? changePayload.recalculatePrice
        : 1;

      const customIdentifiers = Array.isArray(changePayload.customIdentifiers)
        ? changePayload.customIdentifiers
        : [];

      if (currentPermitId && String(selectedPermitId) === currentPermitId && refreshStripeMetadata !== 1) {
        return;
      }

      const applicationId = (this.approved_permit_details || {})['application_id'];
      const requestPayload = {
        application_id: applicationId,
        new_permit_id: selectedPermitId,
        effective_at: effectiveAt,
        proration_behavior: (isRefresh || anyManual || effectiveAt === 'next_period' || avoidEarlyCharge === 1) ? 'none' : prorationBehavior,
        avoid_early_charge: avoidEarlyCharge,
        recalculate_subscription_dates: recalculateSubscriptionDates,
        recalculate_price: recalculatePrice,
      };

      if (allowRefreshStripeMetadata) {
        requestPayload.refresh_stripe_metadata = refreshStripeMetadata;
      }

      if (customIdentifiers.length > 0) {
        requestPayload.custom_identifiers = customIdentifiers;
      }

      const formatEffectiveOn = (value) => {
        if (value === null || value === undefined || value === '') {
          return '';
        }
        const asString = String(value);
        const isAllDigits = /^\d+$/.test(asString);
        if (isAllDigits) {
          const asNumber = parseInt(asString);
          const ms = (asNumber > 1e12) ? asNumber : (asNumber > 1e9 ? asNumber * 1000 : NaN);
          if (!isNaN(ms)) {
            try {
              return new Date(ms).toISOString();
            } catch (e) {
              return asString;
            }
          }
        }
        // ISO-ish strings pass through
        return asString;
      };

      const applySuccessfulUiUpdate = async (resData) => {
        this.$toasted.show(resData.message, {
          icon: 'check-circle',
          className: 'success-class'
        });

        const selectedPermit = (this.permit_list || []).find((permit) => String((permit || {}).permit_id) === String(selectedPermitId));

        this.approved_permit_details.permit_id = selectedPermitId;
        if (selectedPermit && selectedPermit.permit_name) {
          this.approved_permit_details.permit_name = selectedPermit.permit_name;
        }

        const paymentLink = resData && resData.data ? resData.data.payment_link : null;
        if (paymentLink) {
          await this.$swal({
            icon: 'info',
            title: 'Payment required',
            html: `A payment link was generated for this permit change:<br/><br/>
              <a href="${paymentLink}" target="_blank" rel="noopener noreferrer">Open payment link</a><br/><br/>
              <small>${paymentLink}</small>`,
            confirmButtonText: 'OK'
          });
        }

        const effectiveOn = resData && resData.data ? resData.data.effective_on : null;
        const apiEffectiveAt = resData && resData.data ? resData.data.effective_at : null;
        if ((effectiveAt === 'next_period' || apiEffectiveAt === 'next_period') && effectiveOn) {
          await this.$swal({
            icon: 'info',
            title: 'Scheduled',
            text: `This permit change is scheduled to take effect on: ${formatEffectiveOn(effectiveOn)}`,
            confirmButtonText: 'OK'
          });
        }
      };

      const submitChange = async ({ allowClearRetry }) => {
        try {
          const res = await this.axios.post(window.hostname + '/api/auth/permit/change-monthly-customer-permit', requestPayload);

          if (res && res.data && res.data.status) {
            await applySuccessfulUiUpdate(res.data);
            return;
          }

          const message = (res && res.data && res.data.message) ? res.data.message : 'Permit change failed.';
          this.$toasted.show(message, {
            icon: 'times-circle',
            className: 'error-class'
          });
        } catch (err) {
          const status = err && err.response ? err.response.status : null;
          const message = (err && err.response && err.response.data && err.response.data.message)
            ? err.response.data.message
            : 'There was an unexpected error...';

          if (status === 409 && allowClearRetry) {
            const decision = await this.$swal({
              icon: 'warning',
              title: 'Permit change already scheduled',
              text: message,
              showCancelButton: true,
              confirmButtonText: 'Clear scheduled change',
              cancelButtonText: 'Cancel'
            });

            if (decision && decision.isConfirmed) {
              try {
                const clearRes = await this.axios.post(window.hostname + '/api/auth/permit/clear-pending-permit-change', {
                  application_id: applicationId,
                });

                if (clearRes && clearRes.data && clearRes.data.status) {
                  this.$toasted.show(clearRes.data.message || 'Scheduled permit change cleared.', {
                    icon: 'check-circle',
                    className: 'success-class'
                  });
                  await submitChange({ allowClearRetry: false });
                  return;
                }

                const clearMessage = (clearRes && clearRes.data && clearRes.data.message)
                  ? clearRes.data.message
                  : 'Failed to clear scheduled permit change.';

                this.$toasted.show(clearMessage, {
                  icon: 'times-circle',
                  className: 'error-class'
                });
                return;
              } catch (clearErr) {
                const clearMessage = (clearErr && clearErr.response && clearErr.response.data && clearErr.response.data.message)
                  ? clearErr.response.data.message
                  : 'Failed to clear scheduled permit change.';

                this.$toasted.show(clearMessage, {
                  icon: 'times-circle',
                  className: 'error-class'
                });
                return;
              }
            }

            return;
          }

          this.$toasted.show(message, {
            icon: 'times-circle',
            className: 'error-class'
          });
        }
      };

      await submitChange({ allowClearRetry: true });
    },
    formatSubscriptionFailedReason(reason) {
      switch (reason) {
        case 'NO_CARD':
          return "No Card Found";
        case 'NO_VEHICLE':
          return "No Vehicle Found";
        case 'CARD_INVALID':
          return "Invalid Card";
        case 'SERVER_ERROR':
          return "";
        case 'STRIPE_CUSTOMER_CREATE_ERROR':
          return "Customer Create Failed";
        case 'CARD_ATTACH_FAIL':
          return "Card Attachment Failed";
        case 'PAYMENT_FAILED':
          return 'Payment Failed';
        case 'SUBSCRIPTION_ERROR':
          return 'Subscription Failed';
        case 'PAYMENTINTENT_FAILED':
          return 'Payment Failed';
        case 'PAYMENT_CONFIRMATION_FAILED':
          return 'Payment Failed';
        default:
          return '';
      }
    },
    checkVehicleCardStatus() {

      if (this.form.email == "") {
        this.$toasted.show("Email is required!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }

      if (this.approved_application_source) {
        this.approved_application_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.approved_application_source = CancelToken.source();

      this.axios.post(window.hostname + '/api/auth/user/check-vehicle-payment-status', {
        email: this.form.email
      }, {
        cancelToken: this.approved_application_source.token
      })
        .then(res => {
          if (res.data.status) {
            this.check_msg = res.data.message;
            if (res.data.vehicle_status == 1 && res.data.card_status == 1) {
              this.styleClassStatus = true;
            }
            else {
              this.styleClassStatus = false;
            }
            this.$toasted.show(res.data.message, {
              icon: 'check-circle',
              className: 'success-class'
            });
          }
          else {
            this.check_msg = res.data.message;
            this.styleClassStatus = false;
            this.$toasted.show(res.data.message, {
              icon: 'times-circle',
              className: 'error-class'
            });
          }
        })
        .catch(err => {
          if (this.axios.isCancel(err)) {
            return;
          }
          this.check_msg = '';
          this.styleClassStatus = false;
          console.log(err);
        })


    },
    refundSubscription(application_id){
      let message = "Do you want to refund for this subscription?";
      const self = this;
      this.$swal({
        title: "Are you sure?",
        text: message,
        showCancelButton: true,
      }).then((res)=>{
        if(res.value){
          self.axios
            .post(window.hostname + "/api/auth/permit/refund/subscription-amount", {
              subscription_id: application_id,
          }).then((result)=>{
            if(result.data.status){
              self.$toasted.show(result.data.message, {
                    icon: "check-circle",
                    className: "success-class",
              });
            }
            else{
              self.$toasted.show(result.data.message, {
                    icon: "times-circle",
                    className: "error-class",
              });
            }

          })
        }
      })
    }
  },
};
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.9) !important;
}

select option {
  background: #121212;
  border: none;
  margin: 40px;
}

.sessions_number_box_long {
  background-color: var(--primaryWhite);
  border-radius: 3px;
  padding: 6px 8px;
  cursor: pointer;
  /* width: 125px; */
  color: black;
  cursor: default;
}

.phone_class {
  border: 0.5px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 16px !important;
}

.approved__permits {
  max-height: 500px;
}

.approved__permits::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

.approved__permits::-webkit-scrollbar-thumb {
  background: #9fa0ab;
  border-radius: 7px;
}

.approved__permits::-webkit-scrollbar-thumb:hover {
  background: #b4afb5;
}

.approved__permits::-webkit-scrollbar-track {
  background: #ffffff;
  border-radius: 7px;
  box-shadow: inset 7px 5px 12px #424242;
}

/* Custom identifier dropdown styling */
.custom-vue-select {
  border-radius: 16px;
  border: 0.5px solid rgba(255, 255, 255, 0.25);
}

.custom-vue-select .form-control {
  background-color: transparent;
  border: none;
  color: white;
}

.custom-vue-select .form-control:focus {
  background-color: transparent;
  border: none;
  box-shadow: none;
  color: white;
}

.custom-vue-select .dropdown-menu {
  background-color: #2c2c2c;
  border: 1px solid rgba(255, 255, 255, 0.25);
}

.custom-vue-select .dropdown-item {
  color: white;
}

.custom-vue-select .dropdown-item:hover {
  background-color: #444444;
  color: white;
}

.backdate-toggle--locked {
  opacity: 0.45;
}

.backdate-toggle--locked .switch-label,
.backdate-toggle--locked .switch-label--txt {
  cursor: not-allowed;
}

.required-identifier-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(255, 193, 7, 0.18);
  border: 1px solid rgba(255, 193, 7, 0.35);
  color: #ffd86b;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.textInputField--locked {
  opacity: 0.7;
  cursor: not-allowed;
}

.permit-vehicle-identifier {
  max-width: 100%;
  margin-bottom: 0;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
  line-height: 1.1;
}

.permit-vehicle-identifier--sm {
  font-size: 11px;
}

.permit-vehicle-identifier--xs {
  font-size: 10px;
}

.allowed-vehicles-edit-btn {
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff !important;
  text-decoration: none !important;
  line-height: 1;
  transition: background-color 0.15s ease, opacity 0.15s ease;
}

.allowed-vehicles-edit-btn i {
  font-size: 12px;
}

.allowed-vehicles-edit-btn:hover {
  color: #ffffff !important;
  background: rgba(255, 255, 255, 0.08);
  opacity: 0.8;
}

.permit-vehicle-identifier--wrap {
  font-size: 9px;
  white-space: normal;
  word-break: break-word;
}

.offstreet-summary-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.offstreet-summary-pill {
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  background: rgba(255, 255, 255, 0.04);
}

.offstreet-summary-pill.summary-good {
  color: #2cbf7f;
  border-color: rgba(44, 191, 127, 0.4);
}

.offstreet-summary-pill.summary-danger {
  color: #ff6b6b;
  border-color: rgba(255, 107, 107, 0.45);
}

.offstreet-summary-pill.summary-subdued {
  color: #9aa2a9;
  border-color: rgba(154, 162, 169, 0.4);
}

.offstreet-summary-pill.summary-warn {
  color: #f5d97d;
  border-color: rgba(245, 217, 125, 0.45);
}

.offstreet-summary-pill.summary-neutral {
  color: #73c2fb;
  border-color: rgba(115, 194, 251, 0.45);
}

.offstreet-status-chip {
  display: inline-block;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-transform: lowercase;
}

.status-success {
  color: #2cbf7f;
  border-color: rgba(44, 191, 127, 0.4);
}

.status-danger {
  color: #ff6b6b;
  border-color: rgba(255, 107, 107, 0.45);
}

.status-neutral {
  color: #f5d97d;
  border-color: rgba(245, 217, 125, 0.45);
}

.status-subdued {
  color: #9aa2a9;
  border-color: rgba(154, 162, 169, 0.4);
}

.offstreet-error-text {
  white-space: normal;
  word-break: break-word;
}
</style>
